(function () {
function $2892d4b3a4bd7b1c$export$5d0cc2edc113f064() {
    let requestVerificationToken = $("body").data("antiforgery-token");
    $.ajaxSetup({
        cache: false,
        headers: {
            "RequestVerificationToken": requestVerificationToken
        }
    });
}
function $2892d4b3a4bd7b1c$export$80f0146779479e00() {
    $(document).ajaxStart(function() {
        $("#loading").show();
    });
    $(document).ajaxStop(function() {
        $("#loading").hide();
    });
}


function $6ba8f3756a604e1e$var$fixAdOnScroll() {
    let width = $(document).width();
    let isTablet = width <= 976 && width > 768;
    let isMobile = width <= 768;
    if (isTablet || isMobile) {
        let $leaderboard = $(".leaderboard-container");
        if ($(window).scrollTop() > 100) {
            if (!$leaderboard.hasClass("ad-scroll-fix")) $leaderboard.addClass("ad-scroll-fix");
        } else $leaderboard.removeClass("ad-scroll-fix");
    }
}
function $6ba8f3756a604e1e$export$a391e9e11dfa825a() {
    //$(document).on('load', fixAdOnScroll);
    //$(document).on('resize', fixAdOnScroll);
    $(document).on("scroll", $6ba8f3756a604e1e$var$fixAdOnScroll);
}


function $02ccdfd5868f53aa$var$setHeroAds() {
    if (window.desktop != null) {
        let $body = $("body");
        let width = $(document).width();
        let heroContainer = $(".hero-takeover-container");
        $body.addClass("hero-takeover-active");
        const isTablet = width <= 976 && width > 767;
        const isMobile = width <= 767;
        if (isTablet) heroContainer.html($02ccdfd5868f53aa$var$getHtml(window.tablet, window.clickTag));
        else if (isMobile) {
            heroContainer.html($02ccdfd5868f53aa$var$getHtml(window.mobile, window.clickTag));
            $(".site-content-top").css("height", "400px");
        } else {
            heroContainer.html($02ccdfd5868f53aa$var$getHtml(window.desktop, window.clickTag));
            $(".site-content-top").css("height", "500px");
        }
    }
}
function $02ccdfd5868f53aa$var$getHtml(file, link) {
    return $("<a href='" + link + "' target='_blank'>" + '<div class="overlay-ad advert" style="background:url(\'' + file + "') center top no-repeat;\">" + "</div>" + "</a>");
}
function $02ccdfd5868f53aa$export$b2bb814f390b8ca1() {
    $(window).resize(function() {
        $02ccdfd5868f53aa$var$setHeroAds();
    });
    window.setHeroTakeover = function(desktop, tablet, mobile, clickTag) {
        window.desktop = desktop;
        window.tablet = tablet;
        window.mobile = mobile;
        window.clickTag = clickTag;
        $(window).resize();
    };
}


let $c26879fdf7f36150$var$data;
function $c26879fdf7f36150$var$markAsLoading() {
    $("#car-launch-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $c26879fdf7f36150$var$reloadQuery() {
    const State = History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/car-launch/running-costs/query", State.data, function(response) {
        $("#car-launch-query-container").replaceWith(response);
    });
}
function $c26879fdf7f36150$var$setOperatingCycle() {
    $.get("/cap-operating-cycles/miles/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Miles").val(response);
    });
    $.get("/cap-operating-cycles/years/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Years").val(response);
    });
}
function $c26879fdf7f36150$var$buildUpQueryString(data) {
    let queryString = "";
    const operatingCycleDefault = $("#OperatingCycleId option").eq(0).val();
    if (data.OperatingCycleId != operatingCycleDefault) {
        if (queryString.length > 0) queryString += "&";
        queryString += "Years=" + data.Years + "&Miles=" + data.Miles + "&ModelGroupId=" + data.ModelGroupId + "&DerivativeId=" + data.DerivativeId;
    }
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.imageId) > 0) queryString += "image=" + data.imageId;
    else queryString += "image=";
    if (data.ModelYear !== "") queryString += "&ModelYear=" + data.ModelYear;
    return "?" + queryString;
}
function $c26879fdf7f36150$var$getData(page) {
    const operatingCycleId = $("#OperatingCycleId").val();
    const miles = $("#Miles").val();
    const years = $("#Years").val();
    const modelGroupId = $("#ModelGroupId").val();
    const imageId = $("#Image").val();
    const derivativeId = $("#DerivativeId").val();
    const modelYear = $("#ModelYear").val();
    return {
        OperatingCycleId: operatingCycleId,
        Miles: miles,
        Years: years,
        DerivativeId: derivativeId,
        imageId: imageId,
        ModelGroupId: modelGroupId,
        ModelYear: modelYear
    };
}
function $c26879fdf7f36150$var$updateRunningCostsLogic(page) {
    const data = $c26879fdf7f36150$var$getData(page);
    History.pushState(data, $("title").html(), location.pathname + $c26879fdf7f36150$var$buildUpQueryString(data));
}
function $c26879fdf7f36150$var$onImageSliderChange(event) {
    const image = $(event.target.currSlide.content).data("image-id");
    console.log(image);
    $("#Image").val(image);
    window.updateRunningCosts();
}
function $c26879fdf7f36150$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown == "OperatingCycleId") {
        const derivativeId = $("#DerivativeId").val();
        if (parseInt(derivativeId) > 0) {
            const id = $(this).val();
            $.get("/cap-operating-cycles/miles/" + id, function(response) {
                $("#Miles").val(response);
                $.get("/cap-operating-cycles/years/" + id, function(response) {
                    $("#Years").val(response);
                    window.updateRunningCosts();
                });
            });
        } else alert("please select a derivative first");
    } else if (currentDropdown == "DerivativeId") {
        $("#DerivativeId").val($(this).val());
        window.updateRunningCosts();
    }
}
function $c26879fdf7f36150$export$a6a4a29a790aae85() {
    if ($("[data-car-launch-running-costs]").length) {
        window.updateRunningCosts = function() {
            $c26879fdf7f36150$var$updateRunningCostsLogic(1);
        };
        window.loadCarLaunchGallery = function() {
            const sliders = $("[data-car-launch-slider-gallery]");
            if (sliders.length == 0) return;
            sliders.each(function(index, element) {
                const $element = $(element);
                if ($element.data("royalSlider") != null) return;
                const slider = $element.royalSlider({
                    arrowsNavAutoHide: false,
                    imageScaleMode: "fit-if-smaller",
                    imageScalePadding: 0,
                    autoScaleSlider: true,
                    autoScaleSliderWidth: 750,
                    autoScaleSliderHeight: 563,
                    globalCaption: true,
                    controlNavigationSpacing: 0,
                    controlNavigation: "none",
                    loop: true,
                    numImagesToPreload: 1,
                    keyboardNavEnabled: true,
                    usePreloader: false,
                    slidesSpacing: 0,
                    minSlideOffset: 0,
                    thumbs: {
                        arrowsAutoHide: true,
                        spacing: 0
                    }
                });
                const sliderData = slider.data("royalSlider");
                $c26879fdf7f36150$var$data = sliders.data("car-launch-slider-query-string");
                if ($c26879fdf7f36150$var$data.image) for(let i = 0; i < sliderData.slides.length; i++){
                    const slide = sliderData.slides[i];
                    if (slide.content.data("image-id") == $c26879fdf7f36150$var$data.image) {
                        // as per http://help.dimsemenov.com/discussions/problems/1373-gotosilent-version-93
                        sliderData.st.transitionSpeed = 0;
                        sliderData.goTo(slide.id);
                        setTimeout(function() {
                            sliderData.st.transitionSpeed = 600;
                        }, 10);
                    }
                }
                sliderData.ev.on("rsAfterSlideChange", $c26879fdf7f36150$var$onImageSliderChange);
                window.gallerySliderData = sliderData;
                const siblings = $element.siblings("[data-slider-caption-container]");
                const caption = $element.find(".rsGCaption");
                caption.appendTo(siblings);
            });
            $(".rsNav.rsThumbs.rsThumbsHor").attr("style", "height:auto");
        };
        window.loadCarLaunchGallery();
        $c26879fdf7f36150$var$setOperatingCycle();
        $(document).on("change", "[data-car-launch-running-costs] select", $c26879fdf7f36150$var$onChangeFilters);
    //History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate#
    //    markAsLoading();
    //    reloadQuery();
    //    const State = History.getState();
    //    setTimeout(
    //        function () {
    //            $.get('/car-launch/running-costs/results', State.data, function (response) {
    //                $('#car-launch-results-container').replaceWith(response);
    //            });
    //        }, 500);
    //});
    }
}


function $0931948934220f52$var$onChangeFilters(event) {
    var currentDropdown = $(this).attr("name");
    if (currentDropdown == "ManufacturerId") $.get("/cap-manufacturer-url/" + $(this).val(), function(response) {
        $("#ManufacturerName").val(response);
        window.updateResults();
    });
}
function $0931948934220f52$var$getData() {
    var manufacturerId = $("#ManufacturerId").val();
    var manufacturerName = $("#ManufacturerName").val();
    return {
        ManufacturerId: manufacturerId,
        ManufacturerName: manufacturerName
    };
}
function $0931948934220f52$var$buildUpQueryString(data) {
    return "?Manufacturer=" + data.ManufacturerName;
}
function $0931948934220f52$var$updateResultsLogic() {
    var data = $0931948934220f52$var$getData();
    History.pushState(data, $("title").html(), location.pathname + $0931948934220f52$var$buildUpQueryString(data));
}
function $0931948934220f52$var$reloadQuery() {
    var State = History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/car-launch-calendar/query", State.data, function(response) {
        $("#car-launch-calendar-query-container").replaceWith(response);
    });
}
function $0931948934220f52$var$markAsLoading() {
    $("#car-launches-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $0931948934220f52$export$30c8b39afd1a4d2b() {
    //dropdown changes
    $(document).on("change", "[data-car-launch-calendar] select", $0931948934220f52$var$onChangeFilters);
    if ($("[data-car-launch-calendar]").length) window.updateResults = function() {
        $0931948934220f52$var$updateResultsLogic();
    };
} //(function ($) {
 //    function getForm() {
 //        return $("[data-car-launch-calendar-form]");
 //    }
 //    function submitForm() {
 //        var form = getForm();
 //        form.submit();
 //    }
 //    $(function () {
 //        $(document).on("change", "#Year", submitForm);
 //    });
 //})(jQuery);


function $c0e2aeb39b8be769$export$d0990ca26e3a22f3() {
    $(document).on("change", "form[data-car-review-search] select", function(e) {
        $c0e2aeb39b8be769$var$markAsLoading();
        $c0e2aeb39b8be769$var$submitForm(e);
    });
}
function $c0e2aeb39b8be769$var$markAsLoading() {
    let container = $("#car-reviews-search-loading-container");
    container.height(50); // set the height to stop moving on large desktop
    container.text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $c0e2aeb39b8be769$var$submitForm(event) {
    event.preventDefault();
    $(event.target).parents("form").submit();
}


var $06aa7a5ca72b8734$var$data;
function $06aa7a5ca72b8734$var$updateUrl(event) {
    var history = window.History;
    var stateData = $.extend({}, $06aa7a5ca72b8734$var$data);
    stateData.image = $(event.target.currSlide.content).data("image-id");
    history.pushState(stateData, $("title").html(), location.pathname + "?" + $.param(stateData));
    var movePosition = 0;
    var nextArticle = event.target.slider.parents("[data-more-article]");
    if (nextArticle.text() == "") {
        movePosition = event.target.slider.parents(".main-content-wrapper").find("#gallery-container").offset().top;
        if (movePosition > 237) movePosition = 237;
    } else movePosition = nextArticle.find(".main-content-wrapper").find("#gallery-container").offset().top;
    $("html, body").animate({
        scrollTop: movePosition
    }, "slow");
}
function $06aa7a5ca72b8734$var$loadGallery() {
    var sliders = $("[data-car-launch-slider-gallery]");
    if (sliders.length == 0) return;
    sliders.each(function(index, element) {
        var $element = $(element);
        if ($element.data("royalSlider") != null) return;
        var slider = $element.royalSlider({
            arrowsNavAutoHide: false,
            imageScaleMode: "fit-if-smaller",
            imageScalePadding: 0,
            autoScaleSlider: true,
            autoScaleSliderWidth: 750,
            autoScaleSliderHeight: 563,
            globalCaption: true,
            controlNavigationSpacing: 0,
            controlNavigation: "none",
            loop: true,
            numImagesToPreload: 1,
            keyboardNavEnabled: true,
            usePreloader: false,
            slidesSpacing: 0,
            minSlideOffset: 0,
            thumbs: {
                arrowsAutoHide: true,
                spacing: 0
            }
        });
        var sliderData = slider.data("royalSlider");
        $06aa7a5ca72b8734$var$data = sliders.data("car-launch-slider-query-string");
        if ($06aa7a5ca72b8734$var$data.image) for(var i = 0; i < sliderData.slides.length; i++){
            var slide = sliderData.slides[i];
            if (slide.content.data("image-id") == $06aa7a5ca72b8734$var$data.image) {
                // as per http://help.dimsemenov.com/discussions/problems/1373-gotosilent-version-93
                sliderData.st.transitionSpeed = 0;
                sliderData.goTo(slide.id);
                setTimeout(function() {
                    sliderData.st.transitionSpeed = 600;
                }, 10);
            }
        }
        sliderData.ev.on("rsAfterSlideChange", $06aa7a5ca72b8734$var$updateUrl);
        window.gallerySliderData = sliderData;
        var siblings = $element.siblings("[data-slider-caption-container]");
        var caption = $element.find(".rsGCaption");
        caption.appendTo(siblings);
    });
    $(".rsNav.rsThumbs.rsThumbsHor").attr("style", "height:auto");
}
function $06aa7a5ca72b8734$export$4480b153ba60206d() {
    if ($("[data-car-launch-gallery]").length) {
        window.loadGallery = $06aa7a5ca72b8734$var$loadGallery;
        $06aa7a5ca72b8734$var$loadGallery();
    }
}


function $593cd257706de00c$var$submitForm(event) {
    event.preventDefault();
    $(event.target).parents("form").submit();
}
function $593cd257706de00c$export$53c248b281253aba() {}


function $728b06aeb66604b2$var$changeManufacturer() {
    var manufacturerName = $("#ManufacturerId").val();
    $.get("/cars/landing-page/query?ManufacturerName=" + manufacturerName, function(response) {
        $("[data-car-landing-page-query]").replaceWith(response);
    });
//window.location = $("#ManufacturerId").val();
}
function $728b06aeb66604b2$var$changeModel() {
    var modelName = $("#ModelId").val();
    $("#ModelName").val(modelName);
}
function $728b06aeb66604b2$export$a09f327970c84284() {
    if ($("[data-cars-landing-page]").length) {
        $(document).on("change", "#ManufacturerId", $728b06aeb66604b2$var$changeManufacturer);
        $(document).on("change", "#ModelId", $728b06aeb66604b2$var$changeModel);
        $("#ManufacturerId").trigger("change");
    }
}


function $aca60e5b2e026969$var$getForm() {
    return $("[data-car-stats-form]");
}
function $aca60e5b2e026969$var$submitForm() {
    const form = $aca60e5b2e026969$var$getForm();
    form.submit();
}
function $aca60e5b2e026969$var$addToCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("compare-list-add-id");
    $aca60e5b2e026969$var$addVehicle(data);
}
function $aca60e5b2e026969$var$addVehicle(id) {
    $.get("/compare-list/handle/add/" + id, function(response) {
        if (response == 0) {
            const form = $aca60e5b2e026969$var$getForm();
            form.submit();
        } else if (response == 1) alert("Maximum of 5 vehicles.");
        else if (response == 2) alert("Already added to the compare list. Please select another vehicle.");
        else alert("Error");
    });
}
function $aca60e5b2e026969$var$removeFromCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("compare-list-remove-id");
    $aca60e5b2e026969$var$removeVehicle(data);
}
function $aca60e5b2e026969$var$removeVehicle(id) {
    $.get("/compare-list/handle/remove/" + id, function(response) {
        const form = $aca60e5b2e026969$var$getForm();
        form.submit();
    });
}
function $aca60e5b2e026969$export$ce72890db155540c() {
    if ($("[data-car-stats-page]").length) {
        $(document).on("change", "#OperatingCycleId", $aca60e5b2e026969$var$submitForm);
        $(document).on("click", "[data-compare-list-add-id]", $aca60e5b2e026969$var$addToCompareList);
        $(document).on("click", "[data-compare-list-remove-id]", $aca60e5b2e026969$var$removeFromCompareList);
    }
}


function $94302a5ffb81bfa2$var$getForm() {
    return $("[data-air-index-vehicle-form]");
}
function $94302a5ffb81bfa2$var$submitForm() {
    const form = $94302a5ffb81bfa2$var$getForm();
    form.submit();
}
function $94302a5ffb81bfa2$var$addToCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("compare-list-add-id");
    $94302a5ffb81bfa2$var$addVehicle(data);
}
function $94302a5ffb81bfa2$var$addVehicle(id) {
    $.get("/emissions-data/compare-list/handle/add/" + id, function(response) {
        if (response == 0) {
            const form = $94302a5ffb81bfa2$var$getForm();
            form.submit();
        } else if (response == 1) alert("Maximum of 5 vehicles.");
        else if (response == 2) alert("Already added to the compare list. Please select another vehicle.");
        else alert("Error");
    });
}
function $94302a5ffb81bfa2$var$removeFromCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("compare-list-remove-id");
    $94302a5ffb81bfa2$var$removeVehicle(data);
}
function $94302a5ffb81bfa2$var$removeVehicle(id) {
    $.get("/emissions-data/compare-list/handle/remove/" + id, function(response) {
        const form = $94302a5ffb81bfa2$var$getForm();
        form.submit();
    });
}
function $94302a5ffb81bfa2$export$a364db890d354a0c() {
    if ($("[data-air-index-vehicle-page]").length) {
        $(document).on("click", "[data-compare-list-add-id]", $94302a5ffb81bfa2$var$addToCompareList);
        $(document).on("click", "[data-compare-list-remove-id]", $94302a5ffb81bfa2$var$removeFromCompareList);
    }
}


function $d700ac7e948a3f2e$export$d9879cc485083cbe() {
    const commentingBox = `commentingBox${$("[data-main-content]").data("main-content")}`;
    window.commentBox = function() {
        if (window.isViewportGreaterThanOrEqualTo("lg")) $(".comment-box .panel-collapse.collapse").removeClass();
        else {
            const commentingClass = $(`#${commentingBox}`).attr("class");
            if (commentingClass == "") $(`#${commentingBox}`).addClass("panel-collapse collapse");
            else if (commentingClass == "collapse in") $(`#${commentingBox}`).removeClass().addClass("panel-collapse collapse");
        }
    };
    window.commentBoxDesktop = function() {
        if (window.isViewportGreaterThanOrEqualTo("lg")) {
            const commentingClass = $(`#${commentingBox}`).attr("class");
            if (commentingClass == "") $(`#${commentingBox}`).removeClass().addClass("collapse in");
            else if (commentingClass == "collapse in") $(`#${commentingBox}`).removeClass().addClass("collapse");
            else if (commentingClass == "collapse") $(`#${commentingBox}`).removeClass().addClass("collapse in");
        }
    };
    window.commentBox();
    $(window).resize(function() {
        window.commentBox();
    });
    $(document).on("click", ".comment-box .panel-heading a", window.commentBoxDesktop);
}


const $fee793ddf9b673e0$var$History = window.History; // Note: We are using a capital H instead of a lower h
let $fee793ddf9b673e0$var$compareListSortBy;
let $fee793ddf9b673e0$var$compareListSortDesc;
function $fee793ddf9b673e0$var$getData() {
    const sortBy = $fee793ddf9b673e0$var$compareListSortBy;
    const sortDesc = $fee793ddf9b673e0$var$compareListSortDesc;
    return {
        SortBy: sortBy,
        SortDesc: sortDesc
    };
}
function $fee793ddf9b673e0$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;
    return "?" + queryString;
}
function $fee793ddf9b673e0$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("compare-list-sort");
    if ($fee793ddf9b673e0$var$compareListSortBy !== newSortBy) $fee793ddf9b673e0$var$compareListSortDesc = "false";
    else $fee793ddf9b673e0$var$compareListSortDesc = "true";
    $fee793ddf9b673e0$var$compareListSortBy = newSortBy;
    const data = $fee793ddf9b673e0$var$getData();
    $fee793ddf9b673e0$var$History.pushState(data, $("title").html(), location.pathname + $fee793ddf9b673e0$var$buildUpQueryString(data));
}
function $fee793ddf9b673e0$export$c95db721723386e7() {
    if (!$("[data-compare-list]").length) return;
    $fee793ddf9b673e0$var$compareListSortBy = $("#SortBy").val();
    $fee793ddf9b673e0$var$compareListSortDesc = $("#SortDesc").val();
    $(document).on("click", "[data-compare-list-sort]", $fee793ddf9b673e0$var$sortResults);
    $(`[data-compare-list-sort=${$fee793ddf9b673e0$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
    if ($fee793ddf9b673e0$var$compareListSortDesc.toLowerCase() === "true") $("[data-compare-list-sort=" + $fee793ddf9b673e0$var$compareListSortBy + "]").attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
    $(document).on("click", "[data-remove-from-list]", function(event) {
        const id = $(this).attr("data-remove-from-list");
        $.get("/compare-list/handle/remove/" + id, function(response) {});
    });
//History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate#
//    const State = History.getState();
//    $.get('/compare-list/results/' + $('#RunningCostIds').val(), State.data, function (response) {
//        $('#compare-list-results-container').replaceWith(response);
//        $(`[data-compare-list-sort=${compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
//        if (compareListSortDesc.toLowerCase() === "true") {
//            $("[data-compare-list-sort=" + compareListSortBy + "]").attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
//        }
//    });
//});
}


const $a14a535463e27110$var$History = window.History; // Note: We are using a capital H instead of a lower h
let $a14a535463e27110$var$compareListSortBy;
let $a14a535463e27110$var$compareListSortDesc;
function $a14a535463e27110$var$getData() {
    const sortBy = $a14a535463e27110$var$compareListSortBy;
    const sortDesc = $a14a535463e27110$var$compareListSortDesc;
    return {
        SortBy: sortBy,
        SortDesc: sortDesc
    };
}
function $a14a535463e27110$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;
    return "?" + queryString;
}
function $a14a535463e27110$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("air-index-compare-list-sort");
    if ($a14a535463e27110$var$compareListSortBy !== newSortBy) $a14a535463e27110$var$compareListSortDesc = "false";
    else $a14a535463e27110$var$compareListSortDesc = "true";
    $a14a535463e27110$var$compareListSortBy = newSortBy;
    const data = $a14a535463e27110$var$getData();
    $a14a535463e27110$var$History.pushState(data, $("title").html(), location.pathname + $a14a535463e27110$var$buildUpQueryString(data));
}
function $a14a535463e27110$export$2d8fba0164856121() {
    if (!$("[data-air-index-compare-list]").length) return;
    $a14a535463e27110$var$compareListSortBy = $("#SortBy").val();
    $a14a535463e27110$var$compareListSortDesc = $("#SortDesc").val();
    $(document).on("click", "[data-air-index-compare-list-sort]", $a14a535463e27110$var$sortResults);
    $(`[data-air-index-compare-list-sort=${$a14a535463e27110$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
    if ($a14a535463e27110$var$compareListSortDesc.toLowerCase() === "true") $("[data-air-index-compare-list-sort=" + $a14a535463e27110$var$compareListSortBy + "]").attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
    $(document).on("click", "[data-air-index-remove-from-list]", function(event) {
        const id = $(this).attr("data-air-index-remove-from-list");
        $.get("/emissions-data/compare-list/handle/remove/" + id, function(response) {});
    });
    $a14a535463e27110$var$History.Adapter.bind(window, "statechange", function() {
        const State = $a14a535463e27110$var$History.getState();
        $.get("/emissions-data/compare-list/results/" + $("#AirIndexVehicleIds").val(), State.data, function(response) {
            $("#compare-list-results-container").replaceWith(response);
            $(`[data-air-index-compare-list-sort=${$a14a535463e27110$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
            if ($a14a535463e27110$var$compareListSortDesc.toLowerCase() === "true") $("[data-compare-list-sort=" + $a14a535463e27110$var$compareListSortBy + "]").attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
        });
    });
}


/*!
 * The Final Countdown for jQuery v2.2.0 (http://hilios.github.io/jQuery.countdown/)
 * Copyright (c) 2016 Edson Hilios
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ (function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) define([
        "jquery"
    ], factory);
    else factory(jQuery);
})(function($) {
    "use strict";
    var instances = [], matchers = [], defaultOptions = {
        precision: 100,
        elapse: false,
        defer: false
    };
    matchers.push(/^[0-9]*$/.source);
    matchers.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
    matchers.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
    matchers = new RegExp(matchers.join("|"));
    function parseDateString(dateString) {
        if (dateString instanceof Date) return dateString;
        if (String(dateString).match(matchers)) {
            if (String(dateString).match(/^[0-9]*$/)) dateString = Number(dateString);
            if (String(dateString).match(/\-/)) dateString = String(dateString).replace(/\-/g, "/");
            return new Date(dateString);
        } else throw new Error("Couldn't cast `" + dateString + "` to a date object.");
    }
    var DIRECTIVE_KEY_MAP = {
        Y: "years",
        m: "months",
        n: "daysToMonth",
        d: "daysToWeek",
        w: "weeks",
        W: "weeksToMonth",
        H: "hours",
        M: "minutes",
        S: "seconds",
        D: "totalDays",
        I: "totalHours",
        N: "totalMinutes",
        T: "totalSeconds"
    };
    function escapedRegExp(str) {
        var sanitize = str.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        return new RegExp(sanitize);
    }
    function strftime(offsetObject) {
        return function(format) {
            var directives = format.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
            if (directives) for(var i = 0, len = directives.length; i < len; ++i){
                var directive = directives[i].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/), regexp = escapedRegExp(directive[0]), modifier = directive[1] || "", plural = directive[3] || "", value = null;
                directive = directive[2];
                if (DIRECTIVE_KEY_MAP.hasOwnProperty(directive)) {
                    value = DIRECTIVE_KEY_MAP[directive];
                    value = Number(offsetObject[value]);
                }
                if (value !== null) {
                    if (modifier === "!") value = pluralize(plural, value);
                    if (modifier === "") {
                        if (value < 10) value = "0" + value.toString();
                    }
                    format = format.replace(regexp, value.toString());
                }
            }
            format = format.replace(/%%/, "%");
            return format;
        };
    }
    function pluralize(format, count) {
        var plural = "s", singular = "";
        if (format) {
            format = format.replace(/(:|;|\s)/gi, "").split(/\,/);
            if (format.length === 1) plural = format[0];
            else {
                singular = format[0];
                plural = format[1];
            }
        }
        if (Math.abs(count) > 1) return plural;
        else return singular;
    }
    var Countdown = function(el, finalDate, options) {
        this.el = el;
        this.$el = $(el);
        this.interval = null;
        this.offset = {};
        this.options = $.extend({}, defaultOptions);
        this.instanceNumber = instances.length;
        instances.push(this);
        this.$el.data("countdown-instance", this.instanceNumber);
        if (options) {
            if (typeof options === "function") {
                this.$el.on("update.countdown", options);
                this.$el.on("stoped.countdown", options);
                this.$el.on("finish.countdown", options);
            } else this.options = $.extend({}, defaultOptions, options);
        }
        this.setFinalDate(finalDate);
        if (this.options.defer === false) this.start();
    };
    $.extend(Countdown.prototype, {
        start: function() {
            if (this.interval !== null) clearInterval(this.interval);
            var self = this;
            this.update();
            this.interval = setInterval(function() {
                self.update.call(self);
            }, this.options.precision);
        },
        stop: function() {
            clearInterval(this.interval);
            this.interval = null;
            this.dispatchEvent("stoped");
        },
        toggle: function() {
            if (this.interval) this.stop();
            else this.start();
        },
        pause: function() {
            this.stop();
        },
        resume: function() {
            this.start();
        },
        remove: function() {
            this.stop.call(this);
            instances[this.instanceNumber] = null;
            delete this.$el.data().countdownInstance;
        },
        setFinalDate: function(value) {
            this.finalDate = parseDateString(value);
        },
        update: function() {
            if (this.$el.closest("html").length === 0) {
                this.remove();
                return;
            }
            var hasEventsAttached = $._data(this.el, "events") !== undefined, now = new Date(), newTotalSecsLeft;
            newTotalSecsLeft = this.finalDate.getTime() - now.getTime();
            newTotalSecsLeft = Math.ceil(newTotalSecsLeft / 1e3);
            newTotalSecsLeft = !this.options.elapse && newTotalSecsLeft < 0 ? 0 : Math.abs(newTotalSecsLeft);
            if (this.totalSecsLeft === newTotalSecsLeft || !hasEventsAttached) return;
            else this.totalSecsLeft = newTotalSecsLeft;
            this.elapsed = now >= this.finalDate;
            this.offset = {
                seconds: this.totalSecsLeft % 60,
                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 % 30.4368),
                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                weeksToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                years: Math.abs(this.finalDate.getFullYear() - now.getFullYear()),
                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                totalMinutes: Math.floor(this.totalSecsLeft / 60),
                totalSeconds: this.totalSecsLeft
            };
            if (!this.options.elapse && this.totalSecsLeft === 0) {
                this.stop();
                this.dispatchEvent("finish");
            } else this.dispatchEvent("update");
        },
        dispatchEvent: function(eventName) {
            var event = $.Event(eventName + ".countdown");
            event.finalDate = this.finalDate;
            event.elapsed = this.elapsed;
            event.offset = $.extend({}, this.offset);
            event.strftime = strftime(this.offset);
            this.$el.trigger(event);
        }
    });
    $.fn.countdown = function() {
        var argumentsArray = Array.prototype.slice.call(arguments, 0);
        return this.each(function() {
            var instanceNumber = $(this).data("countdown-instance");
            if (instanceNumber !== undefined) {
                var instance = instances[instanceNumber], method = argumentsArray[0];
                if (Countdown.prototype.hasOwnProperty(method)) instance[method].apply(instance, argumentsArray.slice(1));
                else if (String(method).match(/^[$A-Z_][0-9A-Z_$]*$/i) === null) {
                    instance.setFinalDate.call(instance, method);
                    instance.start();
                } else $.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, method));
            } else new Countdown(this, argumentsArray[0], argumentsArray[1]);
        });
    };
});


function $7ef9cb8dc2b7724c$var$createCountdown(item) {
    item.countdown(item.data("countdown-date"), function(event) {
        item.find("[data-countdown-days]").text(event.strftime("%D"));
        item.find("[data-countdown-hours]").text(event.strftime("%H"));
        item.find("[data-countdown-minutes]").text(event.strftime("%M"));
        item.find("[data-countdown-seconds]").text(event.strftime("%S"));
    });
}
function $7ef9cb8dc2b7724c$export$55fbd5f0890cdf7e() {
    $("[data-countdown-date]").each(function() {
        $7ef9cb8dc2b7724c$var$createCountdown($(this));
    });
}


const $165cb073955e137a$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $165cb073955e137a$var$getActivePrices() {
    const greenButtons = $("[data-price] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
function $165cb073955e137a$var$updatePrices(event) {
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateResults();
}
function $165cb073955e137a$var$validateCustomForm() {
    $("#deal-contact-box").validate({
        rules: {
            Email: {
                required: true,
                email: true
            }
        }
    });
}
function $165cb073955e137a$var$submitContactForm(e) {
    const form = $(e.target);
    if (!form.valid()) return;
    e.preventDefault();
    $.post(form.attr("action"), form.serialize(), function(response) {
        $("[id^=deal-thankyou]").empty();
        const dealId = $("#Deal_Id").val();
        const message = $("[data-thankyou-message]").data("thankyou-message");
        $("#deal-thankyou-" + dealId).empty().append("<div class='alert alert-success'>" + message + "</div>");
        const currentfeatherlight = $.featherlight.current();
        if (currentfeatherlight) currentfeatherlight.close();
    });
}
function $165cb073955e137a$var$getData(page) {
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const sortBy = $("#SortBy").val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const mileagePerAnnum = $("#MileagePerAnnum").val();
    const priceFilter = $165cb073955e137a$var$getActivePrices();
    return {
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        ManufacturerName: manufacturerName,
        ModelName: modelName,
        MileagePerAnnum: mileagePerAnnum,
        PriceFilter: priceFilter,
        SortBy: sortBy,
        Page: page
    };
}
function $165cb073955e137a$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.ManufacturerName;
    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.ModelName;
    if (queryString.length > 0) queryString += "&";
    queryString += "MileagePerAnnum=" + data.MileagePerAnnum;
    if (queryString.length > 0) queryString += "&";
    queryString += "PriceFilter=" + data.PriceFilter;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "Page=" + data.Page;
    }
    return "?" + queryString;
}
function $165cb073955e137a$var$updateResultsLogic(page) {
    const data = $165cb073955e137a$var$getData(page);
    $165cb073955e137a$var$History.pushState(data, $("title").html(), location.pathname + $165cb073955e137a$var$buildUpQueryString(data));
}
function $165cb073955e137a$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] === "p";
    })[0].split("=")[1];
}
function $165cb073955e137a$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get("/manufacturer-url/" + manId, function(response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Manufacturer";
            })[0].split("=")[1];
            $("#ManufacturerName").val(manufacturer);
        }
    }
}
function $165cb073955e137a$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get("/model-url/" + manufacturerId + "/" + modelId, function(response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Model";
            })[0].split("=")[1];
            $("#ModelName").val(model);
        }
    }
}
function $165cb073955e137a$var$reloadQuery() {
    const State = $165cb073955e137a$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/deals/query", State.data, function(response) {
        $("#deals-page-query-container").replaceWith(response);
    });
}
function $165cb073955e137a$var$markAsLoading() {
    $("#deals-page-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $165cb073955e137a$var$pageData(event) {
    $("html, body").animate({
        scrollTop: 0
    }, 400);
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $165cb073955e137a$var$getPage($(this).attr("href"));
    $165cb073955e137a$var$updateResultsLogic(page);
}
function $165cb073955e137a$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#ModelName").val("");
        $.get("/manufacturer-url/" + $(this).val(), function(response) {
            $("#ManufacturerName").val(response);
            window.updateResults();
        });
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            const manufacturerId = $("#ManufacturerId").val();
            $.get(`/manufacturer-url/${manufacturerId}`, function(response) {
                $("#ManufacturerName").val(response);
            });
            $.get(`/model-url/${manufacturerId}/${$(this).val()}`, function(response) {
                $("#ModelName").val(response);
                window.updateResults();
            });
        } else {
            $("#ModelName").val("");
            window.updateResults();
        }
    } else window.updateResults();
}
function $165cb073955e137a$export$94d83d887297dd2() {
    if ($("[data-deals-page]").length) {
        window.updateResults = function() {
            $165cb073955e137a$var$updateResultsLogic(1);
        };
        $.featherlight.defaults.afterOpen = $165cb073955e137a$var$validateCustomForm;
        jQuery.validator.setDefaults({
            success: "valid"
        });
        $165cb073955e137a$var$setManufacturer(window.location.href);
        $165cb073955e137a$var$setModel(window.location.href);
        //dropdown changes
        $(document).on("change", "[data-deals-page] input, [data-deals-page] select", $165cb073955e137a$var$onChangeFilters);
        //paging click
        $(document).on("click", "#deals-page-results-container .pagination a", $165cb073955e137a$var$pageData);
        //fuel type button chagnes
        $(document).on("click", "[data-price] a", $165cb073955e137a$var$updatePrices);
        $(document).on("submit", "[data-deal-contact-form]", $165cb073955e137a$var$submitContactForm);
    // Bind to StateChange Event
    //History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate#
    //    markAsLoading();
    //    reloadQuery();
    //    const State = History.getState();
    //    setTimeout(
    //        function () {
    //            $.get('/deals/results', State.data, function (response) {
    //                $('#deals-page-results-container').replaceWith(response);
    //            });
    //        }, 600);
    //});
    }
}


function $82264929ebb8a49e$var$filterFaqs(event) {
    event.preventDefault();
    const search = $(event.currentTarget).val();
    $("[data-faq-name] a").each(function(index, element) {
        const link = $(element);
        const faqName = link.text();
        if (faqName.toLowerCase().indexOf(search.toLowerCase()) > -1) link.parents("[data-faq-name]").removeClass("d-none");
        else link.parents("[data-faq-name]").addClass("d-none");
    });
    $("[data-faq-category]").each(function(index, element) {
        const category = $(element);
        const visibleFaqs = category.find("[data-faq-name]:not(.d-none)");
        if (visibleFaqs.length > 0) category.removeClass("d-none");
        else category.addClass("d-none");
    });
}
function $82264929ebb8a49e$export$10b45b794006d1d0() {
    $(document).on("keyup", "[data-faq-search]", $82264929ebb8a49e$var$filterFaqs);
}


function $4c3677df652e2937$var$getButton(e) {
    return $(e.target).siblings("[data-trigger-button]");
}
function $4c3677df652e2937$var$show(e) {
    $4c3677df652e2937$var$getButton(e).text("View less");
    //getButton(e).hide();
    $("[data-view-all]").removeClass("hidden");
}
function $4c3677df652e2937$var$hide(e) {
    $4c3677df652e2937$var$getButton(e).text("View more");
    $("[data-view-all]").addClass("hidden");
}
function $4c3677df652e2937$export$7b633cd5cf57daa2() {
    if ($("[data-fleet-management]").length) {
        const moreTaggedNews = $("#more-tagged-news");
        moreTaggedNews.on("show.bs.collapse", $4c3677df652e2937$var$show);
        moreTaggedNews.on("hide.bs.collapse", $4c3677df652e2937$var$hide);
    }
}


function $3e663d5dbb36a26e$var$getFuelCostsWidgetForm() {
    return $("[data-fuel-costs-widget]");
}
function $3e663d5dbb36a26e$var$getCarTaxWidgetForm() {
    return $("[data-car-tax-widget]");
}
function $3e663d5dbb36a26e$var$submitCarTaxWidgetForm() {
    const form = $3e663d5dbb36a26e$var$getCarTaxWidgetForm();
    form.submit();
}
function $3e663d5dbb36a26e$var$submitFuelCostsWidgetForm() {
    const form = $3e663d5dbb36a26e$var$getFuelCostsWidgetForm();
    form.submit();
}
function $3e663d5dbb36a26e$export$124a9858458e53dc() {
    $(document).on("change", "[data-car-tax-widget-select]", $3e663d5dbb36a26e$var$submitCarTaxWidgetForm);
    $(document).on("change", "[data-fuel-costs-widget-select]", $3e663d5dbb36a26e$var$submitFuelCostsWidgetForm);
}


function $9e13b2ad467bb145$export$54941c72d7452803() {
    $(document).on("submit", "[data-fleetnews-user-data-form]", $9e13b2ad467bb145$var$submitUserDataForm);
    $(document).on("submit", "[data-fleetnews-user-data-close-form]", $9e13b2ad467bb145$var$closeForm);
}
function $9e13b2ad467bb145$var$closeForm(e) {
    const form = $(e.target);
    if (!form.valid()) return;
    e.preventDefault();
    $.post(form.attr("action"), form.serialize(), function(response) {
        $("[data-fleetnews-user-data]").remove();
    });
}
function $9e13b2ad467bb145$var$submitUserDataForm(e) {
    const toChooseMyNextCompanyCarButton = $("#ToChooseMyNextCompanyCarButton").attr("class");
    if (toChooseMyNextCompanyCarButton.indexOf("active") > -1) $("#ToChooseMyNextCompanyCar").val(true);
    const toManageMyCompanyFleetButton = $("#ToManageMyCompanyFleetButton").attr("class");
    if (toManageMyCompanyFleetButton.indexOf("active") > -1) $("#ToManageMyCompanyFleet").val(true);
    const otherButton = $("#OtherButton").attr("class");
    if (otherButton.indexOf("active") > -1) $("#Other").val(true);
    const form = $(e.target);
    if (!form.valid()) return;
    e.preventDefault();
    $.post(form.attr("action"), form.serialize(), function(response) {
        $("[data-fleetnews-user-data]").remove();
    });
}


function $a83f24934579ebaa$export$85500d64d8b96a12() {
    if ($("[data-fn-200]").length) $("#fn200-table").DataTable({
        responsive: true,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function(oSettings) {
            $(".dataTables_paginate").hide();
        }
    });
}


function $57a44814a6005e07$export$29a95a623dfab103() {
    $("[data-ads-body-copy]  p:nth-child(4)").after('<style>.bib__name {color: #d38407;}</style><div id="bib--rcm-text-only-element"></div>');
}


function $0223437a5c85c95b$var$filterCompanies(event) {
    event.preventDefault();
    const search = $(event.currentTarget).val();
    $("[data-company-name]").each(function(index, element) {
        const link = $(element);
        const companyName = link.data("company-name");
        if (companyName.toLowerCase().indexOf(search.toLowerCase()) > -1) $(this).removeClass("d-none");
        else $(this).addClass("d-none");
    });
}
function $0223437a5c85c95b$var$format(id, tr) {
    var jqXHR = $.ajax({
        url: `/fleet200-company/get/${id}`,
        type: "GET",
        async: false
    });
    const obj = JSON.parse(jqXHR.responseText);
    if (obj[0].name1 === "" && obj[0].name3 === "" && obj[0].name3 === "" && obj[0].name4 === "" && obj[0].name5 === "") ;
    else {
        var returnText = "<div class='padding-left-75 padding-right-75'>";
        if (obj[0].name1 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name1;
            if (obj[0].jobTitle1 !== "") returnText += "</br>" + obj[0].jobTitle1;
            returnText += "</div></div>";
        }
        if (obj[0].name2 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name2;
            if (obj[0].jobTitle2 !== "") returnText += "</br>" + obj[0].jobTitle2;
            returnText += "</div></div>";
        }
        if (obj[0].name3 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name3;
            if (obj[0].jobTitle3 !== "") returnText += "</br>" + obj[0].jobTitle3;
            returnText += "</div></div>";
        }
        if (obj[0].name4 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name4;
            if (obj[0].jobTitle4 !== "") returnText += "</br>" + obj[0].jobTitle4;
            returnText += "</div></div>";
        }
        if (obj[0].name5 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name5;
            if (obj[0].jobTitle5 !== "") returnText += "</br>" + obj[0].jobTitle5;
            returnText += "</div></div>";
        }
        returnText += "</div>";
        $(tr).find(".more-button").addClass("active");
        $("<div class='details' style=''>" + returnText + "</div>").insertAfter(tr);
    }
}
function $0223437a5c85c95b$export$b62efe4e2fbde874() {
    $("#myTable").tablesorter({
        sortInitialOrder: "desc",
        sortList: [
            [
                5,
                1
            ]
        ],
        widgets: [
            "zebra"
        ]
    });
    $("#myTable").bind("sortBegin", function(e, table) {
        $(".details").remove();
        $(".more-button").removeClass("active");
    });
    $(document).on("keyup", "[data-company-search]", $0223437a5c85c95b$var$filterCompanies);
    $(document).on("click", ".more-button", function(e) {
        e.preventDefault();
        var tr = $(this).closest("tr");
        var selectedRow = $(this);
        var itemId = selectedRow.data("item-id");
        var next = tr.next();
        var className = next.attr("class");
        if (className !== "details") {
            $0223437a5c85c95b$var$format(itemId, tr);
            $(this).closest("tr").next().next().find("td").css("padding-top", "80px");
        } else {
            $(this).closest("tr").next().next().find("td").css("padding-top", "10px");
            $(next).remove();
            $(tr).find(".more-button").removeClass("active");
        }
    });
}


function $87b693ffb012c6f5$export$a7425bd496405417() {
    $(".fleet200-testimonials-slider").bxSlider({
        slideWidth: 0,
        minSlides: 1,
        maxSlides: 1,
        moveSlides: 1,
        slideMargin: 30,
        pager: false,
        pagerType: "full",
        controls: true
    });
}


let $dfc3ec1d9e099b15$var$quickCalculationForm, $dfc3ec1d9e099b15$var$advancedCalculationForm, $dfc3ec1d9e099b15$var$fuelCostMessageContainer;
const $dfc3ec1d9e099b15$var$errorClass = "input-validation-error";
function $dfc3ec1d9e099b15$var$addToFleet(event) {
    event.preventDefault();
    $dfc3ec1d9e099b15$var$fuelCostMessageContainer.empty();
    const fuelTypesElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#FuelTypes");
    const mileageElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#Mileage");
    const manufacturerElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#ManufacturerId");
    const modelGroupElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#ModelGroupId");
    const derivativeElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#DerivativeId");
    const quantityElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#Quantity");
    const messages = [];
    if (!$dfc3ec1d9e099b15$var$checkFuelType(fuelTypesElement)) messages.push("Please select a fuel type");
    if (!$dfc3ec1d9e099b15$var$checkMileage(mileageElement)) messages.push("Please select a valid mileage");
    if (!$dfc3ec1d9e099b15$var$checkManufacturer(manufacturerElement)) messages.push("Please select a manufacturer");
    if (!$dfc3ec1d9e099b15$var$checkModel(modelGroupElement)) messages.push("Please select a model");
    if (!$dfc3ec1d9e099b15$var$checkDerivative(derivativeElement)) messages.push("Please select a derivative");
    if (!$dfc3ec1d9e099b15$var$checkQuantity(quantityElement)) messages.push("Please select a valid quantity");
    if (messages.length) {
        const ul = $("<ul>").addClass("list-unstyled field-validation-error margin-bottom-0");
        for(let i = 0; i < messages.length; i++)ul.append($("<li>").append(messages[i]));
        $dfc3ec1d9e099b15$var$fuelCostMessageContainer.append(ul);
        return;
    }
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$checkFuelType(fuelType) {
    if (!fuelType.val()) {
        fuelType.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    fuelType.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$checkMileage(mileage) {
    const mileageVal = parseInt(mileage.val());
    if (isNaN(mileageVal) || mileageVal <= 0) {
        mileage.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    mileage.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$checkManufacturer(manufacturer) {
    if (!manufacturer.val()) {
        manufacturer.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    manufacturer.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$checkModel(model) {
    if (!model.val()) {
        model.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    model.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$checkDerivative(derivative) {
    if (!derivative.val()) {
        derivative.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    derivative.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$checkQuantity(quantity) {
    const quantityVal = parseInt(quantity.val());
    if (isNaN(quantityVal) || quantityVal <= 0) {
        quantity.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    quantity.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$quickCalculate(event) {
    if (!$dfc3ec1d9e099b15$var$quickCalculationForm.valid()) return;
    $dfc3ec1d9e099b15$var$quickCalculationForm.find("#QuickExplicitlyCalculated").val("true");
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$advancedCalculate(event) {
    $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#ExplicitlyCalculated").val("true");
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$changeFuelTypes(event) {
    $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#ManufacturerId").val("");
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$changeManufacturer(event) {
    $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#ModelGroupId").val("");
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$submitForms(event) {
    event.preventDefault();
    const url = $dfc3ec1d9e099b15$var$advancedCalculationForm.attr("action");
    let data = $dfc3ec1d9e099b15$var$advancedCalculationForm.serializeArray();
    data = data.concat($dfc3ec1d9e099b15$var$quickCalculationForm.serializeArray());
    //console.log(data);
    $dfc3ec1d9e099b15$var$postToUrl(url, data);
}
function $dfc3ec1d9e099b15$var$removeFromFleet(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const row = button.parents("tr");
    row.remove();
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$postToUrl(path, params, method) {
    method = method || "post"; // Set method to post by default, if not specified.
    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    const form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for(let key in params){
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", params[key].name);
        hiddenField.setAttribute("value", params[key].value);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
}
function $dfc3ec1d9e099b15$export$17fc438eb96437e2() {
    if ($("[data-fuel-cost-calculator]").length) {
        $dfc3ec1d9e099b15$var$quickCalculationForm = $("[data-quick-calculation]");
        $dfc3ec1d9e099b15$var$advancedCalculationForm = $("[data-fuel-cost-form]");
        $dfc3ec1d9e099b15$var$fuelCostMessageContainer = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("[data-fuel-cost-message-container]");
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("change", "#FuelTypes", $dfc3ec1d9e099b15$var$changeFuelTypes);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("change", "#ManufacturerId", $dfc3ec1d9e099b15$var$changeManufacturer);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("change", "#ModelGroupId", $dfc3ec1d9e099b15$var$submitForms);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("click", "[data-remove-from-fleet]", $dfc3ec1d9e099b15$var$removeFromFleet);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("change", "#Area", $dfc3ec1d9e099b15$var$submitForms);
        $dfc3ec1d9e099b15$var$quickCalculationForm.on("change", "#QuickArea", $dfc3ec1d9e099b15$var$submitForms);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("click", "[data-add-to-fleet]", $dfc3ec1d9e099b15$var$addToFleet);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("click", "[data-advanced-calculate]", $dfc3ec1d9e099b15$var$advancedCalculate);
        $dfc3ec1d9e099b15$var$quickCalculationForm.on("click", "[data-quick-calculate]", $dfc3ec1d9e099b15$var$quickCalculate);
    }
}


function $b98720deb745778b$var$setFuelTypeButtons() {
    setTimeout(function() {
        const url = window.location.href.split("?")[1];
        if (!url) return;
        const selectedFuelTypeArray = url.split("=");
        const selectedFuelType = selectedFuelTypeArray[selectedFuelTypeArray.length - 1];
        if (selectedFuelType.indexOf(",") > 1) {
            const stringArray = selectedFuelType.split(",");
            stringArray.forEach(function(item) {
                const buttonTarget = `data-fuel-type-${item}`;
                $(`[${buttonTarget}]`).removeClass().addClass("btn btn-green");
            });
        } else {
            const buttonTarget = `data-fuel-type-${selectedFuelType}`;
            $(`[${buttonTarget}]`).removeClass().addClass("btn btn-green");
        }
    }, 5000);
}
function $b98720deb745778b$export$d18b5b0ff33e313c() {
    window.fuelTypeButtons = $b98720deb745778b$var$setFuelTypeButtons;
    window.fuelTypeButtons();
}


function $935dae51dafb9406$var$setCaption(imageId) {
    const galleryId = $("[data-image-gallery-id]").data("image-gallery-id");
    $.get("/get-image-caption/" + imageId + "/" + galleryId, function(response) {
        //$('[data-slider-caption-container]').appendTo('.royalSlider');
        $("[data-slider-caption-container]").html(response);
        $("[data-slider-caption-container]").show();
    });
}
function $935dae51dafb9406$var$updateUrl(event) {
    const history = window.History;
    const stateData = {};
    const imageId = event.target.currSlide.imageId || event.target.currSlide.caption?.prevObject.data("image-id");
    if (!imageId) return;
    $935dae51dafb9406$var$setCaption(imageId);
    stateData.image = imageId;
    const queryString = $.param(stateData);
    stateData.doNotReloadAds = true;
    history.replaceState(stateData, $("title").html(), location.pathname + "?" + queryString);
}
function $935dae51dafb9406$var$setupAdHolder(holder, type) {
    const ad = $("<div data-ad-holder>");
    const adHolderId = "ad-" + type + "-" + new Date().getTime();
    ad.attr("id", adHolderId);
    holder.append(ad);
    return adHolderId;
}
function $935dae51dafb9406$var$checkHolder(element, selector) {
    const holder = element.find(selector);
    const slot = holder.data("ad-slot");
    if (slot) {
        window.googletag.cmd.push(function() {
            window.googletag.pubads().refresh([
                slot
            ]);
        });
        return null;
    }
    return holder;
}
function $935dae51dafb9406$var$loadLeaderboard(slider) {
    const holder = $935dae51dafb9406$var$checkHolder(slider, ".rsLeaderboardHolder");
    if (holder == null) return;
    const adHolderId = $935dae51dafb9406$var$setupAdHolder(holder, "leaderboard");
    $935dae51dafb9406$var$initAd(slider, holder, adHolderId, [
        728,
        90
    ], "leaderboard-1", [
        [
            [
                768,
                0
            ],
            [
                728,
                90
            ]
        ],
        [
            [
                0,
                0
            ],
            [
                320,
                50
            ]
        ]
    ]);
}
function $935dae51dafb9406$var$loadMpus(slider) {
    // we don't want to load or refresh MPUs on mobile
    if (window.isViewportLessThan("md")) return;
    // mpu 1
    let holder = $935dae51dafb9406$var$checkHolder(slider, ".rsMpuHolder > .mpu-1-holder");
    let adHolderId;
    if (holder != null) {
        adHolderId = $935dae51dafb9406$var$setupAdHolder(holder, "mpu-1");
        $935dae51dafb9406$var$initAd(slider, holder, adHolderId, [
            300,
            250
        ], "mpu-1");
    }
    // mpu 2
    holder = $935dae51dafb9406$var$checkHolder(slider, ".rsMpuHolder > .mpu-2-holder");
    if (holder != null) {
        adHolderId = $935dae51dafb9406$var$setupAdHolder(holder, "mpu-2");
        $935dae51dafb9406$var$initAd(slider, holder, adHolderId, [
            300,
            250
        ], "mpu-2");
    }
}
function $935dae51dafb9406$var$loadSlideMpu(slider, slide) {
    $("[data-slider-caption-container]").hide();
    const existingSlot = slide.data("ad-slot");
    if (existingSlot) {
        window.googletag.cmd.push(function() {
            window.googletag.pubads().refresh([
                existingSlot
            ]);
            $935dae51dafb9406$var$disableNavigation(existingSlot);
        });
        return;
    }
    $935dae51dafb9406$var$initAd(slider, slide, slide.find("[data-ad-container]").attr("id"), [
        300,
        250
    ], "mpu-1", null, true);
}
function $935dae51dafb9406$var$disableNavigation(slot) {
    slot.lockedNav = true;
    const slider = slot.slider;
    slider.slider.find(".rsOverflow").addClass("rsNoDrag");
    slider.slider.find(".rsArrow").hide();
    slider.st.navigateByClick = false;
    setTimeout(function() {
        $935dae51dafb9406$var$unlock(slider);
    }, 5000);
}
function $935dae51dafb9406$var$unlock(slider) {
    slider.slider.find(".rsOverflow").removeClass("rsNoDrag");
    slider.slider.find(".rsArrow").show();
    slider.st.navigateByClick = true;
}
function $935dae51dafb9406$var$initAd(slider, holder, id, defaultSize, position, sizeMapping, disableNav) {
    window.googletag.cmd.push(function() {
        const thisPage = window.dfpAdsPage;
        const slotName = `${thisPage.slotName}/${position}`;
        let slot = window.googletag.defineSlot(slotName, defaultSize, id).setTargeting("position", [
            position
        ]).addService(window.googletag.pubads());
        if (sizeMapping) slot = slot.defineSizeMapping(sizeMapping);
        holder.data("ad-slot", slot);
        slot.slider = slider;
        // Display has to be called before
        // refresh and after the slot div is in the page.
        window.googletag.display(id);
        window.googletag.pubads().refresh([
            slot
        ]);
        if (disableNav) $935dae51dafb9406$var$disableNavigation(slot);
    });
}
function $935dae51dafb9406$var$unlockNav(event) {
    const slot = event.slot;
    if (!slot.lockedNav) return;
    const slider = slot.slider;
    // unlock after a second and a half
    setTimeout(function() {
        slider.slider.find(".rsOverflow").removeClass("rsNoDrag");
        slider.slider.find(".rsArrow").show();
        slider.st.navigateByClick = true;
    }, slider.st.adNavLockout);
}
function $935dae51dafb9406$var$tryLoadMpu(event) {
    const slide = event.target.currSlide.content;
    if (slide.data("gallery-ad")) $935dae51dafb9406$var$loadSlideMpu(event.target, slide);
}
function $935dae51dafb9406$var$reloadFixedAds(event) {
    const $slider = event.target;
    $slider.leaderboardReloadCount += 1;
    if ($slider.leaderboardReloadCount >= $slider.st.leaderboardReloadAfter) {
        $935dae51dafb9406$var$loadLeaderboard($slider.slider);
        $slider.leaderboardReloadCount = 0;
    }
    // don't increment the mpu count if it's not visible (i.e. it's on mobile)
    if (!window.isViewportLessThan("md")) {
        $slider.mpuReloadCount += 1;
        if ($slider.mpuReloadCount >= $slider.st.mpuReloadAfter) {
            $935dae51dafb9406$var$loadMpus($slider.slider);
            $slider.mpuReloadCount = 0;
        }
    }
}
function $935dae51dafb9406$var$postSlideChange(event) {
    const $slider = event.target;
    if (!$slider.slider.hasClass("rsFullscreen")) return;
    // manually turned off
    if ($slider.changeEventsDisabled) return;
    // this is for goto fast, after resize
    if ($slider.changeEventsDisabledByGoto) {
        // turn it off, as this is the animation complete off the gotoFast
        $slider.changeEventsDisabledByGoto = false;
        return;
    }
    $935dae51dafb9406$var$reloadFixedAds(event);
    $935dae51dafb9406$var$tryLoadMpu(event);
    $935dae51dafb9406$var$updateUrl(event);
}
function $935dae51dafb9406$var$setup() {
    window.loadGallery = function() {
        const sliders = $("[data-slider-gallery]");
        if (sliders.length === 0) return;
        sliders.each(function(index, element) {
            const $element = $(element);
            if ($element.data("royalSlider") != null) return;
            const slides = $element.children().clone();
            const desktopSlides = slides.filter("a").clone();
            const options = {
                arrowsNavAutoHide: false,
                imageScaleMode: "fit-if-smaller",
                imageScalePadding: 0,
                controlNavigationSpacing: 0,
                controlNavigation: "none",
                loop: true,
                numImagesToPreload: 1,
                keyboardNavEnabled: true,
                usePreloader: true,
                slidesSpacing: 0,
                minSlideOffset: 0,
                leaderboardReloadAfter: $element.data("leaderboard-reload-after") || 4,
                mpuReloadAfter: $element.data("mpu-reload-after") || 4,
                adNavLockout: $element.data("ad-nav-lockout") || 1500,
                fullscreen: {
                    // fullscreen options go here
                    enabled: true,
                    nativeFS: false
                }
            };
            $element.royalSlider(options);
            const slider = $element.data("royalSlider");
            const mpuHolder = $('<div class="rsMpuHolder">');
            const mpu1 = $('<div class="mpu-1-holder mb-3">').appendTo(mpuHolder);
            const mpu2 = $('<div class="mpu-2-holder mb-3">').appendTo(mpuHolder);
            $element.prepend(mpuHolder);
            const leaderboardHolder = $('<div class="rsLeaderboardHolder">').prependTo($element);
            slider.ev.on("rsExitFullscreen", function() {
                // exit fullscreen mode 
                $("#heading-group").css("z-index", "2");
                $element.hide();
                $element.removeClass("fullscreen");
            });
            slider.ev.on("rsBeforeSizeSet", function() {
                // adjust the fullsize height of the wrapper to not include the leaderboard and mpu holders
                const leaderboardHolderHeight = leaderboardHolder.outerHeight(true);
                const mpuHolderWidth = mpuHolder.outerWidth(true);
                slider._wrapHeight = slider._wrapHeight - leaderboardHolderHeight;
                slider._wrapWidth = slider._wrapWidth - mpuHolderWidth;
            });
            // do not display on initial load
            $element.hide();
            slider.allSlides = jQuery.extend(true, [], slider.slides);
            slider.desktopSlides = $(slider.allSlides).filter(function(index, element) {
                return element.images !== null;
            }).get();
            function goToFast(indexOf) {
                slider.changeEventsDisabledByGoto = true;
                const temp = slider.st.transitionSpeed;
                slider.st.transitionSpeed = 0;
                slider.goTo(indexOf, true);
                slider.st.transitionSpeed = temp;
            }
            function setToDesktop(init) {
                slider.changeEventsDisabled = true;
                // ensure not on advert
                // if the index is of an advert, we look for the id below, as the first slide can never be an ad
                if (slider.currSlide.images == null) slider.goTo(slider.currSlideId - 1, true);
                const indexOf = slider.desktopSlides.findIndex(function(element) {
                    return element.images[0] === slider.currSlide.images[0];
                });
                while(slider.slides.length > 0)slider.removeSlide(0);
                for(let i = 0; i < slider.desktopSlides.length; i++){
                    const slide = desktopSlides[i];
                    slider.appendSlide(slide);
                }
                setTimeout(function() {
                    goToFast(indexOf);
                }, 50);
                slider.changeEventsDisabled = false;
            }
            function setToMobile() {
                slider.changeEventsDisabled = true;
                const indexOf = slider.allSlides.findIndex(function(element) {
                    return element.images != null && element.images[0] === slider.currSlide.images[0];
                });
                while(slider.slides.length > 0)slider.removeSlide(0);
                for(let i = 0; i < slider.allSlides.length; i++){
                    const slide = slides[i];
                    slider.appendSlide(slide);
                }
                setTimeout(function() {
                    goToFast(indexOf);
                }, 50);
                slider.changeEventsDisabled = false;
            }
            // by default the slides are for mobile as they include ads inbetween, so we'll move to desktop if it's not that
            $(document).on("viewport-changed", function(event, data) {
                // do nothing if the change is non-mobile related
                if (data.from !== document.viewportSize.mobile && data.to !== document.viewportSize.mobile) return;
                //var indexOf;
                if (data.to === document.viewportSize.mobile) setToMobile();
                else if (data.from === document.viewportSize.mobile) setToDesktop();
                $935dae51dafb9406$var$loadLeaderboard($element);
                $935dae51dafb9406$var$loadMpus($element);
                // reset this if it's been force reloaded
                slider.leaderboardReloadCount = 0;
            });
            slider.ev.on("rsEnterFullscreen", function() {
                // enter fullscreen mode 
                $("#heading-group").css("z-index", "1");
                $element.show();
                $element.addClass("fullscreen");
                const defaultImageId = $("[data-default-image-id]").data("default-image-id");
                $935dae51dafb9406$var$setCaption(defaultImageId);
                $935dae51dafb9406$var$loadLeaderboard($element);
                $935dae51dafb9406$var$loadMpus($element);
                if (!window.isViewportLessThan("md")) setToDesktop();
                else setToMobile();
            });
            // add ad reload variables
            slider.leaderboardReloadCount = 0;
            slider.mpuReloadCount = 0;
            slider.ev.on("rsAfterSlideChange", $935dae51dafb9406$var$postSlideChange);
            window.gallerySliderData = slider;
            const siblings = $element.siblings("[data-slider-caption-container]");
            const caption = $element.find(".rsGCaption");
            caption.appendTo(siblings);
        });
    };
}
function $935dae51dafb9406$var$launchGallery(event) {
    event.preventDefault();
    const $this = $(event.currentTarget);
    const galleryName = $this.closest(".article-gallery").find("[data-slider-gallery]").data("slider-gallery");
    const gallery = $('[data-slider-gallery="' + galleryName + '"]');
    const slider = gallery.data("royalSlider");
    if (!slider) return;
    const index = $this.data("gallery-launcher-index");
    if (typeof index == "undefined") return;
    const slide = $(slider.allSlides).filter(function(_, element) {
        return element.id === index;
    }).get(0);
    if (slide == null) return;
    const slideIndex = slider.slides.findIndex(function(element) {
        return element.images != null && element.images[0] === slide.images[0];
    });
    if (slideIndex === -1) return;
    slider.goTo(slideIndex, false);
    setTimeout(function() {
        slider.enterFullscreen();
    }, 51);
}
function $935dae51dafb9406$export$f0c7f3aad087f331() {
    $935dae51dafb9406$var$setup();
    window.loadGallery();
    $(document).on("click", "[data-gallery-launcher]", $935dae51dafb9406$var$launchGallery);
    if (window.googletag) window.googletag.pubads().addEventListener("slotOnload", $935dae51dafb9406$var$unlockNav);
}


function $1681bada7f12e93a$var$getForm() {
    return $("[data-fn-job-search]");
}
function $1681bada7f12e93a$var$setPage(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const page = button.data("pager-page");
    const form = $1681bada7f12e93a$var$getForm();
    form.find("#PageNumber").val(page);
    form.submit();
}
function $1681bada7f12e93a$var$getUrlVars(hrefUrl) {
    const vars = [];
    let hash;
    const hashes = hrefUrl.slice(hrefUrl.indexOf("?") + 1).split("&");
    for(let i = 0; i < hashes.length; i++){
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
function $1681bada7f12e93a$var$applyPagerAttributes() {
    const pager = $("#fn-pager");
    const links = pager.find("a");
    links.each(function(index, element) {
        const alink = $(element);
        const link = alink.attr("href");
        if (!link) return;
        const queryString = $1681bada7f12e93a$var$getUrlVars(link);
        const page = queryString["page"];
        if (!page) return;
        alink.attr("href", "#");
        alink.attr("data-pager-page", page);
    });
}
function $1681bada7f12e93a$export$8ffecd3ecbf5a7bf() {
    if ($("[data-jobs-search]").length) {
        $(document).on("click", "[data-pager-page]", $1681bada7f12e93a$var$setPage);
        $1681bada7f12e93a$var$applyPagerAttributes();
    }
}


function $1062b41150fcb383$export$2b2ccfd71dd67323() {
    if ($("[data-jquery-checkbox]").length) $(".button-checkbox").each(function() {
        // Settings
        const $widget = $(this), $button = $widget.find("button"), $checkbox = $widget.find("input:checkbox"), color = $button.data("color"), settings = {
            on: {
                icon: "glyphicon glyphicon-check"
            },
            off: {
                icon: "glyphicon glyphicon-unchecked"
            }
        };
        // Event Handlers
        $button.on("click", function() {
            $checkbox.prop("checked", !$checkbox.is(":checked"));
            $checkbox.triggerHandler("change");
            updateDisplay();
        });
        $checkbox.on("change", function() {
            updateDisplay();
        });
        // Actions
        function updateDisplay() {
            const isChecked = $checkbox.is(":checked");
            // Set the button's state
            $button.data("state", isChecked ? "on" : "off");
            // Set the button's icon
            $button.find(".state-icon").removeClass().addClass("state-icon " + settings[$button.data("state")].icon);
            //update the value of checkbox
            //var value = $checkbox.val();
            //alert(value);
            //$checkbox.val('checked');
            // Update the button's color
            if (isChecked) $button.removeClass("btn-default").addClass("btn-" + color + " active");
            else $button.removeClass("btn-" + color + " active").addClass("btn-default");
        }
        // Initialization
        function init() {
            updateDisplay();
            // Inject the icon if applicable
            if ($button.find(".state-icon").length === 0) $button.prepend('<i class="state-icon ' + settings[$button.data("state")].icon + '"></i>\xa0');
        }
        init();
    });
}


function $99ad575d7443e4d6$var$onRegisterButtonClick(e) {
    $99ad575d7443e4d6$var$checkPhoneRequirement();
    const form = $("[data-registration-form]");
    if (!form.valid()) return;
    e.preventDefault();
    const $button = form.find('button[type="submit"], input[type="submit"]');
    const partnerByPhone = $("#PartnerByPhone").is(":checked");
    const bauerByPhone = $("#BauerByPhone").is(":checked");
    const phoneNumber = $("#PhoneNumber").val();
    if (partnerByPhone === true || bauerByPhone === false) {
        if (phoneNumber !== "") {
            $button.attr("disabled", "disabled");
            $(form).submit();
        } else $("[data-phone-validation]").removeClass("hidden");
    } else {
        $button.attr("disabled", "disabled");
        $(form).submit();
    }
}
function $99ad575d7443e4d6$var$getTopHeaderHeight() {
    let height = 0;
    if (window.isViewportGreaterThanOrEqualTo("lg")) {
        const siteSelector = $(".site-selector");
        height += siteSelector.height();
        siteSelector.removeClass("collapse");
        siteSelector.removeAttr("style");
    } else if (window.isViewportLessThan("md")) {
        const mobileFixedHeader = $("#fixedHeader");
        height += mobileFixedHeader.height();
    } else if (window.getViewportSize() == "md") {
        const tabletFixedHeader = $("#fixedHeader");
        height += tabletFixedHeader.height();
    }
    return height;
}
const $99ad575d7443e4d6$var$sph = "scrolled-past-header";
function $99ad575d7443e4d6$var$onFNScroll() {
    const scrollPosition = window.pageYOffset;
    //var headerHeight = $('#fixedHeader').height();
    const headerHeight = $99ad575d7443e4d6$var$getTopHeaderHeight();
    if (scrollPosition > headerHeight) $("html").addClass($99ad575d7443e4d6$var$sph);
    else $("html").removeClass($99ad575d7443e4d6$var$sph);
//if (isTablet || isMobile) {
//    if (!$(".leaderboard-container").hasClass('ad-scroll-fix')) {
//        $(".leaderboard-container").addClass('ad-scroll-fix');
//    }
//} else {
//    if ($(".leaderboard-container").hasClass('ad-scroll-fix')) {
//        $(".leaderboard-container").removeClass('ad-scroll-fix');
//    }
//}
}
function $99ad575d7443e4d6$var$fixLeaderboardOnMobileTablet() {
    const width = $(document).width();
    const isTablet = width <= 976 && width > 768;
    const isMobile = width <= 768;
    const newTakeOverActive = $("body").hasClass("hero-takeover-active");
//if (newTakeOverActive) {
//    $(".leaderboard-container").removeClass('ad-scroll-fix');
//    return;
//}
//if (isTablet || isMobile) {
//    if (!$(".leaderboard-container").hasClass('ad-scroll-fix')) {
//        $(".leaderboard-container").addClass('ad-scroll-fix');
//    }
//} else {
//    if ($(".leaderboard-container").hasClass('ad-scroll-fix')) {
//        $(".leaderboard-container").removeClass('ad-scroll-fix');
//    }
//}
}
function $99ad575d7443e4d6$var$checkPhoneRequirement() {
    const partnerByPhone = $("#PartnerByPhone").is(":checked");
    const bauerByPhone = $("#BauerByPhone").is(":checked");
    const phoneNumber = $("#PhoneNumber").val();
    if (partnerByPhone === true || bauerByPhone === false) {
        if (phoneNumber !== "") $("[data-phone-validation]").addClass("hidden");
        else $("[data-phone-validation]").removeClass("hidden");
    } else $("[data-phone-validation]").addClass("hidden");
}
function $99ad575d7443e4d6$var$onShowNavbar(e) {
    let minusHeight = 85;
    if ($("html").hasClass("scrolled-past-header")) {
        minusHeight = 35;
        if ($("body").hasClass("mrcms-admin-bar-on")) minusHeight = 65;
    } else if ($("body").hasClass("mrcms-admin-bar-on")) minusHeight = 115;
    const windowHeight = $(window).innerHeight() - minusHeight;
    $(".navbar-collapse .nav.navbar-nav ").css({
        height: windowHeight
    });
    $("body").attr("style", "margin: 0; height: 0; overflow: hidden;");
    $("#main-content").attr("style", "visibility:hidden");
//$(".ad-scroll-fix").hide();
}
function $99ad575d7443e4d6$var$onHideNavbar(e) {
    $("body").attr("style", "");
    $("#main-content").attr("style", "");
//$(".ad-scroll-fix").show();
}
function $99ad575d7443e4d6$var$onShowRightHandBar(e) {
    if (window.isViewportLessThan("lg")) {
        $("body").attr("style", "margin: 0; height: 0; overflow: hidden;");
        $("[data-ads-main-column]").attr("style", "margin: 0; height: 0; overflow: hidden;visibility:hidden");
        $(".leaderboard-container").attr("style", "height: 0; visibility:hidden");
        $("footer").attr("style", "height: 0; visibility:hidden");
    //$(".ad-scroll-fix").hide();
    }
}
function $99ad575d7443e4d6$var$onShownRightHandBar(e) {
    if (window.isViewportLessThan("lg")) {
        let minusHeight = 90;
        if ($("html").hasClass("scrolled-past-header")) minusHeight = 30;
        const rightMenuHeight = $(window).innerHeight() - minusHeight;
        $("#righthandbar.collapse.in").css({
            height: rightMenuHeight
        });
    }
}
function $99ad575d7443e4d6$var$onHideRightHandBar(e) {
    if (window.isViewportLessThan("lg")) {
        $("body").attr("style", "");
        $("[data-ads-main-column]").attr("style", "");
        $(".leaderboard-container").attr("style", "");
        $("footer").attr("style", "");
    //$(".ad-scroll-fix").show();
    }
}
function $99ad575d7443e4d6$var$onShowHidePasswordClick(event) {
    event.preventDefault();
    const input = $("#show_hide_password input");
    const visible = $("#show_hide_password i");
    if (input.attr("type") === "text") {
        input.attr("type", "password");
        visible.addClass("fa-eye-slash");
        visible.removeClass("fa-eye");
    } else if (input.attr("type") === "password") {
        input.attr("type", "text");
        visible.removeClass("fa-eye-slash");
        visible.addClass("fa-eye");
    }
}
function $99ad575d7443e4d6$var$fixAdOnScroll() {
    var width = $(document).width();
    var isTablet = width <= 976 && width > 768;
    var isMobile = width <= 768;
    if (isTablet || isMobile) {
        if ($(window).scrollTop() > 100) {
            if (!$("#top-leaderboard").hasClass("ad-scroll-fix")) $("#top-leaderboard").addClass("ad-scroll-fix");
        } else $("#top-leaderboard").removeClass("ad-scroll-fix");
    }
}
function $99ad575d7443e4d6$var$stickyInline01() {
    var width = $(document).width();
    var isTablet = width <= 976 && width > 768;
    var isMobile = width <= 768;
    if (isTablet || isMobile) $("#top-leaderboard").removeClass("sticky-dfp-ad");
}
function $99ad575d7443e4d6$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (textDiv.style.maxHeight.replace("px", "") > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
        }
    }
}
function $99ad575d7443e4d6$export$7689f9df4f599197() {
    $99ad575d7443e4d6$var$stickyInline01();
    // need to do this after document.ready so that all dependencies are loaded
    //$(window).scroll(fixingHeaderBar);
    //$(window).on('load', fixingHeaderBar);
    //$(window).on('resize', fixingHeaderBar);
    $(document).on("click", "#OtherButton", function() {
        const classAttribute = $(this).attr("class");
        if (classAttribute.indexOf("active") > -1) $("[data-other-text]").show();
        else {
            $("[data-other-text]").hide();
            $("#OtherText").val("");
        }
    });
    $99ad575d7443e4d6$var$fixLeaderboardOnMobileTablet();
    $(window).resize(function() {
        $99ad575d7443e4d6$var$fixLeaderboardOnMobileTablet();
    });
    $("nav.navbar .collapse").on("show.bs.collapse", $99ad575d7443e4d6$var$onShowNavbar);
    $("nav.navbar .collapse").on("hide.bs.collapse", $99ad575d7443e4d6$var$onHideNavbar);
    $("#righthandbar").on("show.bs.collapse", $99ad575d7443e4d6$var$onShowRightHandBar);
    $("#righthandbar").on("shown.bs.collapse", $99ad575d7443e4d6$var$onShownRightHandBar);
    $("#righthandbar").on("hide.bs.collapse", $99ad575d7443e4d6$var$onHideRightHandBar);
    $("#compareanothercar-link").click(function(event) {
        event.preventDefault();
        $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top
        }, 500);
    });
    $("#show_hide_password a").on("click", $99ad575d7443e4d6$var$onShowHidePasswordClick);
    $("[data-past-events]").click(function() {
        $("html, body").animate({
            scrollTop: $("#past-events").offset().top
        }, 100);
    });
    $("#PartnerByPhone").change(function() {
        $99ad575d7443e4d6$var$checkPhoneRequirement();
    });
    $("#BauerByPhone").change(function() {
        $99ad575d7443e4d6$var$checkPhoneRequirement();
    });
    $("#PhoneNumber").blur(function() {
        $99ad575d7443e4d6$var$checkPhoneRequirement();
    });
    $("#PhoneNumber").keypress(function() {
        $("[data-phone-validation]").addClass("hidden");
    });
    $(document).on("click", "[data-btn-register]", $99ad575d7443e4d6$var$onRegisterButtonClick);
    window.setTimeout(function() {
        $(".form-submitted-message").fadeTo(500, 0).slideUp(500, function() {
            $(this).remove();
        });
    }, 4000);
    $(window).on("scroll", $99ad575d7443e4d6$var$onFNScroll);
    /*$('body').prepend('<a href="#" class="back-to-top">Back to Top</a>');*/ const amountScrolled = 300;
    $(window).scroll(function() {
        if ($(window).scrollTop() > amountScrolled) $("a.back-to-top").fadeIn("slow");
        else $("a.back-to-top").fadeOut("slow");
    });
    $("a.back-to-top, a.simple-back-to-top").click(function() {
        $("html, body").animate({
            scrollTop: 0
        }, 700);
        return false;
    });
    $("[data-extra-content]").click(function(e) {
        e.preventDefault();
        $("#extra-content").toggle("slow");
    });
    $("[data-more-charging-info]").click(function() {
        $("html, body").animate({
            scrollTop: $("#charging-data").offset().top - 100
        }, 700);
        return false;
    });
    $(document).on("scroll", $99ad575d7443e4d6$var$fixAdOnScroll);
    $99ad575d7443e4d6$var$handleBodyCopyToggle();
// $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
//     // Avoid following the href location when clicking
//     event.preventDefault();
//     // Avoid having the menu to close when clicking
//     event.stopPropagation();
//     // If a menu is already open we close it
//     //$('ul.dropdown-menu [data-toggle=dropdown]').parent().removeClass('open');
//     // opening the one you clicked on
//     //$(this).parent().addClass('open');
//
//     $(this).closest(".dropdown-submenu").toggleClass("open");
// });
}


const $fe07b9887899a8fb$var$history = window.History;
function $fe07b9887899a8fb$var$buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data, function(value, key) {
        if (key === "isPageChange") return;
        if (value) queryStringData[key] = value;
    });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}
function $fe07b9887899a8fb$var$getData() {
    const dataArray = $("[data-car-tax-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function(item) {
        if (data[item.name]) {
            if (typeof data[item.name] === "string") data[item.name] = [
                data[item.name]
            ];
            data[item.name].push(item.value);
        } else data[item.name] = item.value;
    });
    return data;
}
function $fe07b9887899a8fb$var$updateResultsLogic(isPageChange) {
    const data = $fe07b9887899a8fb$var$getData();
    if (isPageChange) data.isPageChange = true;
    $fe07b9887899a8fb$var$history.pushState(data, $("title").html(), location.pathname + "?" + $fe07b9887899a8fb$var$buildUpQueryString(data));
    return data;
}
function $fe07b9887899a8fb$var$triggerUpdateResults(event) {
    if (event.target.name === "Manufacturer1Id") {
        if ($("#ModelGroup1Id").val() !== null) {
            $("#ModelGroup1Id").val("");
            $("#Derivative1Id").val("");
        }
    }
    if (event.target.name === "ModelGroup1Id") {
        if ($("#Derivative1Id").val() !== null) $("#Derivative1Id").val("");
    }
    window.updateResults();
}
function $fe07b9887899a8fb$var$reloadQuery() {
    const state = $fe07b9887899a8fb$var$history.getState();
    $.get("/costs/new-car-tax-calculator/query", state.data, function(response) {
        $("[data-car-tax-query-attributes]").replaceWith(response);
    });
}
function $fe07b9887899a8fb$var$updateState() {
    $fe07b9887899a8fb$var$reloadQuery();
    const state = $fe07b9887899a8fb$var$history.getState();
    $.get("/costs/new-car-tax-calculator/results", state.data, function(response) {
        $("[data-car-tax-results-container]").replaceWith(response);
        if (window.isViewportLessThan("lg")) {
            $(".first-car-tax-result").insertAfter($(".first-car-tax-query"));
            $(".second-car-tax-result").insertAfter($(".second-car-tax-query"));
        }
    });
}
function $fe07b9887899a8fb$var$moveElements() {
    if (window.isViewportLessThan("lg")) {
        $(".first-car-tax-result").insertAfter($(".first-car-tax-query"));
        $(".second-car-tax-result").insertAfter($(".second-car-tax-query"));
    }
}
function $fe07b9887899a8fb$export$7c7fd016d0e808fe() {
    if ($("[data-new-car-tax-calculator]").length) {
        $(document).on("change", "[data-car-tax-query-attributes] input, [data-car-tax-query-attributes] select", $fe07b9887899a8fb$var$triggerUpdateResults);
        // Bind to StateChange Event
        $fe07b9887899a8fb$var$history.Adapter.bind(window, "statechange", $fe07b9887899a8fb$var$updateState);
        $fe07b9887899a8fb$var$moveElements();
        $(window).on("resize", $fe07b9887899a8fb$var$moveElements);
        window.updateResults = function() {
            $fe07b9887899a8fb$var$updateResultsLogic();
        };
    }
}


const $1e7dc984495afd55$var$history = window.History;
function $1e7dc984495afd55$var$buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data, function(value, key) {
        if (key === "isPageChange") return;
        if (value) queryStringData[key] = value;
    });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}
function $1e7dc984495afd55$var$getData() {
    const dataArray = $("[data-fuel-cost-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function(item) {
        if (data[item.name]) {
            if (typeof data[item.name] === "string") data[item.name] = [
                data[item.name]
            ];
            data[item.name].push(item.value);
        } else data[item.name] = item.value;
    });
    return data;
}
function $1e7dc984495afd55$var$updateResultsLogic(isPageChange) {
    const data = $1e7dc984495afd55$var$getData();
    if (isPageChange) data.isPageChange = true;
    $1e7dc984495afd55$var$history.pushState(data, $("title").html(), location.pathname + "?" + $1e7dc984495afd55$var$buildUpQueryString(data));
    return data;
}
function $1e7dc984495afd55$var$triggerUpdateResults(event) {
    const currentMpg = $("#Mpg").val();
    if ($(event.target).data("autocomplete") != null) return;
    if (event.target.name === "FuelType") $("#PencePerLitre").val("");
    if (event.target.name === "Mileage") {
        if (currentMpg === "") return;
    }
    if (event.target.name === "ManufacturerId") {
        if (currentMpg !== "") $("#Mpg").val("");
        if ($("#ModelGroupId").val() != null) {
            $("#ModelGroupId").val("");
            $("#DerivativeId").val("");
        }
    }
    if (event.target.name === "ModelGroupId") {
        if (currentMpg !== "") $("#Mpg").val("");
        if ($("#DerivativeId").val() != null) $("#DerivativeId").val("");
    }
    window.updateResults();
}
function $1e7dc984495afd55$var$calculateExtraMpg(event) {
    event.preventDefault();
    const currentMpg = parseFloat($("#Mpg").val());
    $("#Mpg").val(currentMpg + 5);
    window.updateResults();
}
//function calculateExtra1P(event) {
//    event.preventDefault();
//    var currentPrice = parseFloat($("#PencePerLitre").val());;
//    $("#PencePerLitre").val(currentPrice + 1);
//    window.updateResults();
//}
function $1e7dc984495afd55$var$calculateExtra3P(event) {
    event.preventDefault();
    const currentPrice = parseFloat($("#PencePerLitre").val());
    $("#PencePerLitre").val(currentPrice + 3);
    window.updateResults();
}
function $1e7dc984495afd55$var$scrollToResult(event) {
    const penceperlitre = $("#PencePerLitre").val();
    const mileage = $("#Mileage").val();
    const mpg = $("#Mpg").val();
    let headerHeight = 300;
    if (window.isViewportLessThan("md")) headerHeight = 120;
    if (penceperlitre !== "" && mileage !== "" && mpg !== "") $("html, body").animate({
        scrollTop: $("[data-fuel-cost-results-container]").offset().top - headerHeight
    }, 2000);
    if (penceperlitre !== "" && mileage !== "" && mpg === "") {
        $("[data-mpg-message]").append("<div class='alert alert-danger margin-bottom-15'>Please enter mpg or choose the make, model and version for us to find it for you.</div>");
        $("html, body").animate({
            scrollTop: $("[data-mpg-section]").offset().top - headerHeight
        }, 2000);
    }
}
function $1e7dc984495afd55$var$reloadQuery() {
    const state = $1e7dc984495afd55$var$history.getState();
    $.get("/costs/new-fuel-cost-calculator/query", state.data, function(response) {
        $("[data-fuel-cost-query-attributes]").replaceWith(response);
    });
}
function $1e7dc984495afd55$var$updateState() {
    $1e7dc984495afd55$var$reloadQuery();
    const state = $1e7dc984495afd55$var$history.getState();
    $.get("/costs/new-fuel-cost-calculator/results", state.data, function(response) {
        $("[data-fuel-cost-results-container]").replaceWith(response);
        if (response.indexOf("fuel-cost-calculator-result") !== -1) {
            let headerHeight = 300;
            if (window.isViewportLessThan("md")) headerHeight = 120;
            $("html, body").animate({
                scrollTop: $("[data-fuel-cost-results-container]").offset().top - headerHeight
            }, 2000);
        }
    });
}
function $1e7dc984495afd55$export$536c895956e6bdad() {
    if ($("[data-new-fuel-cost-calculator]").length) {
        $(document).on("change", "[data-fuel-cost-query-attributes] input, [data-fuel-cost-query-attributes] select", $1e7dc984495afd55$var$triggerUpdateResults);
        $(document).on("click", "[data-recalculate-extra-mpg]", $1e7dc984495afd55$var$calculateExtraMpg);
        //$(document).on("click", "[data-recalculate-extra-1p]", calculateExtra1P);
        $(document).on("click", "[data-recalculate-extra-3p]", $1e7dc984495afd55$var$calculateExtra3P);
        $(document).on("click", "[data-view-result-button]", $1e7dc984495afd55$var$scrollToResult);
        // Bind to StateChange Event
        $1e7dc984495afd55$var$history.Adapter.bind(window, "statechange", $1e7dc984495afd55$var$updateState);
        window.updateResults = function() {
            $1e7dc984495afd55$var$updateResultsLogic();
        };
    }
}


$.fn.replaceWithCallback = function(replace, callback) {
    var ret = $.fn.replaceWith.call(this, replace); // Call replaceWith
    if (typeof callback === "function") callback.call(ret); // Call your callback
    return ret; // For chaining
};
let $c4df93a4feca97f3$var$reset = false;
const $c4df93a4feca97f3$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $c4df93a4feca97f3$var$getActiveFuelTypes() {
    const greenButtons = $("[data-fuel-type] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
//sorting the results
function $c4df93a4feca97f3$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("new-running-cost-sort");
    const sortByEl = $("#SortBy");
    const sortDescEl = $("#SortDesc");
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy !== newSortBy || sortDesc.toLowerCase() === "true") sortDescEl.val("false");
    else sortDescEl.val("true");
    window.updateCarRunningCostResults();
}
function $c4df93a4feca97f3$var$getData(page) {
    const operatingCycleId = $("#OperatingCycleId").val();
    const vehicleGroupId = $("#VehicleGroupId").val();
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const miles = $("#Miles").val();
    const years = $("#Years").val();
    const manufacturer = $("#Manufacturer").val();
    const model = $("#Model").val();
    const carType = $("#CarType").val();
    const co2From = $("#CO2From").val();
    const co2To = $("#CO2To").val();
    const bikPriceFrom = $("#BIKPriceFrom").val();
    const bikPriceTo = $("#BIKPriceTo").val();
    const sortBy = $("#SortBy").val();
    const sortDesc = $("#SortDesc").val();
    const fuelType = $c4df93a4feca97f3$var$getActiveFuelTypes();
    return {
        OperatingCycleId: operatingCycleId,
        VehicleGroupId: vehicleGroupId,
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Miles: miles,
        Years: years,
        Manufacturer: manufacturer,
        Model: model,
        CarType: carType,
        BIKPriceFrom: bikPriceFrom,
        BIKPriceTo: bikPriceTo,
        CO2From: co2From,
        CO2To: co2To,
        SortBy: sortBy,
        SortDesc: sortDesc,
        FuelType: fuelType,
        P: page
    };
}
function $c4df93a4feca97f3$var$buildUpQueryString(data) {
    let queryString = "";
    const operatingCycleDefault = $("#OperatingCycleId option").eq(0).val();
    if (data.OperatingCycleId !== operatingCycleDefault) {
        if (queryString.length > 0) queryString += "&";
        queryString += `Years=${data.Years}&Miles=${data.Miles}`;
    }
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.VehicleGroupId) > 0) queryString += `CarType=${data.CarType}`;
    else queryString += "CarType=";
    if (queryString.length > 0) queryString += "&";
    queryString += `Manufacturer=${data.Manufacturer}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `Model=${data.Model}`;
    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += `p=${data.P}`;
    }
    if (queryString.length > 0) queryString += "&";
    queryString += `CO2From=${data.CO2From}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `CO2To=${data.CO2To}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `BIKPriceFrom=${data.BIKPriceFrom}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `BIKPriceTo=${data.BIKPriceTo}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SortBy=${data.SortBy}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SortDesc=${data.SortDesc}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `FuelType=${data.FuelType}`;
    return `?${queryString}`;
}
//asc & desc sorting
function $c4df93a4feca97f3$var$applyResultsSortArrows() {
    const sortBy = $("#SortBy").val();
    $(`[data-new-running-cost-sort=${sortBy}]`).attr("style", "background: url('/Themes/FleetNews/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $("#SortDesc").val();
    if (sortDesc.toLowerCase() === "true") $(`[data-new-running-cost-sort=${sortBy}]`).attr("style", "background: url('/Themes/FleetNews/Content/Images/top-desc.png') no-repeat right center;");
}
//load the datatable for low res
function $c4df93a4feca97f3$var$loadAsDataTable() {
    const table = $("#new-running-costs").DataTable({
        // responsive: {
        //     breakpoints: [
        //         ]
        // },
        responsive: true,
        "ordering": false,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function(oSettings) {
            $(".dataTables_paginate").hide();
        }
    });
    //Check spacer when datatable responsive display collapsed (hide)
    table.on("responsive-display.dt", function(e, datatable, row, showHide, update) {
        $c4df93a4feca97f3$var$resetSpacersSize();
    });
}
function $c4df93a4feca97f3$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $c4df93a4feca97f3$var$updateResultsLogic(page) {
    const data = $c4df93a4feca97f3$var$getData(page);
    var returnUrl = "/Identity/Account/Login?returnUrl=" + location.pathname + $c4df93a4feca97f3$var$buildUpQueryString(data);
    $c4df93a4feca97f3$var$History.pushState(data, $("title").html(), location.pathname + $c4df93a4feca97f3$var$buildUpQueryString(data));
//setTimeout(function () {
//    $('[data-tco-login-link]').attr('href', returnUrl);
//}, 1000);
}
function $c4df93a4feca97f3$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] === "p";
    })[0].split("=")[1];
}
function $c4df93a4feca97f3$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/cap-manufacturer-url/${manId}`, function(response) {
                $("#Manufacturer").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Manufacturer";
            })[0].split("=")[1];
            $("#Manufacturer").val(manufacturer);
        }
    }
}
function $c4df93a4feca97f3$var$setCarType(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("VehicleGroupId") > 1) {
            const vehicleGroupId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "VehicleGroupId";
            })[0].split("=")[1];
            $.get(`/cap-car-type-url/${vehicleGroupId}`, function(response) {
                $("#CarType").val(response);
            });
        } else if (href.indexOf("CarType") > 1) {
            const carType = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "CarType";
            })[0].split("=")[1];
            $("#CarType").val(carType);
        }
    }
}
function $c4df93a4feca97f3$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/cap-model-url/${manufacturerId}/${modelId}`, function(response) {
                $("#Model").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Model";
            })[0].split("=")[1];
            $("#Model").val(model);
        }
    }
}
function $c4df93a4feca97f3$var$setOperatingCycle() {
    $.get(`/cap-operating-cycles/miles/${$("#DefaultOperatingCycleId").val()}`, function(response) {
        $("#Miles").val(response);
    });
    $.get(`/cap-operating-cycles/years/${$("#DefaultOperatingCycleId").val()}`, function(response) {
        $("#Years").val(response);
    });
}
function $c4df93a4feca97f3$var$setupMpus() {
    if (window.location.pathname === "/car-running-costs-calculator" && window.location.search !== "") {
        if ($("#mpus").length) $("#mpus").remove();
        if ($("#running-cost-mobile-mpu").length) $("#running-cost-mobile-mpu").remove();
    }
}
function $c4df93a4feca97f3$var$showHideDetail() {
    const $this = $(this);
    let id = $this.attr("href");
    let collapsibleElement = document.querySelector(id);
    if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
    if (collapsibleElement) {
        if (!collapsibleElement.dataset.eventInitiated) collapsibleElement.addEventListener("shown.bs.collapse", function(e) {
            this.dataset.eventInitiated = true;
            let spacer = $(collapsibleElement).closest("tr").next("tr.spacer");
            if (spacer) spacer.find("td").attr("height", $(this).height());
        });
    }
    const currentText = $.trim($this.text());
    const row = $this.closest("tr");
    let currentSpacer = $this.closest("table").find('.spacer[data-id="' + id + '"]');
    const rowHeight = row.height();
    if (currentText === "View data") {
        $this.text("Hide data");
        const takeOverClass = $("body").attr("class");
        if (currentSpacer.length < 1) {
            if (window.isViewportGreaterThanOrEqualTo("xl")) {
                if (takeOverClass === "takeover-active desktop-takeover") row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="195"></td></tr>');
                else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="175"></td></tr>');
            } else if (window.getViewportSize() == "lg") {
                if (rowHeight > 40) {
                    if (takeOverClass === "takeover-active desktop-takeover") row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="165"></td></tr>');
                    else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="145"></td></tr>');
                } else if (takeOverClass === "takeover-active desktop-takeover") row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="195"></td></tr>');
                else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="175"></td></tr>');
            } else if (window.getViewportSize() == "md") {
                if (takeOverClass === "takeover-active desktop-takeover") row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="210"></td></tr>');
                else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="190"></td></tr>');
            } else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="350"></td></tr>');
        }
    } else {
        $this.text("View data");
        currentSpacer.remove();
    }
    $c4df93a4feca97f3$var$resetSpacersSize();
}
function $c4df93a4feca97f3$var$markAsLoading() {
    let container = $("#new-running-cost-results-container");
    container.height(container.height()); // set the height to stop moving on large desktop
    container.text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $c4df93a4feca97f3$var$pageData(event) {
    event.preventDefault();
    //markAsLoading();
    if ($(this).attr("href") === undefined) return;
    const page = $c4df93a4feca97f3$var$getPage($(this).attr("href"));
    $c4df93a4feca97f3$var$updateResultsLogic(page);
}
function $c4df93a4feca97f3$var$checkIsDigitsOnly(e) {
    //if the letter is not digit then display error and don't type anything
    if (e.which !== 8 && e.which !== 0 && e.which !== 13 && (e.which < 48 || e.which > 57)) {
        //display error message
        const id = $(e.target).attr("id");
        $(`[data-error="${id}"]`).html("digits only").show().fadeOut("slow");
        return false;
    }
}
//adding to compare list
function $c4df93a4feca97f3$var$addVehicle(id, callback) {
    $.get(`/compare-list/handle/add/${id}`, function(response) {
        let success;
        if (response === 0) success = true;
        else if (response === 1) {
            alert("Maximum of 5 vehicles.");
            success = false;
        } else if (response === 2) success = true;
        else {
            alert("Error");
            success = false;
        }
        if (callback) callback(success);
    });
//$("html, body").animate({ scrollTop: 0 }, "slow");
}
function $c4df93a4feca97f3$var$removeVehicle(id, callback) {
    $.get(`/compare-list/handle/remove/${id}`, function(response) {
        const success = response === 0;
        if (callback) callback(success);
    });
}
function $c4df93a4feca97f3$var$reloadQuery() {
    const State = $c4df93a4feca97f3$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/new-running-cost/query", State.data, function(response) {
        $("#new-running-cost-query-container").replaceWith(response);
        $c4df93a4feca97f3$var$handleBodyCopyToggle();
    });
    $.get("/new-running-cost/bottom-seo", State.data, function(response) {
        $("#new-running-cost-seo-container").replaceWith(response);
        $c4df93a4feca97f3$var$handleBodyCopyToggle();
    });
//$('html,body').animate({
//        scrollTop: $(".actual-filters-con").offset().top
//    },
//    'slow');
}
function $c4df93a4feca97f3$var$markAsToAdd(btn) {
    btn.removeClass().addClass("btn btn-green btn-block w-100").text("Add to compare");
}
function $c4df93a4feca97f3$var$markAsToRemove(btn) {
    btn.html(btn.data("original-text"));
    btn.addClass("added");
    btn.text("Comparing");
}
function $c4df93a4feca97f3$var$updateCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("new-compare-list-add-id");
    const btn = $(event.target);
    if (!btn.data("original-text")) btn.data("original-text", btn.html());
    const btnClass = $(this).attr("class");
    btn.html("<img src='/Themes/FleetNews/Content/Images/loading.png'/>");
    if (btnClass.indexOf("added") > 1) $c4df93a4feca97f3$var$removeVehicle(data, function(success) {
        if (success) {
            $c4df93a4feca97f3$var$markAsToAdd(btn);
            $c4df93a4feca97f3$var$reloadQuery();
        } else $c4df93a4feca97f3$var$markAsToRemove(btn);
        $c4df93a4feca97f3$var$reloadQuery();
    });
    else $c4df93a4feca97f3$var$addVehicle(data, function(success) {
        if (success) {
            $c4df93a4feca97f3$var$markAsToRemove(btn);
            $("html, body").animate({
                scrollTop: 0
            }, "slow");
            $c4df93a4feca97f3$var$reloadQuery();
        } else $c4df93a4feca97f3$var$markAsToAdd(btn);
    });
//setTimeout(function () { fuelTypeButtons(); }, 800);
}
function $c4df93a4feca97f3$var$onChangeFilters(event) {
    //markAsLoading();
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "OperatingCycleId") {
        const id = $(this).val();
        $.get(`/cap-operating-cycles/miles/${id}`, function(response) {
            $("#Miles").val(response);
            $.get(`/cap-operating-cycles/years/${id}`, function(response) {
                $("#Years").val(response);
                window.updateCarRunningCostResults();
            });
        });
    } else if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#Model").val("");
        if (parseInt($(this).val()) > 0) $.get(`/cap-manufacturer-url/${$(this).val()}`, function(response) {
            $("#Manufacturer").val(response);
            window.updateCarRunningCostResults();
        });
        else {
            $("#Manufacturer").val("");
            window.updateCarRunningCostResults();
        }
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get(`/cap-manufacturer-url/${$("#ManufacturerId").val()}`, function(response) {
                $("#Manufacturer").val(response);
            });
            $.get(`/cap-model-url/${$("#ManufacturerId").val()}/${$(this).val()}`, function(response) {
                $("#Model").val(response);
                window.updateCarRunningCostResults();
            });
        } else {
            $("#Model").val("");
            window.updateCarRunningCostResults();
        }
    } else if (currentDropdown === "VehicleGroupId") {
        $("#ModelGroupId").val("");
        if (parseInt($("#VehicleGroupId").val()) > 0) $.get(`/cap-car-type-url/${$("#VehicleGroupId").val()}`, function(response) {
            $("#CarType").val(response);
            window.updateCarRunningCostResults();
        });
        else {
            $("#CarType").val("");
            window.updateCarRunningCostResults();
        }
    } else window.updateCarRunningCostResults();
}
function $c4df93a4feca97f3$var$updateFuelTypes(event) {
    //markAsLoading();
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateCarRunningCostResults();
}
function $c4df93a4feca97f3$var$updateState() {
    $c4df93a4feca97f3$var$markAsLoading();
    $c4df93a4feca97f3$var$reloadQuery();
    const State = $c4df93a4feca97f3$var$History.getState();
    $.get("/new-running-cost/results", State.data, function(response) {
        $("#new-running-cost-results-container").replaceWith(response);
        $("#new-running-cost-results-container input[name^='comparelist']").each(function() {
            const compareListId = $(this).val();
            $(`[data-new-compare-list-add-id=${compareListId}]`).addClass("added").text("Comparing");
        });
        $c4df93a4feca97f3$var$loadAsDataTable();
        $c4df93a4feca97f3$var$applyResultsSortArrows();
        if ($c4df93a4feca97f3$var$reset) {
            $("[data-no-results]").hide();
            $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a car type or make above to start your search</div>");
            $c4df93a4feca97f3$var$reset = false;
        }
    }).done(function() {
        setTimeout(function() {
            // //delay reload until results show, as we are now injecting ads into content
            const adSection = $("[data-ad-id]");
            // //push slots
            //
            const page = window.getDFPAdsPage(adSection);
            // window.getDFPAds(page);
            // if (page.adSlots['leaderboard-2'] === undefined) {
            //     window.pushAdSlot(page, $("#leaderboard-2-container"));
            // }
            // if (page.adSlots['leaderboard-3'] === undefined) {
            //     window.pushAdSlot(page, $("#leaderboard-3-container"));
            // }
            window.getDFPAds(page, hideIfNoAd);
        }, 250);
    });
    function hideIfNoAd() {
    //the below works but then the even/odd table needs adjusting and more work that worth.
    /* setTimeout(function(){
             let $carrunningcost = $("#carrunningcost-ad-slot-1");   
             const len = $carrunningcost.html().length;
             if (len === 0){
                 $carrunningcost.parent().parent().parent().hide();
             } else {
                 $carrunningcost.parent().parent().parent().show();
             }
         }, 1000);   */ }
}
function $c4df93a4feca97f3$var$resetSpacersSize() {
    $(".spacer[data-id]").each(function() {
        let spacer = $(this);
        let id = spacer.data("id");
        let collapsibleElement = document.querySelector(id);
        if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
        if (collapsibleElement) {
            if (collapsibleElement.offsetParent !== null && $(collapsibleElement).height() > 0) spacer.find("td").attr("height", $(collapsibleElement).height());
            else spacer.remove();
        } else spacer.remove();
    });
}
function $c4df93a4feca97f3$var$handleToggleBtnClick() {
    var toggleBtn = document.getElementById("tco-toggle");
    if (toggleBtn) toggleBtn.addEventListener("click", function(e) {
        e.preventDefault();
        var textDiv = document.getElementById("text");
        if (textDiv.style.maxHeight.replace("px", "") > 19.2) {
            // If block is expanded 
            textDiv.style.maxHeight = "2.8em"; // Collapse it
            this.innerHTML = "Show more +";
        } else {
            textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
            this.innerHTML = "Show less";
        }
    });
}
function $c4df93a4feca97f3$export$332cf1f44c0656c1() {
    if (!$("[data-new-car-running-costs]").length) return;
    $c4df93a4feca97f3$var$setupMpus();
    $c4df93a4feca97f3$var$setOperatingCycle();
    $c4df93a4feca97f3$var$setManufacturer(window.location.href);
    $c4df93a4feca97f3$var$setCarType(window.location.href);
    $c4df93a4feca97f3$var$setModel(window.location.href);
    $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a car type or make above to start your search</div>");
    $("[data-no-results]").hide();
    $c4df93a4feca97f3$var$loadAsDataTable();
    $(document).on("click", "[data-view-detail]", $c4df93a4feca97f3$var$showHideDetail);
    $(document).on("keypress", "[data-digits-only]", $c4df93a4feca97f3$var$checkIsDigitsOnly);
    //add to compare list button click
    $(document).on("click", "[data-new-compare-list-add-id]", $c4df93a4feca97f3$var$updateCompareList);
    //dropdown changes
    $(document).on("change", "[data-new-car-running-costs] input, [data-new-car-running-costs] select", $c4df93a4feca97f3$var$onChangeFilters);
    $(document).on("keypress", "[data-new-car-running-costs] input", function(e) {
        if (e.keyCode === 13) {
            $c4df93a4feca97f3$var$onChangeFilters();
            return false;
        }
    });
    //fuel type button chagnes
    $(document).on("click", "[data-fuel-type] a", $c4df93a4feca97f3$var$updateFuelTypes);
    //paging click
    $(document).on("click", "#new-running-cost-results-container .pagination a", $c4df93a4feca97f3$var$pageData);
    $c4df93a4feca97f3$var$applyResultsSortArrows();
    $(document).on("click", "[data-new-running-cost-sort]", $c4df93a4feca97f3$var$sortResults);
    window.addEventListener("resize", function() {
        $c4df93a4feca97f3$var$resetSpacersSize();
    });
    $(document).on("click", "[data-derivative]", function(e) {
        e.preventDefault();
        let viewDetailsButton = $(this).parents("tr").find("[data-view-detail]");
        if (viewDetailsButton.length) {
            if (window.isViewportLessThan("md")) $(this).closest("tr").find(".dtr-control").trigger("click");
            else {
                let id = viewDetailsButton.attr("href");
                let collapsibleElement = document.querySelector(id);
                if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
                if (collapsibleElement) {
                    viewDetailsButton.toggleClass("collapsed");
                    viewDetailsButton.data("aria-expanded", !viewDetailsButton.data("aria-expanded"));
                    $(collapsibleElement).toggleClass("show");
                    $(this).closest("tr").find("[data-view-detail]").trigger("click");
                }
            }
        }
        $c4df93a4feca97f3$var$resetSpacersSize();
    });
    $("#new-running-cost-results-container input[name^='comparelist']").each(function() {
        const compareListId = $(this).val();
        $(`[data-new-compare-list-add-id=${compareListId}]`).addClass("added").text("Comparing");
    });
    $(document).on("click", "[data-reset-button]", function(event) {
        event.preventDefault();
        //var state = History.getState();
        //markAsLoading();
        $c4df93a4feca97f3$var$History.pushState({}, $("title").html(), location.pathname);
        $c4df93a4feca97f3$var$reset = true;
    });
    window.updateCarRunningCostResults = function() {
        $c4df93a4feca97f3$var$updateResultsLogic(1);
        $c4df93a4feca97f3$var$setupMpus();
    };
    $c4df93a4feca97f3$var$handleToggleBtnClick();
    // Bind to StateChange Event
    $c4df93a4feca97f3$var$History.Adapter.bind(window, "statechange", $c4df93a4feca97f3$var$updateState);
}


let $a51221e90ccfb5f2$var$reset = false;
var $a51221e90ccfb5f2$var$table;
const $a51221e90ccfb5f2$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $a51221e90ccfb5f2$var$getActiveCO2Buttons() {
    const greenButtons = $("[data-co2] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
function $a51221e90ccfb5f2$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $a51221e90ccfb5f2$var$getActiveNOxButtons() {
    const greenButtons = $("[data-urban-NOx] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
//sorting the results
function $a51221e90ccfb5f2$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("air-index-tool-sort");
    const sortByEl = $("#SortBy");
    const sortDescEl = $("#SortDesc");
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy !== newSortBy || sortDesc.toLowerCase() === "true") sortDescEl.val("false");
    else sortDescEl.val("true");
    window.updateAirIndexToolResults();
}
function $a51221e90ccfb5f2$var$getData(page) {
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const manufacturer = $("#Manufacturer").val();
    const model = $("#Model").val();
    const year = $("#Year").val();
    const bodyStyle = $("#BodyStyle").val();
    const engine = $("#Engine").val();
    const co2 = $a51221e90ccfb5f2$var$getActiveCO2Buttons();
    const urbanNOx = $a51221e90ccfb5f2$var$getActiveNOxButtons();
    const searchTerm = $("#SearchTerm").val();
    const sortBy = $("#SortBy").val();
    const sortDesc = $("#SortDesc").val();
    return {
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Manufacturer: manufacturer,
        Model: model,
        Year: year,
        BodyStyle: bodyStyle,
        Engine: engine,
        CO2Rating: co2,
        UrbanNoxRating: urbanNOx,
        SearchTerm: searchTerm,
        SortBy: sortBy,
        SortDesc: sortDesc,
        P: page
    };
}
function $a51221e90ccfb5f2$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += `Manufacturer=${data.Manufacturer}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `Model=${data.Model}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `Year=${data.Year}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `BodyStyle=${data.BodyStyle}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `Engine=${data.Engine}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `CO2Rating=${data.CO2Rating}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `UrbanNOxRating=${data.UrbanNoxRating}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SearchTerm=${data.SearchTerm}`;
    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += `p=${data.P}`;
    }
    if (queryString.length > 0) queryString += "&";
    queryString += `SortBy=${data.SortBy}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SortDesc=${data.SortDesc}`;
    return `?${queryString}`;
}
//asc & desc sorting
function $a51221e90ccfb5f2$var$applyResultsSortArrows() {
    const sortBy = $("#SortBy").val();
    $(`[data-air-index-tool-sort=${sortBy}]`).attr("style", "background: url('/Themes/FleetNews/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $("#SortDesc").val();
    if (sortDesc.toLowerCase() === "true") $(`[data-air-index-tool-sort=${sortBy}]`).attr("style", "background: url('/Themes/FleetNews/Content/Images/top-desc.png') no-repeat right center;");
}
//load the datatable for low res
function $a51221e90ccfb5f2$var$loadAsDataTable() {
    $a51221e90ccfb5f2$var$table = $("#air-index-results-table").DataTable({
        "columns": [
            {
                "className": "dt-control",
                "orderable": false,
                "data": null,
                "defaultContent": ""
            },
            {
                "data": "make"
            },
            {
                "data": "fuel"
            },
            {
                "data": "year"
            },
            {
                "data": "engine"
            },
            {
                "data": "bhp"
            },
            {
                "data": "euro"
            },
            {
                "data": "co2"
            },
            {
                "data": "nox"
            },
            {
                "data": "compare"
            }
        ],
        "order": [
            [
                1,
                "asc"
            ]
        ],
        searching: false,
        paging: false,
        "info": false,
        responsive: true,
        "ordering": false
    });
//const table = $('#air-index-results-table').DataTable({
//    "columns": [
//        {
//            "className": 'dt-control',
//            "orderable": false,
//            "data": null,
//            "defaultContent": ''
//        },
//        { "data": "make" },
//        { "data": "fuel" },
//        { "data": "year" },
//        { "data": "engine" },
//        { "data": "bhp" },
//        { "data": "euro" },
//        { "data": "co2" },
//        { "data": "nox" },
//        { "data": "compare" }
//    ],
//    "order": [[1, 'asc']],
//    searching: false,
//    paging: false,
//    "info": false,
//    responsive: true
//});
}
function $a51221e90ccfb5f2$var$updateResultsLogic(page) {
    const data = $a51221e90ccfb5f2$var$getData(page);
    $a51221e90ccfb5f2$var$History.pushState(data, $("title").html(), location.pathname + $a51221e90ccfb5f2$var$buildUpQueryString(data));
//hideInitialBodyContent();
}
function $a51221e90ccfb5f2$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] === "p";
    })[0].split("=")[1];
}
function $a51221e90ccfb5f2$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/manufacturer-url/${manId}`, function(response) {
                $("#Manufacturer").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Manufacturer";
            })[0].split("=")[1];
            $("#Manufacturer").val(manufacturer);
        }
    }
}
function $a51221e90ccfb5f2$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/model-url/${manufacturerId}/${modelId}`, function(response) {
                $("#Model").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Model";
            })[0].split("=")[1];
            $("#Model").val(model);
        }
    }
}
function $a51221e90ccfb5f2$var$markAsLoading() {
    $("#air-index-tool-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $a51221e90ccfb5f2$var$pageData(event) {
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $a51221e90ccfb5f2$var$getPage($(this).attr("href"));
    $a51221e90ccfb5f2$var$updateResultsLogic(page);
}
//adding to compare list
function $a51221e90ccfb5f2$var$addVehicle(id, callback) {
    $.get(`/emissions-data/compare-list/handle/add/${id}`, function(response) {
        let success;
        if (response === 0) success = true;
        else if (response === 1) {
            alert("Maximum of 5 vehicles.");
            success = false;
        } else if (response === 2) success = true;
        else {
            alert("Error");
            success = false;
        }
        if (callback) callback(success);
    });
}
function $a51221e90ccfb5f2$var$removeVehicle(id, callback) {
    $.get(`/emissions-data/compare-list/handle/remove/${id}`, function(response) {
        const success = response === 0;
        if (callback) callback(success);
    });
}
function $a51221e90ccfb5f2$var$reloadQuery() {
    const State = $a51221e90ccfb5f2$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/emissions-data/query", State.data, function(response) {
        $("#air-index-tool-query-container").replaceWith(response);
        $a51221e90ccfb5f2$var$handleBodyCopyToggle();
    });
}
function $a51221e90ccfb5f2$var$markAsToAdd(btn) {
    btn.removeClass().addClass("btn btn-green btn-block w-100").text("Compare");
}
function $a51221e90ccfb5f2$var$markAsToRemove(btn) {
    btn.html(btn.data("original-text"));
    btn.addClass("added");
    btn.text("Comparing");
}
function $a51221e90ccfb5f2$var$updateCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("air-index-compare-list-add-id");
    const btn = $(event.target);
    if (!btn.data("original-text")) btn.data("original-text", btn.html());
    const btnClass = $(this).attr("class");
    btn.html("<img src='/Themes/FleetNews/Content/Images/loading.png'/>");
    if (btnClass.indexOf("added") > 1) $a51221e90ccfb5f2$var$removeVehicle(data, function(success) {
        if (success) {
            $a51221e90ccfb5f2$var$markAsToAdd(btn);
            $a51221e90ccfb5f2$var$reloadQuery();
        } else $a51221e90ccfb5f2$var$markAsToRemove(btn);
        $a51221e90ccfb5f2$var$reloadQuery();
    });
    else $a51221e90ccfb5f2$var$addVehicle(data, function(success) {
        if (success) {
            $a51221e90ccfb5f2$var$markAsToRemove(btn);
            $("html, body").animate({
                scrollTop: $("#air-index-tool-query-container").offset().top
            }, "slow");
            $a51221e90ccfb5f2$var$reloadQuery();
        } else $a51221e90ccfb5f2$var$markAsToAdd(btn);
    });
}
function $a51221e90ccfb5f2$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#Model").val("");
        $.get(`/manufacturer-url/${$(this).val()}`, function(response) {
            $("#Manufacturer").val(response);
            window.updateAirIndexToolResults();
        });
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get(`/manufacturer-url/${$("#ManufacturerId").val()}`, function(response) {
                $("#Manufacturer").val(response);
            });
            $.get(`/model-url/${$("#ManufacturerId").val()}/${$(this).val()}`, function(response) {
                $("#Model").val(response);
                window.updateAirIndexToolResults();
            });
        } else {
            $("#Model").val("");
            window.updateAirIndexToolResults();
        }
    } else window.updateAirIndexToolResults();
}
function $a51221e90ccfb5f2$var$updateCO2Buttons(event) {
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateAirIndexToolResults();
}
function $a51221e90ccfb5f2$var$updateUrbanNOxButtons(event) {
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateAirIndexToolResults();
}
function $a51221e90ccfb5f2$var$updateState() {
    $a51221e90ccfb5f2$var$markAsLoading();
    $a51221e90ccfb5f2$var$reloadQuery();
    const State = $a51221e90ccfb5f2$var$History.getState();
    $.get("/emissions-data/results", State.data, function(response) {
        $("#air-index-tool-results-container").replaceWith(response);
        $("#air-index-tool-results-container input[name^='comparelist']").each(function() {
            const compareListId = $(this).val();
            $(`[data-air-index-compare-list-add-id=${compareListId}]`).addClass("added").text("Comparing");
        });
        $a51221e90ccfb5f2$var$loadAsDataTable();
        $a51221e90ccfb5f2$var$applyResultsSortArrows();
        if ($a51221e90ccfb5f2$var$reset) {
            $("[data-no-results]").hide();
            $("#initial-result").html("<div class='alert alert-warning margin-top-15'>Your results will appear here - please choose a filter from above to start your search</div>");
            $a51221e90ccfb5f2$var$reset = false;
        }
    //hideInitialBodyContent(true);
    });
}
function $a51221e90ccfb5f2$var$oneDecimalPlace(x) {
    return Number.parseFloat(x).toFixed(1);
}
/* Formatting function for row details - modify as you need */ function $a51221e90ccfb5f2$var$format(id) {
    var jqXHR = $.ajax({
        url: `/emissions-data/get/${id}`,
        type: "GET",
        async: false
    });
    const obj = JSON.parse(jqXHR.responseText);
    var details = $.ajax({
        url: `/emissions-data/get-url/${id}`,
        type: "GET",
        async: false
    });
    var airco2Rating = "";
    var co2RatingStandard = "";
    if (obj.airCO2Rating === "A") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-a">' + obj.airCO2Rating + "</span></div>";
        co2RatingStandard = "0 - 95 g/km";
    } else if (obj.airCO2Rating === "B") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-b">' + obj.airCO2Rating + "</span></div>";
        co2RatingStandard = "95 - 130 g/km";
    } else if (obj.airCO2Rating === "C") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-c">' + obj.airCO2Rating + "</span></div>";
        co2RatingStandard = "130 - 180 g/km";
    } else if (obj.airCO2Rating === "D") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-d">' + obj.airCO2Rating + "</span></div>";
        co2RatingStandard = "180 - 230 g/km";
    } else if (obj.airCO2Rating === "E") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-e">' + obj.airCO2Rating + "</span></div>";
        co2RatingStandard = "230+ g/km";
    }
    var urbanNoxRating = "";
    var urbanNoxStandardRating = "";
    if (obj.airUrbanNoxRating === "A") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-a">' + obj.airUrbanNoxRating + "</span></div>";
        urbanNoxStandardRating = "0 - 80 mg/km";
    } else if (obj.airUrbanNoxRating === "B") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-b">' + obj.airUrbanNoxRating + "</span></div>";
        urbanNoxStandardRating = "80 - 168 mg/km";
    } else if (obj.airUrbanNoxRating === "C") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-c">' + obj.airUrbanNoxRating + "</span></div>";
        urbanNoxStandardRating = "168 - 270 mg/km";
    } else if (obj.airUrbanNoxRating === "D") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-d">' + obj.airUrbanNoxRating + "</span></div>";
        urbanNoxStandardRating = "270 - 600 mg/km";
    } else if (obj.airUrbanNoxRating === "E") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-e">' + obj.airUrbanNoxRating + "</span></div>";
        urbanNoxStandardRating = "600+ mg/km";
    }
    var mobileData = "";
    if (window.isViewportLessThan("md")) mobileData = '<tr class="d-md-none"><td>Fuel</td><td>' + obj.fuelType + "</td>" + "</tr>" + '<tr class="d-md-none">' + "<td>Year</td>" + "<td>" + obj.modelYear + "</td>" + "</tr>" + '<tr class="d-md-none">' + "<td>Engine</td>" + "<td>" + obj.engineCC + "cc</td>" + "</tr>" + '<tr class="d-md-none">' + "<td>BHP</td>" + "<td>" + obj.powerBhp + "bhp</td>" + "</tr>" + '<tr class="d-md-none">' + "<td>Euro</td>" + "<td>" + obj.euroStage + "</td>" + "</tr>";
    var extraData = "";
    if (obj.officialNedcMpg != null) extraData += "<tr><td>Official NEDC mpg</td><td>" + $a51221e90ccfb5f2$var$oneDecimalPlace(obj.officialNedcMpg) + " mpg</td>" + "</tr>";
    if (obj.officialWltpMpg != null) extraData += "<tr><td>Official WLTP mpg</td><td>" + $a51221e90ccfb5f2$var$oneDecimalPlace(obj.officialWltpMpg) + " mpg</td>" + "</tr>";
    return '<div class="row additional-air-index-info"><div class="col-md-4"><table class="table">' + mobileData + '<tr class="drive">' + "<td>Drive</td>" + "<td>" + obj.driveTrain + "</td>" + "</tr>" + "<tr>" + "<td>Body type</td>" + "<td>" + obj.bodyStyle + "</td>" + "</tr>" + "<tr>" + "<td>Transmission</td>" + "<td>" + obj.transmission + "</td>" + "</tr>" + "<tr>" + "<td>Engine (Litres)</td>" + "<td>" + obj.engineL + "</td>" + "</tr>" + "<tr>" + "<td>Power</td>" + "<td>" + obj.powerPS + "bhp</td>" + "</tr>" + "<tr>" + "<td>Predicted fuel economy</td>" + "<td>" + $a51221e90ccfb5f2$var$oneDecimalPlace(obj.airMpg) + " mpg<br/>" + $a51221e90ccfb5f2$var$oneDecimalPlace(obj.fuelEconomy) + " litres/100km</td>" + "</tr>" + extraData + "</table>" + '<a href="' + details.responseText + '" class="btn btn-primary mb-3">More details</a>' + "</div>" + '<div class="col-md-4 px-lg-3 px-md-4">' + '<div class="mb-3">' + "<h4>Carbon dioxide (CO2)</h4>" + "</div>" + '<div class="mb-3">' + airco2Rating + '<div class="float-start">' + '<div class="margin-bottom-10">' + "<strong>Air Index range</strong> " + "<br/>" + co2RatingStandard + "</div>" + "<strong>Official rating</strong>" + "<br/>" + "" + obj.officialCO2 + " g/km " + "</div>" + '<div class="clearfix"></div>' + "</div>" + '<div class="mb-2 mb-md-0"><strong> What is CO2? </strong> <br/> <small>Vehicles produce CO2 when they use fuel. The amount of CO2 produced is directly linked to how much fuel it consumes. Excess levels of CO2 can be harmful to humans and the environment.</small><br/></div><hr class="visible-xs"/>' + "</div>" + '<div class="col-md-4">' + '<div class="mb-3">' + "<h4>Urban NOx</h4>" + "</div>" + '<div class="mb-3">' + urbanNoxRating + '<div class="float-start">' + '<div class="mb-2">' + "<strong>Air Index range</strong> " + "<br/>" + urbanNoxStandardRating + "</div>" + "</div>" + '<div class="clearfix"></div>' + "</div>" + '<div class="mb-2 mb-md-0"><strong> What is Urban NOx? </strong> <br/> <small>NOx refers to nitric oxide and nitrogen dioxide. They are released from vehicle engines and can reach harmful levels in towns and cities. They are an irritant and cause inflammation of the airways.</small><br/></div>' + "</div>" + "</div>";
}
function $a51221e90ccfb5f2$var$checkBodyContent(text) {
    if (text === "Show more") {
        $("#data-air-index-body p:not(:first-child)").show(500);
        $("[data-air-index-tool-toggle]").text("Show less");
    } else {
        $("#data-air-index-body p:not(:first-child)").hide(500);
        $("[data-air-index-tool-toggle]").text("Show more");
    }
}
function $a51221e90ccfb5f2$export$1254953e51e11fff() {
    if (!$("[data-air-index-tool]").length) return;
    //hideInitialBodyContent(false);
    $(document).on("click", "[data-air-index-tool-toggle]", function(e) {
        e.preventDefault();
        var text = $(this).text();
        $a51221e90ccfb5f2$var$checkBodyContent(text);
    });
    $(document).on("click", "[data-showing-cars]", function(e) {
        e.preventDefault();
        $("html, body").animate({
            scrollTop: $("#air-index-tool-results-container").offset().top - 120
        }, "slow");
    });
    $(".slider4").bxSlider({
        slideWidth: 400,
        minSlides: 2,
        maxSlides: 3,
        moveSlides: 3,
        slideMargin: 30,
        pager: true
    });
    $(document).on("click", "#air-index-results-table tbody td.dt-control", function() {
        var tr = $(this).closest("tr");
        var row = $a51221e90ccfb5f2$var$table.row(tr);
        var selectedRow = $(this);
        var itemId = selectedRow.data("item-id");
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass("shown");
        } else {
            // Open this row
            row.child($a51221e90ccfb5f2$var$format(itemId)).show();
            tr.addClass("shown");
        }
    //if (row.child.isShown()) {
    //    if (window.isViewportLessThan('md')) {
    //        // Open this row
    //        row.child(format(itemId)).show();
    //        tr.addClass('shown');
    //    } else {
    //        // This row is already open - close it
    //        row.child.hide();
    //        tr.removeClass('shown');
    //    }
    //}
    //else {
    //    if (window.isViewportLessThan('md')) {
    //        // This row is already open - close it
    //        row.child.hide();
    //        tr.removeClass('shown');
    //    } else {
    //        // Open this row
    //        row.child(format(itemId)).show();
    //        tr.addClass('shown');
    //    }
    //}
    });
    $(document).on("click", "#air-index-results-table tbody td a.data-more-details", function(e) {
        e.preventDefault();
        var tr = $(this).closest("tr");
        var row = $a51221e90ccfb5f2$var$table.row(tr);
        var selectedRow = $(this);
        var itemId = selectedRow.data("item-id");
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass("shown");
        } else {
            // Open this row
            row.child($a51221e90ccfb5f2$var$format(itemId)).show();
            tr.addClass("shown");
        }
    });
    $a51221e90ccfb5f2$var$setManufacturer(window.location.href);
    $a51221e90ccfb5f2$var$setModel(window.location.href);
    $("#initial-result").html("<div class='alert alert-warning margin-top-15'>Your results will appear here - please choose a filter from above to start your search</div>");
    $("[data-no-results]").hide();
    $a51221e90ccfb5f2$var$loadAsDataTable();
    //$(document).on("click", "[data-view-detail]", showHideDetail);
    //add to compare list button click
    $(document).on("click", "[data-air-index-compare-list-add-id]", $a51221e90ccfb5f2$var$updateCompareList);
    //dropdown changes
    $(document).on("change", "[data-air-index-tool] input, [data-air-index-tool] select", $a51221e90ccfb5f2$var$onChangeFilters);
    $(document).on("keypress", "[data-air-index-tool] input", function(e) {
        if (e.keyCode === 13) {
            $a51221e90ccfb5f2$var$onChangeFilters();
            return false;
        }
    });
    //co2 button changes
    $(document).on("click", "[data-co2] a", $a51221e90ccfb5f2$var$updateCO2Buttons);
    //urban NOx button changes
    $(document).on("click", "[data-urban-NOx] a", $a51221e90ccfb5f2$var$updateUrbanNOxButtons);
    //paging click
    $(document).on("click", "#air-index-tool-results-container .pagination a", $a51221e90ccfb5f2$var$pageData);
    $a51221e90ccfb5f2$var$applyResultsSortArrows();
    $(document).on("click", "[data-air-index-tool-sort]", $a51221e90ccfb5f2$var$sortResults);
    $(document).on("click", "[data-reset-button]", function(event) {
        event.preventDefault();
        $a51221e90ccfb5f2$var$History.pushState({}, $("title").html(), location.pathname);
        $a51221e90ccfb5f2$var$reset = true;
    });
    window.updateAirIndexToolResults = function() {
        $a51221e90ccfb5f2$var$updateResultsLogic(1);
    };
    // Bind to StateChange Event
    $a51221e90ccfb5f2$var$History.Adapter.bind(window, "statechange", $a51221e90ccfb5f2$var$updateState);
}


const $3bc885c99072932d$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $3bc885c99072932d$var$getData(page) {
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const carType = $("#CarGroup").val();
    const rangeFrom = $("#RangeFrom").val();
    const rangeTo = $("#RangeTo").val();
    const priceFrom = $("#PriceFrom").val();
    const priceTo = $("#PriceTo").val();
    const sortBy = $("#Sorting").val();
    return {
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        ManufacturerName: manufacturerName,
        ModelName: modelName,
        CarType: carType,
        RangeFrom: rangeFrom,
        RangeTo: rangeTo,
        PriceFrom: priceFrom,
        PriceTo: priceTo,
        SortBy: sortBy,
        P: page
    };
}
function $3bc885c99072932d$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $3bc885c99072932d$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += `Manufacturer=${data.ManufacturerName}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `Model=${data.ModelName}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `CarType=${data.CarType}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `RangeFrom=${data.RangeFrom}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `RangeTo=${data.RangeTo}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `PriceFrom=${data.PriceFrom}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `PriceTo=${data.PriceTo}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SortBy=${data.SortBy}`;
    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += `p=${data.P}`;
    }
    return `?${queryString}`;
}
function $3bc885c99072932d$var$updateResultsLogic(page) {
    const data = $3bc885c99072932d$var$getData(page);
    $3bc885c99072932d$var$History.pushState(data, $("title").html(), location.pathname + $3bc885c99072932d$var$buildUpQueryString(data));
}
function $3bc885c99072932d$var$getPage(href) {
    const querystring = href.split("?")[1];
    console.log("EV querystring: " + querystring);
    if (!querystring) return null; // or some default value
    const parts = querystring.split("&");
    console.log("EV parts: " + parts);
    const pageParam = $.grep(parts, function(el) {
        return el.split("=")[0] === "page";
    });
    if (!pageParam.length) return null; // or some default value
    return pageParam[0].split("=")[1];
}
function $3bc885c99072932d$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/manufacturer-url/${manId}`, function(response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Manufacturer";
            })[0].split("=")[1];
            $("#ManufacturerName").val(manufacturer);
        }
    }
}
function $3bc885c99072932d$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/electric-model-url/${manufacturerId}/${modelId}`, function(response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Model";
            })[0].split("=")[1];
            $("#ModelName").val(model);
        }
    }
}
function $3bc885c99072932d$var$setCarType(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("CarType") > 1) {
            const carType = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "CarType";
            })[0].split("=")[1];
            $("#CarGroup").val(carType);
        }
    }
}
function $3bc885c99072932d$var$setRange(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("RangeFrom") > 1) {
            const rangeFrom = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "RangeFrom";
            })[0].split("=")[1];
            $("#RangeFrom").val(rangeFrom);
        }
        if (href.indexOf("RangeTo") > 1) {
            const rangeTo = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "RangeTo";
            })[0].split("=")[1];
            $("#RangeTo").val(rangeTo);
        }
    }
}
function $3bc885c99072932d$var$setPrice(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("PriceFrom") > 1) {
            const priceFrom = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "PriceFrom";
            })[0].split("=")[1];
            $("#PriceFrom").val(priceFrom);
        }
        if (href.indexOf("PriceTo") > 1) {
            const priceTo = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "PriceTo";
            })[0].split("=")[1];
            $("#PriceTo").val(priceTo);
        }
    }
}
function $3bc885c99072932d$var$markAsLoading() {
    $("#electric-vehicles-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $3bc885c99072932d$var$pageData(event) {
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $3bc885c99072932d$var$getPage($(this).attr("href"));
    $3bc885c99072932d$var$updateResultsLogic(page);
}
function $3bc885c99072932d$var$reloadQuery() {
    const State = $3bc885c99072932d$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/electric-vehicles/query", State.data, function(response) {
        $("#electric-vehicles-query-container").replaceWith(response);
        $3bc885c99072932d$var$setupPriceSlider();
        $3bc885c99072932d$var$setupRangeSlider();
        $3bc885c99072932d$var$handleBodyCopyToggle();
    });
}
function $3bc885c99072932d$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#ModelName").val("");
        if (parseInt($(this).val()) > 0) $.get(`/manufacturer-url/${$(this).val()}`, function(response) {
            $("#ManufacturerName").val(response);
            window.updateElectricVehicles();
        });
        else {
            $("#ManufacturerName").val("");
            window.updateElectricVehicles();
        }
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get(`/manufacturer-url/${$("#ManufacturerId").val()}`, function(response) {
                $("#ManufacturerName").val(response);
            });
            $.get(`/electric-model-url/${$("#ManufacturerId").val()}/${$(this).val()}`, function(response) {
                $("#ModelName").val(response);
                window.updateElectricVehicles();
            });
        } else {
            $("#ModelName").val("");
            window.updateElectricVehicles();
        }
    } else if (currentDropdown === "CarType") {
        $("#CarGroup").val($(this).val());
        window.updateElectricVehicles();
    } else if (currentDropdown === "SortBy") {
        $("#Sorting").val($(this).val());
        window.updateElectricVehicles();
    } else window.updateElectricVehicles();
}
function $3bc885c99072932d$var$updateState() {
    $3bc885c99072932d$var$markAsLoading();
    $3bc885c99072932d$var$reloadQuery();
    const State = $3bc885c99072932d$var$History.getState();
    $.get("/electric-vehicles/results", State.data, function(response) {
        $("#electric-vehicles-results-container").replaceWith(response);
    //if (reset) {
    //    $('[data-no-results]').hide();
    //    $('#initial-result').html("<div class='alert alert-warning'>Your results will appear here - choose a make above to start your search</div>");
    //    reset = false;
    //}
    });
//$.get('/electric-vehicles/heading', State.data, function (response) {
//    $('#electric-vehicles-heading-container').replaceWith(response);
//});
}
function $3bc885c99072932d$var$setupPriceSlider() {
    let priceFromValue = parseFloat($("#PriceFrom").val());
    let minimum = 10000;
    if (!isNaN(priceFromValue) && priceFromValue !== minimum) minimum = priceFromValue;
    let priceToValue = parseFloat($("#PriceTo").val());
    let maximum = 250000;
    if (!isNaN(priceToValue) && priceToValue !== maximum) maximum = priceToValue;
    let priceSliderInput = document.querySelector("#price-slider-range");
    priceSliderInput.setAttribute("data-old-data", `${minimum},${maximum}`);
    let priceRangeSlider = new rSlider({
        target: "#price-slider-range",
        values: {
            min: 10000,
            max: 250000
        },
        range: true,
        tooltip: true,
        scale: false,
        labels: false,
        step: 500,
        set: [
            minimum,
            maximum
        ],
        onChange: function(values) {
            let oldData = priceSliderInput.getAttribute("data-old-data");
            $("#PriceFrom").val(values.split(",")[0]);
            $("#PriceTo").val(values.split(",")[1]);
            if (oldData !== values) {
                priceSliderInput.setAttribute("data-old-data", `${values}`);
                $3bc885c99072932d$var$onChangeFilters();
            }
        }
    });
}
function $3bc885c99072932d$var$setupRangeSlider() {
    let rangeFromValue = parseFloat($("#RangeFrom").val());
    let minimum = 0;
    if (!isNaN(rangeFromValue) && rangeFromValue !== minimum) minimum = rangeFromValue;
    let rangeToValue = parseFloat($("#RangeTo").val());
    let maximum = 1000;
    if (!isNaN(rangeToValue) && rangeToValue !== maximum) maximum = rangeToValue;
    let rangeSliderInput = document.querySelector("#range-slider-range");
    rangeSliderInput.setAttribute("data-old-data", `${minimum},${maximum}`);
    let rangeSliderRange = new rSlider({
        target: "#range-slider-range",
        values: {
            min: 0,
            max: 1000
        },
        range: true,
        tooltip: true,
        scale: false,
        labels: false,
        step: 10,
        set: [
            minimum,
            maximum
        ],
        onChange: function(values) {
            let oldData = rangeSliderInput.getAttribute("data-old-data");
            $("#RangeFrom").val(values.split(",")[0]);
            $("#RangeTo").val(values.split(",")[1]);
            if (oldData !== values) {
                rangeSliderInput.setAttribute("data-old-data", `${values}`);
                $3bc885c99072932d$var$onChangeFilters();
            }
        }
    });
}
function $3bc885c99072932d$export$e09e8541d6e6379b() {
    if (!$("[data-electric-vehicles]").length) return;
    $3bc885c99072932d$var$setManufacturer(window.location.href);
    $3bc885c99072932d$var$setModel(window.location.href);
    $3bc885c99072932d$var$setRange(window.location.href);
    $3bc885c99072932d$var$setPrice(window.location.href);
    $3bc885c99072932d$var$setCarType(window.location.href);
    $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose a make above to start your search</div>");
    $("[data-no-results]").hide();
    //dropdown changes
    $(document).on("change", "[data-electric-vehicles] input, [data-electric-vehicles] select", $3bc885c99072932d$var$onChangeFilters);
    $(document).on("keypress", "[data-electric-vehicles] input", function(e) {
        if (e.keyCode === 13) {
            $3bc885c99072932d$var$onChangeFilters();
            return false;
        }
    });
    //paging click
    $(document).on("click", "#electric-vehicles-results-container .pagination a", $3bc885c99072932d$var$pageData);
    window.updateElectricVehicles = function() {
        $3bc885c99072932d$var$updateResultsLogic(1);
    };
    // Bind to StateChange Event
    $3bc885c99072932d$var$History.Adapter.bind(window, "statechange", $3bc885c99072932d$var$updateState);
    $3bc885c99072932d$var$setupPriceSlider();
    $3bc885c99072932d$var$setupRangeSlider();
}


function $ff2e9cac1156f2ea$var$setFuelPriceDate(event) {
    event.preventDefault();
    $(event.target).parents("form").submit();
}
function $ff2e9cac1156f2ea$var$drawChart(serverData) {
    var data = google.visualization.arrayToDataTable(serverData);
    var options = {
        title: "Nationwide average fuel price per litre (pence)",
        curveType: "function",
        legend: {
            position: "bottom"
        },
        chartArea: {
            width: "80%"
        }
    };
    var chart = new google.visualization.LineChart(document.getElementById("curve_chart"));
    chart.draw(data, options);
}
function $ff2e9cac1156f2ea$var$getServerData() {
    $.get("/regional-fuel-prices/average-price-chart-data", $ff2e9cac1156f2ea$var$drawChart);
}
function $ff2e9cac1156f2ea$export$376e40bec80c21a() {
    if (!$("[data-regional-fuel-prices]").length) return;
    // Define the callback function
    function init() {
        $ff2e9cac1156f2ea$var$getServerData();
        $(document).on("change", "[data-regional-fuel-price-date]", $ff2e9cac1156f2ea$var$setFuelPriceDate);
        $("#regional-fuel-prices-table").DataTable({
            responsive: true,
            "bPageinate": false,
            "bFilter": false,
            "bInfo": false,
            "bAutoWidth": false,
            "bLengthChange": false,
            "bSearchable": false,
            "iDisplayLength": -1,
            "order": [],
            "fnDrawCallback": function(oSettings) {
                $(".dataTables_paginate").hide();
            }
        });
    }
    // Load the API and specify the init function as callback
    google.charts.load("current", {
        packages: [
            "corechart"
        ],
        callback: init // This ensures init is called only after Google Charts is fully loaded
    });
}


(function($1) {
    function hoverEvent() {}
    $1(function() {
        $1(document).on("mouseover", "[data-upsell]", hoverEvent);
    });
})(jQuery);
const $a8340321fe089932$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $a8340321fe089932$var$changeSupplier() {
    const data = $a8340321fe089932$var$getData(1);
    const queryString = $a8340321fe089932$var$buildUpQueryString(data);
    if (queryString != "") $a8340321fe089932$var$History.pushState(data, $("title").html(), "/suppliers/" + $a8340321fe089932$var$buildUpQueryString(data) + "/");
    else $a8340321fe089932$var$History.pushState(data, $("title").html(), "/suppliers/" + $a8340321fe089932$var$buildUpQueryString(data));
//History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}
function $a8340321fe089932$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] == "page";
    })[0].split("=")[1];
}
function $a8340321fe089932$var$pageData(event) {
    if ($(event.target).attr("href") === undefined) return false;
    const page = $a8340321fe089932$var$getPage($(this).attr("href"));
    const data = $a8340321fe089932$var$getData(page);
    //History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
    const queryString = $a8340321fe089932$var$buildUpQueryString(data);
    if (queryString !== "") $a8340321fe089932$var$History.pushState(data, $("title").html(), "/suppliers/" + queryString + "/");
    else $a8340321fe089932$var$History.pushState(data, $("title").html(), "/suppliers/");
    const top = $("html").offset().top;
    $("html,body").animate({
        scrollTop: top
    }, 350);
    return false;
}
function $a8340321fe089932$var$getData(page) {
    const categories = $('.supplier-categories-container input[name="Categories"]:checked').map(function(index, element) {
        return $(element).val();
    }).toArray();
    return {
        Categories: categories.join(","),
        Page: page
    };
}
function $a8340321fe089932$var$buildUpQueryString(data) {
    if (data.Categories.length == 0 && data.Page <= 1) return "";
    let queryString = "";
    if (data.Categories.length > 0) queryString += data.Categories;
    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "/";
        queryString += data.Page;
    }
    return queryString;
}
function $a8340321fe089932$var$updateState() {
    const State = $a8340321fe089932$var$History.getState();
    $.get("/Apps/FleetNews/supplier-zone/query", State.data, function(response) {
        $("[data-supplier-query]").replaceWith(response);
    });
    $.get("/Apps/FleetNews/supplier-zone/results", State.data, function(response) {
        $("[data-supplier-results]").replaceWith(response);
    });
}
function $a8340321fe089932$export$ae69331b624aa7a() {
    const page = $("[data-supplier-zone]").length;
    if (!page) return;
    $(document).on("change", ".supplier-categories-container input", $a8340321fe089932$var$changeSupplier);
    $(document).on("click", "[data-supplier-results] .pagination a", $a8340321fe089932$var$pageData);
    //Bind to StateChange Event
    $a8340321fe089932$var$History.Adapter.bind(window, "statechange", $a8340321fe089932$var$updateState);
}


function $86f87e45f0071f3a$export$6f277b52b642b4f9() {
    $(document).on("click", "[data-test-drive-click]", function(e) {
        var clickValue = $(this).data("test-drive-click");
        if (clickValue !== "undefined") $.get("/set-test-drive-click-count/" + clickValue, function(response) {});
    });
}


function $b9c76af634f3d75b$var$markAsLoading() {
    $("#car-launch-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $b9c76af634f3d75b$var$reloadQuery() {
    var State = History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/up-sold-car-launch/running-costs/query", State.data, function(response) {
        $("#car-launch-query-container").replaceWith(response);
    });
}
function $b9c76af634f3d75b$var$setOperatingCycle() {
    $.get("/cap-operating-cycles/miles/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Miles").val(response);
    });
    $.get("/cap-operating-cycles/years/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Years").val(response);
    });
}
function $b9c76af634f3d75b$var$buildUpQueryString(data) {
    var queryString = "";
    var operatingCycleDefault = $("#OperatingCycleId option").eq(0).val();
    if (data.OperatingCycleId != operatingCycleDefault) {
        if (queryString.length > 0) queryString += "&";
        queryString += "Years=" + data.Years + "&Miles=" + data.Miles + "&ModelGroupId=" + data.ModelGroupId + "&DerivativeId=" + data.DerivativeId;
    }
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.imageId) > 0) queryString += "image=" + data.imageId;
    else queryString += "image=";
    if (data.ModelYear !== "") queryString += "&ModelYear=" + data.ModelYear;
    return "?" + queryString;
}
function $b9c76af634f3d75b$var$getData(page) {
    var operatingCycleId = $("#OperatingCycleId").val();
    var miles = $("#Miles").val();
    var years = $("#Years").val();
    var modelGroupId = $("#ModelGroupId").val();
    var imageId = $("#Image").val();
    var derivativeId = $("#DerivativeId").val();
    var modelYear = $("#ModelYear").val();
    return {
        OperatingCycleId: operatingCycleId,
        Miles: miles,
        Years: years,
        DerivativeId: derivativeId,
        imageId: imageId,
        ModelGroupId: modelGroupId,
        ModelYear: modelYear
    };
}
function $b9c76af634f3d75b$var$updateRunningCostsLogic(page) {
    var data = $b9c76af634f3d75b$var$getData(page);
    History.pushState(data, $("title").html(), location.pathname + $b9c76af634f3d75b$var$buildUpQueryString(data));
}
window.updateRunningCosts = function() {
    $b9c76af634f3d75b$var$updateRunningCostsLogic(1);
};
function $b9c76af634f3d75b$var$onImageSliderChange(event) {
    //console.log($(this).find(".item.active").data('image'));
    var image = $(this).find(".item.active").data("image-id");
    $("#Image").val(image);
    window.updateRunningCosts();
}
function $b9c76af634f3d75b$var$onChangeFilters(event) {
    var currentDropdown = $(this).attr("name");
    if (currentDropdown === "OperatingCycleId") {
        var derivativeId = $("#DerivativeId").val();
        if (parseInt(derivativeId) > 0) {
            var id = $(this).val();
            $.get("/cap-operating-cycles/miles/" + id, function(response) {
                $("#Miles").val(response);
                $.get("/cap-operating-cycles/years/" + id, function(response) {
                    $("#Years").val(response);
                    window.updateRunningCosts();
                });
            });
        } else alert("please select a derivative first");
    } else if (currentDropdown == "DerivativeId") {
        $("#DerivativeId").val($(this).val());
        window.updateRunningCosts();
    }
}
function $b9c76af634f3d75b$var$validateCustomForm() {
    $("#car-launch-contact-box").validate({
        rules: {
            Name: {
                required: true
            },
            Telephone: {
                require_from_group: [
                    1,
                    ".phone-group"
                ]
            },
            Email: {
                require_from_group: [
                    1,
                    ".phone-group"
                ]
            }
        },
        messages: {
            Name: "Name is required.",
            Telephone: "Please complete either email or phone number",
            Email: "Please complete either email or phone number"
        }
    });
}
function $b9c76af634f3d75b$var$updateState() {
    $b9c76af634f3d75b$var$markAsLoading();
    $b9c76af634f3d75b$var$reloadQuery();
    var State = History.getState();
    setTimeout(function() {
        $.get("/up-sold-car-launch/running-costs/results", State.data, function(response) {
            $("#car-launch-results-container").replaceWith(response);
        });
        $.get("/up-sold-car-launch/fact-sheet/results", State.data, function(response) {
            $("#car-launch-fact-sheet-container").replaceWith(response);
        });
    }, 500);
}
function $b9c76af634f3d75b$export$af46fff3f8bb6cb0() {
    if (!$("[data-upsold-car-launch]").length) return;
    $.featherlight.defaults.afterOpen = $b9c76af634f3d75b$var$validateCustomForm;
    jQuery.validator.setDefaults({
        success: "valid"
    });
    $b9c76af634f3d75b$var$setOperatingCycle();
    $(document).on("change", "[data-car-launch-running-costs] select", $b9c76af634f3d75b$var$onChangeFilters);
    $("a.carousel-control-down").click(function() {
        $("html, body").animate({
            scrollTop: $("#name").offset().top - 160
        });
        return false;
    });
    $("#carousel-example-generic").bind("slid.bs.carousel", $b9c76af634f3d75b$var$onImageSliderChange);
    $("#carousel-example-generic").swiperight(function() {
        $(this).carousel("prev");
    });
    $("#carousel-example-generic").swipeleft(function() {
        $(this).carousel("next");
    });
    var heights = $("div.sameheight").map(function() {
        return $(this).height();
    }).get(), maxHeight = Math.max.apply(null, heights);
    $("div.sameheight").height(maxHeight);
    $(document).on("submit", "[data-car-launch-contact-form]", function(e) {
        $("[data-upsold-contact-button]").disabled = true;
        var form = $(e.target);
        if (!form.valid()) return;
        e.preventDefault();
        $.post(form.attr("action"), form.serialize(), function(response) {
            $("[data-success-message]").empty().append("<section><div class='container'><div class='padding-top-15'><div class='alert alert-success'>Thank you for contacting us. You will receive a response soon.</div></div></div></section>");
            var currentfeatherlight = $.featherlight.current();
            if (currentfeatherlight) currentfeatherlight.close();
        });
    });
//History.Adapter.bind(window, 'statechange', updateState);
}


let $cb041d180d1b1b5e$var$reset = false;
const $cb041d180d1b1b5e$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $cb041d180d1b1b5e$var$getActiveFuelTypes() {
    const greenButtons = $("[data-fuel-type] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
function $cb041d180d1b1b5e$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $cb041d180d1b1b5e$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-van-manufacturer-url/" + manId, function(response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Manufacturer";
            })[0].split("=")[1];
            $("#ManufacturerName").val(manufacturer);
        }
    }
}
function $cb041d180d1b1b5e$var$setBodyType(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("VehicleGroupId") > 1) {
            const vehicleGroupId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "VehicleGroupId";
            })[0].split("=")[1];
            $.get("/cap-van-type-url/" + vehicleGroupId, function(response) {
                $("#BodyType").val(response);
            });
        } else if (href.indexOf("BodyType") > 1) {
            const vanType = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "BodyType";
            })[0].split("=")[1];
            $("#BodyType").val(vanType);
        }
    }
}
function $cb041d180d1b1b5e$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-van-model-url/" + manufacturerId + "/" + modelId, function(response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Model";
            })[0].split("=")[1];
            $("#ModelName").val(model);
        }
    }
}
//load the datatable for low res
function $cb041d180d1b1b5e$var$loadAsDataTable() {
    const table = $("#van-co2-table").DataTable({
        responsive: true,
        "ordering": false,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function(oSettings) {
            $(".dataTables_paginate").hide();
        }
    });
}
function $cb041d180d1b1b5e$var$checkIsDigitsOnly(e) {
    if (e.which !== 8 && e.which !== 0 && e.which !== 13 && (e.which < 48 || e.which > 57)) {
        const id = $(e.target).attr("id");
        $('[data-error="' + id + '"]').html("digits only").show().fadeOut("slow");
        return false;
    }
    return true;
}
function $cb041d180d1b1b5e$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#ModelName").val("");
        $.get("/cap-van-manufacturer-url/" + $(this).val(), function(response) {
            $("#ManufacturerName").val(response);
        });
        window.updateVanCO2Results();
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get("/cap-van-manufacturer-url/" + $("#ManufacturerId").val(), function(response) {
                $("#ManufacturerName").val(response);
            });
            $.get("/cap-van-model-url/" + $("#ManufacturerId").val() + "/" + $(this).val(), function(response) {
                $("#ModelName").val(response);
                window.updateVanCO2Results();
            });
        } else {
            $("#ModelName").val("");
            window.updateVanCO2Results();
        }
    } else if (currentDropdown === "VehicleGroupId") {
        $("#ModelGroupId").val("");
        if (parseInt($("#VehicleGroupId").val()) > 0) $.get("/cap-van-type-url/" + $("#VehicleGroupId").val(), function(response) {
            $("#BodyType").val(response);
            window.updateVanCO2Results();
        });
        else {
            $("#BodyType").val("");
            window.updateVanCO2Results();
        }
    } else window.updateVanCO2Results();
}
function $cb041d180d1b1b5e$var$updateFuelTypes(event) {
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateVanCO2Results();
}
function $cb041d180d1b1b5e$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.VehicleGroupId) > 0) queryString += "BodyType=" + data.BodyType;
    else queryString += "BodyType=";
    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.ManufacturerName;
    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.ModelName;
    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "P=" + data.Page;
    }
    if (queryString.length > 0) queryString += "&";
    queryString += "CO2To=" + data.CO2To;
    if (queryString.length > 0) queryString += "&";
    queryString += "MpgFrom=" + data.MpgFrom;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;
    if (queryString.length > 0) queryString += "&";
    queryString += "FuelType=" + data.FuelType;
    return "?" + queryString;
}
function $cb041d180d1b1b5e$var$getData(page) {
    const vehicleGroupId = $("#VehicleGroupId").val();
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const bodyType = $("#BodyType").val();
    const co2To = $("#CO2To").val();
    const mpgFrom = $("#MpgFrom").val();
    const sortBy = $("#SortBy").val();
    const sortDesc = $("#SortDesc").val();
    const fuelType = $cb041d180d1b1b5e$var$getActiveFuelTypes();
    return {
        VehicleGroupId: vehicleGroupId,
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        ManufacturerName: manufacturerName,
        ModelName: modelName,
        BodyType: bodyType,
        MpgFrom: mpgFrom,
        CO2To: co2To,
        SortBy: sortBy,
        SortDesc: sortDesc,
        FuelType: fuelType,
        Page: page
    };
}
function $cb041d180d1b1b5e$var$updateResultsLogic(page) {
    const data = $cb041d180d1b1b5e$var$getData(page);
    $cb041d180d1b1b5e$var$History.pushState(data, $("title").html(), location.pathname + $cb041d180d1b1b5e$var$buildUpQueryString(data));
}
function $cb041d180d1b1b5e$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] == "p";
    })[0].split("=")[1];
}
function $cb041d180d1b1b5e$var$pageData(event) {
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $cb041d180d1b1b5e$var$getPage($(this).attr("href"));
    $cb041d180d1b1b5e$var$updateResultsLogic(page);
}
function $cb041d180d1b1b5e$var$applyResultsSortArrows() {
    const sortBy = $("#SortBy").val();
    $("[data-co2-sort=" + sortBy + "]").attr("style", "background: url('/Themes/FleetNews/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $("#SortDesc").val();
    if (sortDesc.toLowerCase() === "true") $("[data-co2-sort=" + sortBy + "]").attr("style", "background: url('/Themes/FleetNews/Content/Images/top-desc.png') no-repeat right center;");
}
function $cb041d180d1b1b5e$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("co2-sort");
    const sortByEl = $("#SortBy");
    const sortDescEl = $("#SortDesc");
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy != newSortBy || sortDesc.toLowerCase() === "true") sortDescEl.val("false");
    else sortDescEl.val("true");
    window.updateVanCO2Results();
}
function $cb041d180d1b1b5e$var$markAsLoading() {
    $("#co2-calculator-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $cb041d180d1b1b5e$var$reloadQuery() {
    const State = $cb041d180d1b1b5e$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    let clonedData = {
        ...State.data
    };
    clonedData.P = clonedData.Page;
    $.get("/van-co2-calculator/query", clonedData, function(response) {
        $("#co2-calculator-query-container").replaceWith(response);
        $cb041d180d1b1b5e$var$handleBodyCopyToggle();
    });
}
function $cb041d180d1b1b5e$var$updateState() {
    $cb041d180d1b1b5e$var$markAsLoading();
    $cb041d180d1b1b5e$var$reloadQuery();
    const State = $cb041d180d1b1b5e$var$History.getState();
    let clonedData = {
        ...State.data
    };
    clonedData.P = clonedData.Page;
    $.get("/van-co2-calculator/results", clonedData, function(response) {
        $("#co2-calculator-results-container").replaceWith(response);
        $cb041d180d1b1b5e$var$loadAsDataTable();
        $cb041d180d1b1b5e$var$applyResultsSortArrows();
        if ($cb041d180d1b1b5e$var$reset) {
            $("[data-no-results]").hide();
            $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a van type or make above to start your search</div>");
            $cb041d180d1b1b5e$var$reset = false;
        }
    });
}
function $cb041d180d1b1b5e$export$b16f720339b8b3cd() {
    if (!$("[data-van-co2-calculator]").length) return;
    window.updateVanCO2Results = function() {
        $cb041d180d1b1b5e$var$updateResultsLogic(1);
    };
    const currentUrl = window.location.href;
    $cb041d180d1b1b5e$var$setManufacturer(currentUrl);
    $cb041d180d1b1b5e$var$setBodyType(currentUrl);
    $cb041d180d1b1b5e$var$setModel(currentUrl);
    $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a van type or make above to start your search</div>");
    $("[data-no-results]").hide();
    $cb041d180d1b1b5e$var$loadAsDataTable();
    $(document).on("keypress", "[data-digits-only]", $cb041d180d1b1b5e$var$checkIsDigitsOnly);
    $(document).on("change", "[data-van-co2-calculator] input, [data-van-co2-calculator] select", $cb041d180d1b1b5e$var$onChangeFilters);
    $(document).on("keypress", "[data-van-co2-calculator] input", function(e) {
        if (e.keyCode === 13) {
            $cb041d180d1b1b5e$var$onChangeFilters();
            return false;
        }
    });
    $(document).on("click", "[data-derivative]", function(e) {
        e.preventDefault();
        $(this).parents("tr").find("[data-view-detail]").trigger("click");
    });
    $(document).on("click", "[data-fuel-type] a", $cb041d180d1b1b5e$var$updateFuelTypes);
    $(document).on("click", "#co2-calculator-results-container .pagination a", $cb041d180d1b1b5e$var$pageData);
    $cb041d180d1b1b5e$var$applyResultsSortArrows();
    $(document).on("click", "[data-co2-sort]", $cb041d180d1b1b5e$var$sortResults);
    $(document).on("click", "[data-reset-button]", function(event) {
        event.preventDefault();
        $cb041d180d1b1b5e$var$History.pushState({}, $("title").html(), location.pathname);
        $cb041d180d1b1b5e$var$reset = true;
    });
    $cb041d180d1b1b5e$var$History.Adapter.bind(window, "statechange", $cb041d180d1b1b5e$var$updateState);
} //(function ($) {
 //    function getForm() {
 //        return $("[data-van-co2-form]");
 //    }
 //    function sortResults(event) {
 //        event.preventDefault();
 //        var button = $(event.currentTarget);
 //        var data = button.data("co2-sort");
 //        var form = getForm();
 //        var currentSort = form.find("#SortBy").val();
 //        form.find("#SortBy").val(data);
 //        form.find("#SortDesc").val(data != currentSort ? "false" : "true");
 //        form.submit();
 //    }
 //    //ToDo: Refactor this
 //    function applySortArrows() {
 //        var form = getForm();
 //        var currentSort = form.find("#SortBy").val();
 //        var isDesc = form.find("#SortDesc").val();
 //        var cssClass;
 //        if (isDesc == "True") {
 //            cssClass = "sorting_desc";
 //        } else {
 //            cssClass = "sorting_asc";
 //        }
 //        var runningCostTable = $("#van-co2-table");
 //        var test = runningCostTable.find("[data-co2-sort='" + currentSort + "']");
 //        test.parent().addClass(cssClass);
 //    }
 //    function changeManufacturer() {
 //        var form = getForm();
 //        form.find("#ModelGroupId").val("");
 //        form.submit();
 //    }
 //    function changeModelGroup() {
 //        var form = getForm();
 //        form.submit();
 //    }
 //    var table = $('#van-co2-table').DataTable({
 //        responsive: true,
 //        "ordering": false,
 //        "bPageinate": false,
 //        "bFilter": false,
 //        "bInfo": false,
 //        "bAutoWidth": false,
 //        "bLengthChange": false,
 //        "bSearchable": false,
 //        "iDisplayLength": -1,
 //        "fnDrawCallback": function (oSettings) {
 //            $('.dataTables_paginate').hide();
 //        }
 //    });
 //    $(function () {
 //        $(document).on("click", "[data-co2-sort]", sortResults);
 //        $(document).on("change", "#ManufacturerId", changeManufacturer);
 //        $(document).on("change", "#ModelGroupId", changeModelGroup);
 //        applySortArrows();
 //    });
 //})(jQuery);


var $29b334ac16b2381b$var$History = window.History; // Note: We are using a capital H instead of a lower h
var $29b334ac16b2381b$var$compareListSortBy;
var $29b334ac16b2381b$var$compareListSortDesc;
function $29b334ac16b2381b$var$getData() {
    var sortBy = $29b334ac16b2381b$var$compareListSortBy;
    var sortDesc = $29b334ac16b2381b$var$compareListSortDesc;
    return {
        SortBy: sortBy,
        SortDesc: sortDesc
    };
}
function $29b334ac16b2381b$var$buildUpQueryString(data) {
    var queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += `SortBy=${data.SortBy}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SortDesc=${data.SortDesc}`;
    return `?${queryString}`;
}
function $29b334ac16b2381b$var$sortResults(event) {
    event.preventDefault();
    var newSortBy = $(this).data("compare-list-sort");
    if ($29b334ac16b2381b$var$compareListSortBy !== newSortBy) $29b334ac16b2381b$var$compareListSortDesc = "false";
    else if ($29b334ac16b2381b$var$compareListSortDesc === "true") $29b334ac16b2381b$var$compareListSortDesc = "false";
    else $29b334ac16b2381b$var$compareListSortDesc = "true";
    $29b334ac16b2381b$var$compareListSortBy = newSortBy;
    var data = $29b334ac16b2381b$var$getData();
    $29b334ac16b2381b$var$History.pushState(data, $("title").html(), location.pathname + $29b334ac16b2381b$var$buildUpQueryString(data));
}
function $29b334ac16b2381b$var$updateState() {
    var State = $29b334ac16b2381b$var$History.getState();
    $.get(`/van-compare-list/results/${$("#RunningCostIds").val()}`, State.data, function(response) {
        $("#compare-list-results-container").replaceWith(response);
        $(`[data-compare-list-sort=${$29b334ac16b2381b$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
        if ($29b334ac16b2381b$var$compareListSortDesc.toLowerCase() === "true") $(`[data-compare-list-sort=${$29b334ac16b2381b$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
    });
}
function $29b334ac16b2381b$export$953e2b044b74bd66() {
    if (!$("[data-van-compare-list]").length) return;
    $29b334ac16b2381b$var$compareListSortBy = $("#SortBy").val();
    $29b334ac16b2381b$var$compareListSortDesc = $("#SortDesc").val();
    $(document).on("click", "[data-compare-list-sort]", $29b334ac16b2381b$var$sortResults);
    $(`[data-compare-list-sort=${$29b334ac16b2381b$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
    if ($29b334ac16b2381b$var$compareListSortDesc.toLowerCase() === "true") $(`[data-compare-list-sort=${$29b334ac16b2381b$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
    $(document).on("click", "[data-remove-from-list]", function(event) {
        var id = $(this).attr("data-remove-from-list");
        $.get(`/van-compare-list/handle/remove/${id}`, function(response) {});
    });
// Bind to StateChange Event
//History.Adapter.bind(window, 'statechange', updateState);
}


function $b0c1205ab438e8b5$var$submitForm(event) {
    event.preventDefault();
    $(event.target).parents("form").submit();
}
function $b0c1205ab438e8b5$var$markAsLoading() {
    let container = $("#van-reviews-search-loading-container");
    container.height(50); // set the height to stop moving on large desktop
    container.text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $b0c1205ab438e8b5$export$abf0c736cc0404e4() {
    $(document).on("change", "form[data-van-review-search] select", function(e) {
        $b0c1205ab438e8b5$var$markAsLoading();
        $b0c1205ab438e8b5$var$submitForm(e);
        if ($("#ManufacturerSlugSelected").val() == "search") $("#ManufacturerSlug").val("");
    });
}


function $a45552c76e7ee752$var$changeManufacturer() {
    var manufacturerName = $("#ManufacturerId").val();
    $.get("/vans/section/query?ManufacturerName=" + manufacturerName, function(response) {
        $("[data-van-section-search]").replaceWith(response);
    });
}
function $a45552c76e7ee752$var$changeModel() {
    var modelName = $("#ModelId").val();
    $("#ModelName").val(modelName);
}
function $a45552c76e7ee752$export$b4ebbdbd9d8b89a1() {
    if ($("[data-van-reviews-section]").length) {
        $(document).on("change", "#ManufacturerId", $a45552c76e7ee752$var$changeManufacturer);
        $(document).on("change", "#ModelId", $a45552c76e7ee752$var$changeModel);
        $("#ManufacturerId").trigger("change");
    }
}


function $de5410f3f786fb03$var$submitForm(event) {
    event.preventDefault();
    $(event.target).parents("form").submit();
}
function $de5410f3f786fb03$export$ea92669c2bcde238() {
    $(document).on("change", "form[data-manufacturer-dropdown] select", $de5410f3f786fb03$var$submitForm);
}


let $631d9a7494b6c619$var$reset = false;
const $631d9a7494b6c619$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $631d9a7494b6c619$var$getActiveFuelTypes() {
    const greenButtons = $("[data-fuel-type] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
function $631d9a7494b6c619$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $631d9a7494b6c619$var$reloadQuery() {
    const State = $631d9a7494b6c619$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/new-van-running-cost/query", State.data, function(response) {
        $("#new-van-running-cost-query-container").replaceWith(response);
        $631d9a7494b6c619$var$handleBodyCopyToggle();
    });
    $.get("/new-van-running-cost/bottom-seo", State.data, function(response) {
        $("#new-van-running-cost-seo-container").replaceWith(response);
        $631d9a7494b6c619$var$handleBodyCopyToggle();
    });
}
function $631d9a7494b6c619$var$markAsLoading() {
    let container = $("#new-van-running-cost-results-container");
    container.height(container.height()); // set the height to stop moving on large desktop
    container.text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $631d9a7494b6c619$var$setOperatingCycle() {
    $.get("/cap-van-operating-cycles/miles/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Miles").val(response);
    });
    $.get("/cap-van-operating-cycles/years/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Years").val(response);
    });
}
function $631d9a7494b6c619$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown == "OperatingCycleId") {
        const id = $(this).val();
        $.get("/cap-van-operating-cycles/miles/" + id, function(response) {
            $("#Miles").val(response);
            $.get("/cap-van-operating-cycles/years/" + id, function(response) {
                $("#Years").val(response);
                window.updateVanRunningCosts();
            });
        });
    } else if (currentDropdown == "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#Model").val("");
        if (parseInt($(this).val()) > 0) $.get("/cap-van-manufacturer-url/" + $(this).val(), function(response) {
            $("#Manufacturer").val(response);
            window.updateVanRunningCosts();
        });
        else {
            $("#Manufacturer").val("");
            window.updateVanRunningCosts();
        }
    } else if (currentDropdown == "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get("/cap-van-manufacturer-url/" + $("#ManufacturerId").val(), function(response) {
                $("#Manufacturer").val(response);
                window.updateVanRunningCosts();
            });
            $.get("/cap-van-model-url/" + $("#ManufacturerId").val() + "/" + $(this).val(), function(response) {
                $("#Model").val(response);
                window.updateVanRunningCosts();
            });
        } else {
            $("#Model").val("");
            window.updateVanRunningCosts();
        }
    } else if (currentDropdown == "VehicleGroupId") {
        $("#ModelGroupId").val("");
        if (parseInt($("#VehicleGroupId").val()) > 0) $.get("/cap-van-type-url/" + $("#VehicleGroupId").val(), function(response) {
            $("#VanType").val(response);
            window.updateVanRunningCosts();
        });
        else {
            $("#VanType").val("");
            window.updateVanRunningCosts();
        }
    } else window.updateVanRunningCosts();
}
//sorting the results
function $631d9a7494b6c619$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("new-running-cost-sort");
    const sortByEl = $("#SortBy");
    const sortDescEl = $("#SortDesc");
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy != newSortBy || sortDesc.toLowerCase() == "true") sortDescEl.val("false");
    else sortDescEl.val("true");
    window.updateVanRunningCosts();
}
function $631d9a7494b6c619$var$showHideDetail() {
    const $this = $(this);
    let id = $this.attr("href");
    let collapsibleElement = document.querySelector(id);
    if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
    if (collapsibleElement) {
        if (!collapsibleElement.dataset.eventInitiated) collapsibleElement.addEventListener("shown.bs.collapse", function(e) {
            this.dataset.eventInitiated = true;
            let spacer = $(collapsibleElement).closest("tr").next("tr.spacer");
            if (spacer) spacer.find("td").attr("height", $(this).height());
        });
    }
    const currentText = $.trim($this.text());
    const row = $this.parents("tr");
    let currentSpacer = $this.closest("table").find('.spacer[data-id="' + id + '"]');
    const rowHeight = row.height();
    if (currentText == "View data") {
        $this.text("Hide data");
        if (currentSpacer.length < 1) {
            if (window.isViewportGreaterThanOrEqualTo("xl")) row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="175"></td></tr>');
            else if (window.getViewportSize() == "lg") {
                if (rowHeight > 40) row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="145"></td></tr>');
                else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="175"></td></tr>');
            } else if (window.getViewportSize() == "md") row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="190"></td></tr>');
            else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="400"></td></tr>');
        }
    } else {
        $this.text("View data");
        currentSpacer.remove();
    }
    $631d9a7494b6c619$var$resetSpacersSize();
}
//sorting arrow
function $631d9a7494b6c619$var$applyResultsSortArrows() {
    const sortBy = $("#SortBy").val();
    $("[data-new-running-cost-sort=" + sortBy + "]").attr("style", "background: url('/Themes/FleetNews/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $("#SortDesc").val();
    if (sortDesc.toLowerCase() == "true") $("[data-new-running-cost-sort=" + sortBy + "]").attr("style", "background: url('/Themes/FleetNews/Content/Images/top-desc.png') no-repeat right center;");
}
function $631d9a7494b6c619$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-van-manufacturer-url/" + manId, function(response) {
                $("#Manufacturer").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Manufacturer";
            })[0].split("=")[1];
            $("#Manufacturer").val(manufacturer);
        }
    }
}
function $631d9a7494b6c619$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-van-model-url/" + manufacturerId + "/" + modelId, function(response) {
                $("#Model").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Model";
            })[0].split("=")[1];
            $("#Model").val(model);
        }
    }
}
function $631d9a7494b6c619$var$setVanType(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("VehicleGroupId") > 1) {
            const vehicleGroupId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "VehicleGroupId";
            })[0].split("=")[1];
            $.get("/cap-van-type-url/" + vehicleGroupId, function(response) {
                $("#VanType").val(response);
            });
        } else if (href.indexOf("VanType") > 1) {
            const carType = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "VanType";
            })[0].split("=")[1];
            $("#VanType").val(carType);
        }
    }
}
function $631d9a7494b6c619$var$checkIsDigitsOnly(e) {
    //if the letter is not digit then display error and don't type anything
    if (e.which != 8 && e.which != 0 && e.which != 13 && e.which != 46 && (e.which < 48 || e.which > 57)) {
        //display error message
        const id = $(e.target).attr("id");
        $('[data-error="' + id + '"]').html("digits only").show().fadeOut("slow");
        return false;
    }
    return true;
}
function $631d9a7494b6c619$var$loadAsDataTable() {
    const table = $("#new-running-costs").DataTable({
        responsive: true,
        "ordering": false,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function(oSettings) {
            $(".dataTables_paginate").hide();
        }
    });
    //Check spacer when datatable responsive display collapsed (hide)
    table.on("responsive-display.dt", function(e, datatable, row, showHide, update) {
        $631d9a7494b6c619$var$resetSpacersSize();
    });
}
function $631d9a7494b6c619$var$addVehicle(id, callback) {
    $.get("/van-compare-list/handle/add/" + id, function(response) {
        let success;
        if (response == 0) success = true;
        else if (response == 1) {
            alert("Maximum of 5 vehicles.");
            success = false;
        } else if (response == 2) success = true;
        else {
            alert("Error");
            success = false;
        }
        if (callback) callback(success);
    });
}
function $631d9a7494b6c619$var$removeVehicle(id, callback) {
    $.get("/van-compare-list/handle/remove/" + id, function(response) {
        const success = response == 0;
        if (callback) callback(success);
    });
}
function $631d9a7494b6c619$var$markAsToAdd(btn) {
    btn.removeClass().addClass("btn btn-green btn-block w-100").text("Add to compare");
}
function $631d9a7494b6c619$var$markAsToRemove(btn) {
    btn.html(btn.data("original-text"));
    btn.addClass("added");
    btn.text("Comparing");
}
function $631d9a7494b6c619$var$updateCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("new-compare-list-add-id");
    const btn = $(event.target);
    if (!btn.data("original-text")) btn.data("original-text", btn.html());
    const btnClass = $(this).attr("class");
    btn.html("<img src='/Themes/FleetNews/Content/Images/loading.png'/>");
    if (btnClass.indexOf("added") > 1) $631d9a7494b6c619$var$removeVehicle(data, function(success) {
        if (success) {
            $631d9a7494b6c619$var$markAsToAdd(btn);
            $631d9a7494b6c619$var$reloadQuery();
        } else $631d9a7494b6c619$var$markAsToRemove(btn);
        $631d9a7494b6c619$var$reloadQuery();
    });
    else $631d9a7494b6c619$var$addVehicle(data, function(success) {
        if (success) {
            $631d9a7494b6c619$var$markAsToRemove(btn);
            $("html, body").animate({
                scrollTop: 0
            }, "slow");
            $631d9a7494b6c619$var$reloadQuery();
        } else $631d9a7494b6c619$var$markAsToAdd(btn);
    });
}
function $631d9a7494b6c619$var$updateFuelTypes(event) {
    //markAsLoading();
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateVanRunningCosts();
}
$(function() {});
function $631d9a7494b6c619$var$buildUpQueryString(data) {
    let queryString = "";
    //var operatingCycleDefault = $('#OperatingCycleId option').eq(0).val();
    //if (data.OperatingCycleId != operatingCycleDefault) {
    //    if (queryString.length > 0) queryString += "&";
    //    queryString += "Years=" + data.Years + "&Miles=" + data.Miles;
    //}
    if (queryString.length > 0) queryString += "&";
    queryString += "Years=" + data.Years + "&Miles=" + data.Miles;
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.VehicleGroupId) > 0) queryString += "VanType=" + data.VanType;
    else queryString += "VanType=";
    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.Manufacturer;
    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.Model;
    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "P=" + data.P;
    }
    if (queryString.length > 0) queryString += "&";
    queryString += "MinPayload=" + data.MinPayload;
    if (queryString.length > 0) queryString += "&";
    queryString += "MinLoadWidth=" + data.MinLoadWidth;
    if (queryString.length > 0) queryString += "&";
    queryString += "MinLoadLength=" + data.MinLoadLength;
    if (queryString.length > 0) queryString += "&";
    queryString += "MinTow=" + data.MinTow;
    if (queryString.length > 0) queryString += "&";
    queryString += "BIKPriceFrom=" + data.BIKPriceFrom;
    if (queryString.length > 0) queryString += "&";
    queryString += "BIKPriceTo=" + data.BIKPriceTo;
    if (queryString.length > 0) queryString += "&";
    queryString += "CO2From=" + data.CO2From;
    if (queryString.length > 0) queryString += "&";
    queryString += "CO2To=" + data.CO2To;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;
    if (queryString.length > 0) queryString += "&";
    queryString += "FuelType=" + data.FuelType;
    return "?" + queryString;
}
function $631d9a7494b6c619$var$getData(page) {
    const operatingCycleId = $("#OperatingCycleId").val();
    const vehicleGroupId = $("#VehicleGroupId").val();
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const miles = $("#Miles").val();
    const years = $("#Years").val();
    const manufacturer = $("#Manufacturer").val();
    const model = $("#Model").val();
    const vanType = $("#VanType").val();
    const co2From = $("#CO2From").val();
    const co2To = $("#CO2To").val();
    const minPayload = $("#MinPayload").val();
    const minLoadWidth = $("#MinLoadWidth").val();
    const minLoadLength = $("#MinLoadLength").val();
    const minTow = $("#MinTow").val();
    const bikPriceFrom = $("#BIKPriceFrom").val();
    const bikPriceTo = $("#BIKPriceTo").val();
    const sortBy = $("#SortBy").val();
    const sortDesc = $("#SortDesc").val();
    const fuelType = $631d9a7494b6c619$var$getActiveFuelTypes();
    return {
        OperatingCycleId: operatingCycleId,
        VehicleGroupId: vehicleGroupId,
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Miles: miles,
        Years: years,
        Manufacturer: manufacturer,
        Model: model,
        VanType: vanType,
        MinPayload: minPayload,
        MinLoadWidth: minLoadWidth,
        MinLoadLength: minLoadLength,
        MinTow: minTow,
        BIKPriceFrom: bikPriceFrom,
        BIKPriceTo: bikPriceTo,
        CO2From: co2From,
        CO2To: co2To,
        SortBy: sortBy,
        SortDesc: sortDesc,
        FuelType: fuelType,
        P: page
    };
}
function $631d9a7494b6c619$var$updateResultsLogic(page) {
    const data = $631d9a7494b6c619$var$getData(page);
    $631d9a7494b6c619$var$History.pushState(data, $("title").html(), location.pathname + $631d9a7494b6c619$var$buildUpQueryString(data));
}
function $631d9a7494b6c619$var$pageData(event) {
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $631d9a7494b6c619$var$getPage($(this).attr("href"));
    $631d9a7494b6c619$var$updateResultsLogic(page);
}
function $631d9a7494b6c619$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] == "p";
    })[0].split("=")[1];
}
function $631d9a7494b6c619$var$updateState() {
    $631d9a7494b6c619$var$markAsLoading();
    $631d9a7494b6c619$var$reloadQuery();
    const State = $631d9a7494b6c619$var$History.getState();
    $.get("/new-van-running-cost/results", State.data, function(response) {
        $("#new-van-running-cost-results-container").replaceWith(response);
        $("#new-van-running-cost-results-container input[name^='comparelist']").each(function() {
            const compareListId = $(this).val();
            $("[data-new-compare-list-add-id=" + compareListId + "]").addClass("added").text("Comparing");
        });
        $631d9a7494b6c619$var$loadAsDataTable();
        $631d9a7494b6c619$var$applyResultsSortArrows();
        if ($631d9a7494b6c619$var$reset) {
            $("[data-no-results]").hide();
            $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a van type or make above to start your search</div>");
            $631d9a7494b6c619$var$reset = false;
        }
    }).done(function() {
        setTimeout(function() {
            // //delay reload until results show, as we are now injecting ads into content
            const adSection = $("[data-ad-id]");
            // //push slots
            //
            const page = window.getDFPAdsPage(adSection);
            // window.getDFPAds(page);
            // if (page.adSlots['leaderboard-2'] === undefined) {
            //     window.pushAdSlot(page, $("#leaderboard-2-container"));
            // }
            // if (page.adSlots['leaderboard-3'] === undefined) {
            //     window.pushAdSlot(page, $("#leaderboard-3-container"));
            // }
            window.getDFPAds(page, hideIfNoAd);
        }, 250);
    });
    function hideIfNoAd() {
    //the below works but then the even/odd table needs adjusting and more work that worth.
    /* setTimeout(function(){
             let $vanrunningcost = $("#vanrunningcost-ad-slot-1");   
             const len = $$vanrunningcost.html().length;
             if (len === 0){
                 $vanrunningcost.parent().parent().parent().hide();
             } else {
                 $vanrunningcost.parent().parent().parent().show();
             }
         }, 1000);   */ }
}
function $631d9a7494b6c619$var$setupMpus() {
    if (window.location.pathname === "/tools/van/running-costs/" && window.location.search !== "") {
        if ($("#mpus").length) $("#mpus").remove();
    }
}
function $631d9a7494b6c619$var$resetSpacersSize() {
    $(".spacer[data-id]").each(function() {
        let spacer = $(this);
        let id = spacer.data("id");
        let collapsibleElement = document.querySelector(id);
        if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
        if (collapsibleElement) {
            if (collapsibleElement.offsetParent !== null && $(collapsibleElement).height() > 0) spacer.find("td").attr("height", $(collapsibleElement).height());
            else spacer.remove();
        } else spacer.remove();
    });
}
function $631d9a7494b6c619$export$9ef30b34c240b3e6() {
    if (!$("[data-new-van-running-costs]").length) return;
    $631d9a7494b6c619$var$setupMpus();
    $631d9a7494b6c619$var$setOperatingCycle();
    $631d9a7494b6c619$var$setManufacturer(window.location.href);
    $631d9a7494b6c619$var$setVanType(window.location.href);
    $631d9a7494b6c619$var$setModel(window.location.href);
    $631d9a7494b6c619$var$loadAsDataTable();
    $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a van type or make above to start your search</div>");
    $("[data-no-results]").hide();
    //dropdown changes
    $(document).on("change", "[data-new-van-running-costs] input, [data-new-van-running-costs] select", $631d9a7494b6c619$var$onChangeFilters);
    $(document).on("keypress", "[data-new-van-running-costs] input", function(e) {
        if (e.keyCode == 13) {
            $631d9a7494b6c619$var$onChangeFilters();
            return false;
        }
    });
    //paging click
    $(document).on("click", "#new-van-running-cost-results-container .pagination a", $631d9a7494b6c619$var$pageData);
    //fuel type button chagnes
    $(document).on("click", "[data-fuel-type] a", $631d9a7494b6c619$var$updateFuelTypes);
    //sort
    $(document).on("click", "[data-new-running-cost-sort]", $631d9a7494b6c619$var$sortResults);
    window.addEventListener("resize", function() {
        $631d9a7494b6c619$var$resetSpacersSize();
    });
    //viewdata
    $(document).on("click", "[data-view-detail]", $631d9a7494b6c619$var$showHideDetail);
    //digit only
    $(document).on("keypress", "[data-digits-only]", $631d9a7494b6c619$var$checkIsDigitsOnly);
    //arrow
    $631d9a7494b6c619$var$applyResultsSortArrows();
    //reset
    $(document).on("click", "[data-reset-button]", function(event) {
        event.preventDefault();
        $631d9a7494b6c619$var$History.pushState({}, $("title").html(), location.pathname);
        $631d9a7494b6c619$var$reset = true;
    });
    //add to compare list button click
    $(document).on("click", "[data-new-compare-list-add-id]", $631d9a7494b6c619$var$updateCompareList);
    //derivative link
    $(document).on("click", "[data-derivative]", function(e) {
        e.preventDefault();
        let viewDetailsButton = $(this).parents("tr").find("[data-view-detail]");
        if (viewDetailsButton.length) {
            if (window.isViewportLessThan("md")) $(this).closest("tr").find(".dtr-control").trigger("click");
            else {
                let id = viewDetailsButton.attr("href");
                let collapsibleElement = document.querySelector(id);
                if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
                if (collapsibleElement) {
                    viewDetailsButton.toggleClass("collapsed");
                    viewDetailsButton.data("aria-expanded", !viewDetailsButton.data("aria-expanded"));
                    $(collapsibleElement).toggleClass("show");
                    $(this).closest("tr").find("[data-view-detail]").trigger("click");
                }
            }
        }
        $631d9a7494b6c619$var$resetSpacersSize();
    });
    // Bind to StateChange Event
    $631d9a7494b6c619$var$History.Adapter.bind(window, "statechange", $631d9a7494b6c619$var$updateState);
    window.updateVanRunningCosts = function() {
        $631d9a7494b6c619$var$updateResultsLogic(1);
        $631d9a7494b6c619$var$setupMpus();
    };
}


const $a44a9adb885e4949$var$history = window.History;
function $a44a9adb885e4949$var$buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data, function(value, key) {
        if (key === "isPageChange") return;
        if (value) queryStringData[key] = value;
    });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}
function $a44a9adb885e4949$var$getData() {
    const dataArray = $("[data-what-is-my-car-mpg-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function(item) {
        if (data[item.name]) {
            if (typeof data[item.name] === "string") data[item.name] = [
                data[item.name]
            ];
            data[item.name].push(item.value);
        } else data[item.name] = item.value;
    });
    return data;
}
function $a44a9adb885e4949$var$updateResultsLogic(isPageChange) {
    const data = $a44a9adb885e4949$var$getData();
    if (isPageChange) data.isPageChange = true;
    $a44a9adb885e4949$var$history.pushState(data, $("title").html(), location.pathname + "?" + $a44a9adb885e4949$var$buildUpQueryString(data));
    return data;
}
function $a44a9adb885e4949$var$triggerUpdateResults(event) {
    if ($(event.target).data("autocomplete") != null) return;
    if (event.target.name === "ManufacturerId") {
        if ($("#ModelGroupId").val() != null) {
            $("#ModelGroupId").val("");
            $("#DerivativeId").val("");
        }
    }
    if (event.target.name === "ModelGroupId") {
        if ($("#DerivativeId").val() != null) $("#DerivativeId").val("");
    }
    window.updateResults();
}
function $a44a9adb885e4949$var$reloadQuery() {
    const state = $a44a9adb885e4949$var$history.getState();
    $.get("/costs/what-is-my-car-mpg/query", state.data, function(response) {
        $("[data-what-is-my-car-mpg-query-attributes]").replaceWith(response);
    });
}
function $a44a9adb885e4949$var$updateState() {
    $a44a9adb885e4949$var$reloadQuery();
    const state = $a44a9adb885e4949$var$history.getState();
    $.get("/costs/what-is-my-car-mpg/results", state.data, function(response) {
        $("[data-what-is-my-car-mpg-results-container]").replaceWith(response);
    });
}
function $a44a9adb885e4949$var$scrollToResult(e) {
    e.preventDefault();
    $("html, body").animate({
        scrollTop: $(window).scrollTop() + 200
    }, 2000);
}
function $a44a9adb885e4949$export$5a34e6870ef2f82e() {
    if (!$("[data-what-is-my-car-mpg]").length) return;
    $(document).on("change", "[data-what-is-my-car-mpg-query-attributes] input, [data-what-is-my-car-mpg-query-attributes] select", $a44a9adb885e4949$var$triggerUpdateResults);
    $(document).on("click", "[data-view-result-button]", $a44a9adb885e4949$var$scrollToResult);
    //Bind to StateChange Event
    $a44a9adb885e4949$var$history.Adapter.bind(window, "statechange", $a44a9adb885e4949$var$updateState);
    window.updateResults = function() {
        $a44a9adb885e4949$var$updateResultsLogic();
    };
}


let $41f3be02cf03cd10$var$reset = false;
const $41f3be02cf03cd10$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $41f3be02cf03cd10$var$getActiveFuelTypes() {
    const greenButtons = $("[data-fuel-type] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
function $41f3be02cf03cd10$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $41f3be02cf03cd10$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-manufacturer-url/" + manId, function(response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Manufacturer";
            })[0].split("=")[1];
            $("#ManufacturerName").val(manufacturer);
        }
    }
}
function $41f3be02cf03cd10$var$setCarType(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("VehicleGroupId") > 1) {
            const vehicleGroupId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "VehicleGroupId";
            })[0].split("=")[1];
            $.get("/cap-car-type-url/" + vehicleGroupId, function(response) {
                $("#CarType").val(response);
            });
        } else if (href.indexOf("CarType") > 1) {
            const carType = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "CarType";
            })[0].split("=")[1];
            $("#CarType").val(carType);
        }
    }
}
function $41f3be02cf03cd10$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-model-url/" + manufacturerId + "/" + modelId, function(response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Model";
            })[0].split("=")[1];
            $("#ModelName").val(model);
        }
    }
}
//load the datatable for low res
function $41f3be02cf03cd10$var$loadAsDataTable() {
    const table = $("#car-co2-table").DataTable({
        responsive: true,
        "ordering": false,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function(oSettings) {
            $(".dataTables_paginate").hide();
        }
    });
}
function $41f3be02cf03cd10$var$checkIsDigitsOnly(e) {
    if (e.which !== 8 && e.which !== 0 && e.which !== 13 && (e.which < 48 || e.which > 57)) {
        const id = $(e.target).attr("id");
        $('[data-error="' + id + '"]').html("digits only").show().fadeOut("slow");
        return false;
    }
    return true;
}
function $41f3be02cf03cd10$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#ModelName").val("");
        $.get("/cap-manufacturer-url/" + $(this).val(), function(response) {
            $("#ManufacturerName").val(response);
            window.updateCarCO2Results();
        });
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get("/cap-manufacturer-url/" + $("#ManufacturerId").val(), function(response) {
                $("#ManufacturerName").val(response);
            });
            $.get("/cap-model-url/" + $("#ManufacturerId").val() + "/" + $(this).val(), function(response) {
                $("#ModelName").val(response);
                window.updateCarCO2Results();
            });
        } else {
            $("#ModelName").val("");
            window.updateCarCO2Results();
        }
    } else if (currentDropdown === "VehicleGroupId") {
        $("#ModelGroupId").val("");
        if (parseInt($("#VehicleGroupId").val()) > 0) $.get("/cap-car-type-url/" + $("#VehicleGroupId").val(), function(response) {
            $("#CarType").val(response);
            window.updateCarCO2Results();
        });
        else {
            $("#CarType").val("");
            window.updateCarCO2Results();
        }
    } else window.updateCarCO2Results();
}
function $41f3be02cf03cd10$var$updateFuelTypes(event) {
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateCarCO2Results();
}
function $41f3be02cf03cd10$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.VehicleGroupId) > 0) queryString += "CarType=" + data.CarType;
    else queryString += "CarType=";
    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.Manufacturer;
    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.Model;
    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "P=" + data.Page;
    }
    if (queryString.length > 0) queryString += "&";
    queryString += "CO2To=" + data.CO2To;
    if (queryString.length > 0) queryString += "&";
    queryString += "MpgFrom=" + data.MpgFrom;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;
    if (queryString.length > 0) queryString += "&";
    queryString += "FuelType=" + data.FuelType;
    return "?" + queryString;
}
function $41f3be02cf03cd10$var$getData(page) {
    const vehicleGroupId = $("#VehicleGroupId").val();
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const carType = $("#CarType").val();
    const co2To = $("#CO2To").val();
    const mpgFrom = $("#MpgFrom").val();
    const sortBy = $("#SortBy").val();
    const sortDesc = $("#SortDesc").val();
    const fuelType = $41f3be02cf03cd10$var$getActiveFuelTypes();
    return {
        VehicleGroupId: vehicleGroupId,
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Manufacturer: manufacturerName,
        Model: modelName,
        CarType: carType,
        MpgFrom: mpgFrom,
        CO2To: co2To,
        SortBy: sortBy,
        SortDesc: sortDesc,
        FuelType: fuelType,
        P: page
    };
}
function $41f3be02cf03cd10$var$updateResultsLogic(page) {
    const data = $41f3be02cf03cd10$var$getData(page);
    $41f3be02cf03cd10$var$History.pushState(data, $("title").html(), location.pathname + $41f3be02cf03cd10$var$buildUpQueryString(data));
}
function $41f3be02cf03cd10$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] == "p";
    })[0].split("=")[1];
}
function $41f3be02cf03cd10$var$pageData(event) {
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $41f3be02cf03cd10$var$getPage($(this).attr("href"));
    $41f3be02cf03cd10$var$updateResultsLogic(page);
}
function $41f3be02cf03cd10$var$applyResultsSortArrows() {
    const sortBy = $("#SortBy").val();
    $("[data-co2-sort=" + sortBy + "]").attr("style", "background: url('/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $("#SortDesc").val();
    if (sortDesc.toLowerCase() === "true") $("[data-co2-sort=" + sortBy + "]").attr("style", "background: url('/Content/Images/top-desc.png') no-repeat right center;");
}
function $41f3be02cf03cd10$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("co2-sort");
    const sortByEl = $("#SortBy");
    const sortDescEl = $("#SortDesc");
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy != newSortBy || sortDesc.toLowerCase() === "true") sortDescEl.val("false");
    else sortDescEl.val("true");
    window.updateCarCO2Results();
}
function $41f3be02cf03cd10$var$showHideDetail() {
    const $this = $(this);
    const currentText = $.trim($this.text());
    const row = $this.parents("tr");
    let alreadyExist = row.next("tr.spacer");
    if (window.isViewportLessThan("md")) alreadyExist = row.parent().parent().next("tr.spacer");
    const rowHeight = row.height();
    if (currentText == "View data") {
        $this.text("Hide data");
        if (alreadyExist.length < 1) {
            if (window.isViewportGreaterThanOrEqualTo("xl")) row.after('<tr class="spacer"><td colspan="6" height="140"></td></tr>');
            else if (window.getViewportSize() == "lg") {
                if (rowHeight > 40) row.after('<tr class="spacer"><td colspan="6" height="110"></td></tr>');
                else row.after('<tr class="spacer"><td colspan="6" height="140"></td></tr>');
            } else if (window.getViewportSize() == "md") row.after('<tr class="spacer"><td colspan="6" height="155"></td></tr>');
            else row.after('<tr class="spacer"><td colspan="6" height="220"></td></tr>');
        }
    } else {
        $this.text("View data");
        if (alreadyExist.length > 0) row.next("tr.spacer").remove();
        if (window.isViewportLessThan("md")) $("#car-co2-table_wrapper tr.spacer").remove();
    }
}
function $41f3be02cf03cd10$var$markAsLoading() {
    $("#co2-calculator-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $41f3be02cf03cd10$var$reloadQuery() {
    const State = $41f3be02cf03cd10$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/car-co2-calculator/query", State.data, function(response) {
        $("#co2-calculator-query-container").replaceWith(response);
        $41f3be02cf03cd10$var$handleBodyCopyToggle();
    });
}
function $41f3be02cf03cd10$var$updateState() {
    $41f3be02cf03cd10$var$markAsLoading();
    $41f3be02cf03cd10$var$reloadQuery();
    const State = $41f3be02cf03cd10$var$History.getState();
    $.get("/car-co2-calculator/results", State.data, function(response) {
        $("#co2-calculator-results-container").replaceWith(response);
        $("html, body").animate({
            scrollTop: $("#co2-calculator-results-container").offset().top - 90
        }, 100);
        $41f3be02cf03cd10$var$loadAsDataTable();
        $41f3be02cf03cd10$var$applyResultsSortArrows();
        if ($41f3be02cf03cd10$var$reset) {
            $("[data-no-results]").hide();
            $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a car type or make above to start your search</div>");
            $41f3be02cf03cd10$var$reset = false;
        }
    });
}
function $41f3be02cf03cd10$export$d1979b506d91f67d() {
    const page = $("[data-co2-calculator]").length;
    if (!page) return;
    const currentUrl = window.location.href;
    $41f3be02cf03cd10$var$setManufacturer(currentUrl);
    $41f3be02cf03cd10$var$setCarType(currentUrl);
    $41f3be02cf03cd10$var$setModel(currentUrl);
    $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a car type or make above to start your search</div>");
    $("[data-no-results]").hide();
    $41f3be02cf03cd10$var$loadAsDataTable();
    $(document).on("click", "[data-view-detail]", $41f3be02cf03cd10$var$showHideDetail);
    $(document).on("keypress", "[data-digits-only]", $41f3be02cf03cd10$var$checkIsDigitsOnly);
    $(document).on("change", "[data-co2-calculator] input, [data-co2-calculator] select", $41f3be02cf03cd10$var$onChangeFilters);
    $(document).on("keypress", "[data-co2-calculator] input", function(e) {
        if (e.keyCode === 13) {
            $41f3be02cf03cd10$var$onChangeFilters();
            return false;
        }
    });
    $(document).on("click", "[data-derivative]", function(e) {
        e.preventDefault();
        $(this).parents("tr").find("[data-view-detail]").trigger("click");
    });
    $(document).on("click", "[data-fuel-type] a", $41f3be02cf03cd10$var$updateFuelTypes);
    $(document).on("click", "#co2-calculator-results-container .pagination a", $41f3be02cf03cd10$var$pageData);
    $41f3be02cf03cd10$var$applyResultsSortArrows();
    $(document).on("click", "[data-co2-sort]", $41f3be02cf03cd10$var$sortResults);
    $(document).on("click", "[data-reset-button]", function(event) {
        event.preventDefault();
        $41f3be02cf03cd10$var$History.pushState({}, $("title").html(), location.pathname);
        $41f3be02cf03cd10$var$reset = true;
    });
    window.updateCarCO2Results = function() {
        $41f3be02cf03cd10$var$updateResultsLogic(1);
    };
    $41f3be02cf03cd10$var$History.Adapter.bind(window, "statechange", $41f3be02cf03cd10$var$updateState);
}


function $c80792d02f0f6a54$export$f80078829203ea32() {
    var startState = $("[name='Input.IsFleetDecisionMaker']:checked").val();
    if (startState == "true") $("[data-fleet-options]").show();
    else $("[data-fleet-options]").hide();
    $(function() {
        $("[name='Input.IsFleetDecisionMaker']").click(function() {
            if ($(this).is(":checked")) $("[data-fleet-options]").show();
            else $("[data-fleet-options]").hide();
        });
    });
}


function $6d5c05cfba139cb5$var$changeManufacturer() {
    var manufacturerName = $("#ManufacturerId").val();
    $.get("/vans/landing-page/query?ManufacturerName=" + manufacturerName, function(response) {
        $("[data-van-landing-page-query]").replaceWith(response);
    });
//window.location = $("#ManufacturerId").val();
}
function $6d5c05cfba139cb5$var$changeModel() {
    var modelName = $("#ModelId").val();
    $("#ModelName").val(modelName);
}
function $6d5c05cfba139cb5$export$561d62cccb15fe01() {
    if ($("[data-vans-landing-page]").length) {
        $(document).on("change", "#ManufacturerId", $6d5c05cfba139cb5$var$changeManufacturer);
        $(document).on("change", "#ModelId", $6d5c05cfba139cb5$var$changeModel);
    }
}


function $f673f4e358290dfb$var$onChangeFilters(event) {
    const costValue = $(this).val();
    if (costValue === "4") {
        $(".threeyear").hide();
        $(".fouryear").show();
    } else {
        $(".threeyear").show();
        $(".fouryear").hide();
    }
}
function $f673f4e358290dfb$export$ed89fd68baaffc46() {
    //dropdown changes
    $(document).on("change", "[data-running-costs-dropdown]", $f673f4e358290dfb$var$onChangeFilters);
}


const $94ae081d16a9769f$var$history = window.History;
function $94ae081d16a9769f$var$buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data, function(value, key) {
        if (key === "isPageChange") return;
        if (value) queryStringData[key] = value;
    });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}
function $94ae081d16a9769f$var$getData() {
    const dataArray = $("[data-fuel-cost-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function(item) {
        if (data[item.name]) {
            if (typeof data[item.name] === "string") data[item.name] = [
                data[item.name]
            ];
            data[item.name].push(item.value);
        } else data[item.name] = item.value;
    });
    return data;
}
function $94ae081d16a9769f$var$updateResultsLogic(isPageChange) {
    const data = $94ae081d16a9769f$var$getData();
    if (isPageChange) data.isPageChange = true;
    $94ae081d16a9769f$var$history.pushState(data, $("title").html(), location.pathname + "?" + $94ae081d16a9769f$var$buildUpQueryString(data));
    return data;
}
function $94ae081d16a9769f$var$triggerUpdateResults(event) {
    const mpg = $("#Mpg");
    const currentMpg = mpg.val();
    if ($(event.target).data("autocomplete") != null) return;
    if (event.target.name === "FuelType") $("#PencePerLitre").val("");
    if (event.target.name === "Mileage") {
        if (currentMpg === "") return;
    }
    const derivativeId = $("#DerivativeId");
    if (event.target.name === "ManufacturerId") {
        if (currentMpg !== "") mpg.val("");
        const modelGroupId = $("#ModelGroupId");
        if (modelGroupId.val() != null) {
            modelGroupId.val("");
            derivativeId.val("");
        }
    }
    if (event.target.name === "ModelGroupId") {
        if (currentMpg !== "") mpg.val("");
        if (derivativeId.val() != null) derivativeId.val("");
    }
    window.updateVanFuelCostCalculator();
}
function $94ae081d16a9769f$var$calculateExtraMpg(event) {
    event.preventDefault();
    const mpg = $("#Mpg");
    const currentMpg = parseFloat(mpg.val());
    mpg.val(currentMpg + 5);
    window.updateVanFuelCostCalculator();
}
//function calculateExtra1P(event) {
//    event.preventDefault();
//    var currentPrice = parseFloat($("#PencePerLitre").val());;
//    $("#PencePerLitre").val(currentPrice + 1);
//    window.updateResults();
//}
function $94ae081d16a9769f$var$calculateExtra3P(event) {
    event.preventDefault();
    const pencePerLitre = $("#PencePerLitre");
    const currentPrice = parseFloat(pencePerLitre.val());
    pencePerLitre.val(currentPrice + 3);
    window.updateVanFuelCostCalculator();
}
function $94ae081d16a9769f$var$scrollToResult(event) {
    const penceperlitre = $("#PencePerLitre").val();
    const mileage = $("#Mileage").val();
    const mpg = $("#Mpg").val();
    let headerHeight = 300;
    if (window.isViewportLessThan("md")) headerHeight = 120;
    if (penceperlitre !== "" && mileage !== "" && mpg !== "") $("html, body").animate({
        scrollTop: $("[data-fuel-cost-results-container]").offset().top - headerHeight
    }, 2000);
    if (penceperlitre !== "" && mileage !== "" && mpg === "") {
        $("[data-mpg-message]").append("<div class='alert alert-danger margin-bottom-15'>Please enter mpg or choose the make, model and version for us to find it for you.</div>");
        $("html, body").animate({
            scrollTop: $("[data-mpg-section]").offset().top - headerHeight
        }, 2000);
    }
}
function $94ae081d16a9769f$var$reloadQuery() {
    const state = $94ae081d16a9769f$var$history.getState();
    $.get("/diesel-cost-calculator/query", state.data, function(response) {
        $("[data-fuel-cost-query-attributes]").replaceWith(response);
    });
}
function $94ae081d16a9769f$var$updateState() {
    $94ae081d16a9769f$var$reloadQuery();
    const state = $94ae081d16a9769f$var$history.getState();
    $.get("/diesel-cost-calculator/results", state.data, function(response) {
        $("[data-fuel-cost-results-container]").replaceWith(response);
        if (response.indexOf("fuel-cost-calculator-result") !== -1) {
            let headerHeight = 300;
            if (window.isViewportLessThan("md")) headerHeight = 120;
            $("html, body").animate({
                scrollTop: $("[data-fuel-cost-results-container]").offset().top - headerHeight
            }, 2000);
        }
    });
}
function $94ae081d16a9769f$export$922c8c7f19660105() {
    if (!$("[data-diesel-cost-calculator]").length) return;
    $(document).on("change", "[data-fuel-cost-query-attributes] input, [data-fuel-cost-query-attributes] select", $94ae081d16a9769f$var$triggerUpdateResults);
    $(document).on("click", "[data-recalculate-extra-mpg]", $94ae081d16a9769f$var$calculateExtraMpg);
    //$(document).on("click", "[data-recalculate-extra-1p]", calculateExtra1P);
    $(document).on("click", "[data-recalculate-extra-3p]", $94ae081d16a9769f$var$calculateExtra3P);
    $(document).on("click", "[data-view-result-button]", $94ae081d16a9769f$var$scrollToResult);
    // Bind to StateChange Event
    $94ae081d16a9769f$var$history.Adapter.bind(window, "statechange", $94ae081d16a9769f$var$updateState);
    window.updateVanFuelCostCalculator = function() {
        $94ae081d16a9769f$var$updateResultsLogic();
    };
}


var $67f53fcf4925a3cd$var$googleChartsLoaded = false;
function $67f53fcf4925a3cd$var$loadGoogleCharts() {
    return new Promise((resolve)=>{
        google.charts.load("current", {
            "packages": [
                "corechart"
            ]
        });
        google.charts.setOnLoadCallback(function() {
            $67f53fcf4925a3cd$var$googleChartsLoaded = true;
            resolve();
        });
    });
}
const $67f53fcf4925a3cd$var$NewVehicles = {
    history: window.History,
    buildUpQueryString: function(nv_data) {
        const queryStringData = {};
        $.map(nv_data, function(value, key) {
            if (key === "isPageChange") return;
            if (value) queryStringData[key] = value;
        });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getData: function() {
        const dataArray = $("[data-one-link-new-vehicles-query-attributes] :input").serializeArray();
        const data = {};
        dataArray.map(function(item) {
            if (data[item.name]) {
                if (typeof data[item.name] === "string") data[item.name] = [
                    data[item.name]
                ];
                data[item.name].push(item.value);
            } else data[item.name] = item.value;
        });
        // Get the active tab
        var tabValue = $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").filter(".active").attr("id");
        // Add the active tab to the data
        data.tab = tabValue;
        data.FuelType = $("#FuelType").val() || null;
        return data;
    },
    updateResultsLogic: function(isPageChange) {
        const self = this;
        const data = self.getData();
        if (isPageChange) data.isPageChange = true;
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    reloadQuery: function() {
        const self = this;
        const state = self.history.getState();
        $.get("/one-link-new-vehicles/query", state.data, function(response) {
            $("[data-one-link-new-vehicles-query-attributes]").replaceWith(response);
        });
    },
    reloadTable: function(state) {
        const self = this;
        $.get("/one-link-new-vehicles/table-results", state.data, function(response) {
            $("[data-one-link-new-vehicles-table-results]").replaceWith(response);
        });
    },
    getChartData: function(state) {
        const self = this;
        $.get("/one-link-new-vehicles/get-chart-data", state.data, function(response) {
            console.log("Inside getChartData of NewVehicles");
            console.log("new vehicles: " + response);
            self.drawChartForMonths(state.data.tab, response);
        });
    },
    updateState: function() {
        const self = this;
        self.reloadQuery();
        const state = self.history.getState();
        $.get("/one-link-new-vehicles/table-results", state.data, function(response) {
            $("[data-one-link-new-vehicles-table-results]").replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    drawChartForMonths: function(tab, rawDataNewVehicles) {
        console.log("chart loaded: " + $67f53fcf4925a3cd$var$googleChartsLoaded);
        if ($67f53fcf4925a3cd$var$googleChartsLoaded) {
            if ($("#" + tab).hasClass("active")) {
                const self = this;
                var newVehiclesChartId = "curve_chart-" + tab;
                self.drawChart(newVehiclesChartId, rawDataNewVehicles);
            }
        } else // Set a timeout or some other method to wait until googleChartsLoaded becomes true
        setTimeout(()=>this.drawChartForMonths(tab, rawDataNewVehicles), 1000);
    },
    getParameterByName: function(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    drawChart: function(newVehiclesChartId, rawDataNewVehicles) {
        const self = this;
        var columnNames = [
            "Month",
            "Electric %",
            "Hybrid %",
            "Petrol %",
            "Diesel %"
        ];
        var selectedFuelType = (self.getParameterByName("FuelType") || "all").toLowerCase();
        if (selectedFuelType !== "all") {
            var fuelTypes = [
                "electric",
                "hybrid",
                "petrol",
                "diesel"
            ];
            var index = fuelTypes.indexOf(selectedFuelType);
            columnNames = [
                "Month",
                columnNames[index + 1]
            ];
        }
        var newVehiclesChartData = [
            columnNames
        ];
        for(var i = 0; i < rawDataNewVehicles.length; i++){
            var dateParts = rawDataNewVehicles[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = {
                Jan: 0,
                Feb: 1,
                Mar: 2,
                Apr: 3,
                May: 4,
                Jun: 5,
                Jul: 6,
                Aug: 7,
                Sep: 8,
                Oct: 9,
                Nov: 10,
                Dec: 11
            };
            var month = monthMapping[dateParts[0]];
            var fuelTypeMapping = {
                "electric": "ev",
                "hybrid": "hyb",
                "petrol": "petrol",
                "diesel": "diesel"
            };
            if (selectedFuelType === "all") newVehiclesChartData.push([
                new Date(year, month),
                rawDataNewVehicles[i].evPercentage ? parseFloat(rawDataNewVehicles[i].evPercentage.toFixed(2)) : null,
                rawDataNewVehicles[i].hybPercentage ? parseFloat(rawDataNewVehicles[i].hybPercentage.toFixed(2)) : null,
                rawDataNewVehicles[i].petrolPercentage ? parseFloat(rawDataNewVehicles[i].petrolPercentage.toFixed(2)) : null,
                rawDataNewVehicles[i].dieselPercentage ? parseFloat(rawDataNewVehicles[i].dieselPercentage.toFixed(2)) : null
            ]);
            else if (rawDataNewVehicles[i].hasOwnProperty(fuelTypeMapping[selectedFuelType] + "Percentage")) newVehiclesChartData.push([
                new Date(year, month),
                rawDataNewVehicles[i][fuelTypeMapping[selectedFuelType] + "Percentage"] ? parseFloat(rawDataNewVehicles[i][fuelTypeMapping[selectedFuelType] + "Percentage"].toFixed(2)) : null
            ]);
        }
        var newVehiclesData = google.visualization.arrayToDataTable(newVehiclesChartData);
        var options = {
            curveType: "none",
            vAxis: {
                format: "#'%'"
            },
            hAxis: {
                format: "MMM yyyy",
                ticks: newVehiclesData.getNumberOfRows() ? newVehiclesData.getDistinctValues(0) : []
            },
            legend: {
                position: "top",
                alignment: "start"
            },
            series: {
                0: {
                    lineWidth: 1,
                    pointSize: 5
                },
                1: {
                    lineWidth: 1,
                    pointSize: 5
                },
                2: {
                    lineWidth: 1,
                    pointSize: 5
                },
                3: {
                    lineWidth: 1,
                    pointSize: 5
                }
            },
            chartArea: {
                left: "5%",
                right: "5%",
                top: "10%",
                width: "100%",
                height: "82%"
            }
        };
        var newVehiclesChartDiv = document.getElementById(newVehiclesChartId);
        if (newVehiclesChartDiv) {
            // Create a chart instance
            var newVehiclesChart = new google.visualization.LineChart(newVehiclesChartDiv);
            // Clear the chart
            newVehiclesChart.clearChart();
            // Draw the chart with options and data.
            newVehiclesChart.draw(newVehiclesData, options);
        }
    },
    setupOneLinkNewVehicles: function() {
        const self = this;
        const FuelType = self.getParameterByName("FuelType");
        $(document).on("change", "[data-one-link-new-vehicles-query-attributes] input, [data-one-link-new-vehicles-query-attributes] select", function() {
            self.updateResultsLogic();
        });
        $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").on("click", function(e) {
            // Stop the browser from following the link
            e.preventDefault();
            // Show the tab
            $(this).tab("show");
            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set("tab", $(this).attr("id"));
            window.history.replaceState({}, "", url);
        });
        // Pass FuelType and VehicleType to getChartData
        self.getChartData({
            data: {
                tab: "new-vehicles-tab1",
                FuelType: FuelType
            }
        });
        History.Adapter.bind(window, "statechange", function() {
            self.updateState();
        });
        window.updateResults = function() {
            self.updateResultsLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get("tab");
        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) $("#" + tab).tab("show");
        else {
            tab = "new-vehicles-tab1";
            $("#" + tab).tab("show");
        }
        $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").on("shown.bs.tab", function(e) {
            const tab = $(this).attr("id");
            // Only fetch the chart data and reload the table after the tab has been shown
            if ($("#" + tab).hasClass("active")) {
                const state = {
                    data: {
                        tab: tab,
                        FuelType: self.getParameterByName("FuelType")
                    }
                }; // Fetch FuelType from the URL
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });
        $("#" + tab).tab("show"); // <-- Move here
        // Explicitly call getChartData and reloadTable for the initial tab
        const state = {
            data: {
                tab: tab,
                FuelType: self.getParameterByName("FuelType")
            }
        }; // Fetch FuelType from the URL
        self.getChartData(state);
        self.reloadTable(state); // Update to pass full state
        google.charts.load("current", {
            "packages": [
                "corechart"
            ]
        });
    }
};
// average lead times
const $67f53fcf4925a3cd$var$AverageLeadTimes = {
    history: window.History,
    buildUpQueryString: function(alt_data) {
        const queryStringData = {};
        $.map(alt_data, function(value, key) {
            if (key === "isPageChange") return;
            if (value) queryStringData[key] = value;
        });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAverageLeadTimesData: function() {
        // Get the active tab
        var tabValue = $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").filter(".active").attr("id");
        // Return a data object with the active tab
        return {
            tab: tabValue
        };
    },
    updateResultsAverageLeadTimesLogic: function(isPageChange) {
        const self = this;
        const data = self.getAverageLeadTimesData();
        if (isPageChange) data.isPageChange = true;
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function(state) {
        const self = this;
        $.get("/one-link-average-lead-times/get-chart-data", state.data, function(response) {
            self.drawAverageLeadTimesChartForMonths(state.data.tab, response);
        });
    },
    updateAverageLeadTimeState: function() {
        const self = this;
        const state = self.history.getState();
        $.get("/one-link-average-lead-times/table-results", state.data, function(response) {
            $("[data-one-link-average-lead-times-table-results]").replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    reloadTable: function(state) {
        const self = this;
        $.get("/one-link-average-lead-times/table-results", state.data, function(response) {
            $("[data-one-link-average-lead-times-table-results]").replaceWith(response);
        });
    },
    drawAverageLeadTimesChartForMonths: function(tab, rawData) {
        if ($67f53fcf4925a3cd$var$googleChartsLoaded) {
            if ($("#" + tab).hasClass("active")) {
                const self = this;
                var chartId = "curve_chart-" + tab;
                self.drawAverageLeadTimesChart(chartId, rawData);
            }
        } else setTimeout(()=>this.drawAverageLeadTimesChartForMonths(tab, rawData), 1000);
    },
    getParameterByName: function(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    drawAverageLeadTimesChart: function(chartId, rawData) {
        var columnNames = [
            "Month",
            "Lead time (days)"
        ];
        var chartData = [
            columnNames
        ];
        for(var i = 0; i < rawData.length; i++){
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = {
                Jan: 0,
                Feb: 1,
                Mar: 2,
                Apr: 3,
                May: 4,
                Jun: 5,
                Jul: 6,
                Aug: 7,
                Sep: 8,
                Oct: 9,
                Nov: 10,
                Dec: 11
            };
            var month = monthMapping[dateParts[0]];
            var leadTime = rawData[i].averageLeadTime ? parseFloat(rawData[i].averageLeadTime.toFixed(2)) : null;
            chartData.push([
                new Date(year, month),
                leadTime
            ]); // Add lead time data
        }
        var data = google.visualization.arrayToDataTable(chartData);
        var options = {
            curveType: "none",
            vAxis: {
                format: "#' day(s)'"
            },
            hAxis: {
                format: "MMM yyyy",
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : [] // return distinct values from the first column (0 index) of the data
            },
            legend: {
                position: "top",
                alignment: "start"
            },
            series: {
                0: {
                    lineWidth: 1,
                    pointSize: 5
                },
                1: {
                    lineWidth: 1,
                    pointSize: 5
                },
                2: {
                    lineWidth: 1,
                    pointSize: 5
                },
                3: {
                    lineWidth: 1,
                    pointSize: 5
                }
            },
            chartArea: {
                left: "7%",
                right: "5%",
                top: "10%",
                width: "100%",
                height: "82%"
            }
        };
        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            // Create a chart instance
            var chart = new google.visualization.LineChart(chartDiv);
            // Clear the chart
            chart.clearChart();
            // Draw the chart with options and data.
            chart.draw(data, options);
        }
    },
    setupOneLinkAverageLeadTimes: function() {
        const self = this;
        $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").on("click", function(e) {
            // Stop the browser from following the link
            e.preventDefault();
            // Show the tab
            $(this).tab("show");
            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set("tab", $(this).attr("id"));
            window.history.replaceState({}, "", url);
        });
        self.getChartData({
            data: {
                tab: "average-lead-times-tab1"
            }
        });
        History.Adapter.bind(window, "statechange", self.updateAverageLeadTimeState());
        window.updateResults = function() {
            self.updateResultsAverageLeadTimesLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get("tab") || "average-lead-times-tab1";
        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) $("#" + tab).tab("show");
        else {
            tab = "average-lead-times-tab1";
            $("#" + tab).tab("show");
        }
        $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").on("shown.bs.tab", function(e) {
            const tab = $(this).attr("id");
            // Only fetch the chart data after the tab has been shown
            if ($("#" + tab).hasClass("active")) {
                const state = {
                    data: {
                        tab: tab
                    }
                };
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });
        $("#" + tab).tab("show");
        const state = {
            data: {
                tab: tab
            }
        };
        self.getChartData(state);
        setTimeout(function() {
            self.reloadTable(state);
        }, 200); // delay of 200ms
        google.charts.load("current", {
            "packages": [
                "corechart"
            ]
        });
    }
};
// Average age of fleet
const $67f53fcf4925a3cd$var$AverageAgeOfFleet = {
    history: window.History,
    buildUpQueryString: function(nv_data) {
        const queryStringData = {};
        $.map(nv_data, function(value, key) {
            if (key === "isPageChange") return;
            if (value) queryStringData[key] = value;
        });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAverageAgeOfFleetData: function() {
        const dataArray = $("[data-one-link-average-age-of-fleet-query-attributes] :input").serializeArray();
        const data = {};
        dataArray.map(function(item) {
            if (data[item.name]) {
                if (typeof data[item.name] === "string") data[item.name] = [
                    data[item.name]
                ];
                data[item.name].push(item.value);
            } else data[item.name] = item.value;
        });
        // Get the active tab
        var tabValue = $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").filter(".active").attr("id");
        // Add the active tab to the data
        data.tab = tabValue;
        data.VehicleType = $("#VehicleType").val() || null;
        return data;
    },
    updateResultsAverageAgeOfFleetLogic: function(isPageChange) {
        const self = this;
        const data = self.getAverageAgeOfFleetData();
        if (isPageChange) data.isPageChange = true;
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    reloadQuery: function() {
        const self = this;
        const state = self.history.getState();
        $.get("/one-link-average-age-of-fleet-entering-workshop/query", state.data, function(response) {
            $("[data-one-link-average-age-of-fleet-query-attributes]").replaceWith(response);
        });
    },
    reloadTable: function(state) {
        const self = this;
        $.get("/one-link-average-age-of-fleet-entering-workshop/table-results", state.data, function(response) {
            $("[data-one-link-average-age-of-fleet-table-results]").replaceWith(response);
        });
    },
    getAverageAgeOfFleetChartData: function(state) {
        const self = this;
        $.get("/one-link-average-age-of-fleet-entering-workshop/get-chart-data", state.data, function(response) {
            console.log("Inside getAverageAgeOfFleetChartData of AverageAgeOfFleet");
            console.log("age: " + response);
            self.drawAverageAgeOfFleetChartForMonths(state.data.tab, response);
        });
    },
    updateAverageAgeOfFleetState: function() {
        const self = this;
        self.reloadQuery();
        const state = self.history.getState();
        $.get("/one-link-average-age-of-fleet-entering-workshop/table-results", state.data, function(response) {
            $("[data-one-link-average-age-of-fleet-table-results]").replaceWith(response);
        });
        self.getAverageAgeOfFleetChartData(self.history.getState());
    },
    drawAverageAgeOfFleetChartForMonths: function(tab, drawAverageAgeOfFleetChart) {
        if ($67f53fcf4925a3cd$var$googleChartsLoaded) {
            if ($("#" + tab).hasClass("active")) {
                const self = this;
                var ageOfFleetChartId = "curve_chart-" + tab;
                self.drawAverageAgeOfFleetChart(ageOfFleetChartId, drawAverageAgeOfFleetChart);
            }
        } else setTimeout(()=>this.drawAverageAgeOfFleetChartForMonths(tab, drawAverageAgeOfFleetChart), 1000);
    },
    getParameterByName: function(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    drawAverageAgeOfFleetChart: function(ageOfFleetChartId, rawDataAverageAgeOfFleet) {
        const self = this;
        var columnNames = [
            "Month",
            "Cars (years)",
            "Vans (years)"
        ];
        var selectedVehicleType = (self.getParameterByName("VehicleType") || "all").toLowerCase();
        if (selectedVehicleType !== "all") {
            var vehicleTypes = [
                "cars",
                "vans"
            ];
            var index = vehicleTypes.indexOf(selectedVehicleType);
            columnNames = [
                "Month",
                columnNames[index + 1]
            ];
        }
        var chartData = [
            columnNames
        ];
        for(var i = 0; i < rawDataAverageAgeOfFleet.length; i++){
            var dateParts = rawDataAverageAgeOfFleet[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = {
                Jan: 0,
                Feb: 1,
                Mar: 2,
                Apr: 3,
                May: 4,
                Jun: 5,
                Jul: 6,
                Aug: 7,
                Sep: 8,
                Oct: 9,
                Nov: 10,
                Dec: 11
            };
            var month = monthMapping[dateParts[0]];
            var vehicleTypeMapping = {
                "cars": "averageCarAge",
                "vans": "averageVanAge"
            };
            if (selectedVehicleType === "all") chartData.push([
                new Date(year, month),
                rawDataAverageAgeOfFleet[i].averageCarAge ? parseFloat(rawDataAverageAgeOfFleet[i].averageCarAge.toFixed(2)) : null,
                rawDataAverageAgeOfFleet[i].averageVanAge ? parseFloat(rawDataAverageAgeOfFleet[i].averageVanAge.toFixed(2)) : null
            ]);
            else if (rawDataAverageAgeOfFleet[i].hasOwnProperty(vehicleTypeMapping[selectedVehicleType])) chartData.push([
                new Date(year, month),
                rawDataAverageAgeOfFleet[i][vehicleTypeMapping[selectedVehicleType]] ? parseFloat(rawDataAverageAgeOfFleet[i][vehicleTypeMapping[selectedVehicleType]].toFixed(2)) : null
            ]);
        }
        var data = google.visualization.arrayToDataTable(chartData);
        var options = {
            curveType: "none",
            vAxis: {
                format: "#' year(s)'"
            },
            hAxis: {
                format: "MMM yyyy",
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: "top",
                alignment: "start"
            },
            series: {
                0: {
                    lineWidth: 1,
                    pointSize: 5
                },
                1: {
                    lineWidth: 1,
                    pointSize: 5
                },
                2: {
                    lineWidth: 1,
                    pointSize: 5
                },
                3: {
                    lineWidth: 1,
                    pointSize: 5
                }
            },
            chartArea: {
                left: "7%",
                right: "5%",
                top: "10%",
                width: "100%",
                height: "82%"
            }
        };
        var ageOfFleetChartDiv = document.getElementById(ageOfFleetChartId);
        if (ageOfFleetChartDiv) {
            // Create a chart instance
            var ageOfFleetChart = new google.visualization.LineChart(ageOfFleetChartDiv);
            // Clear the chart
            ageOfFleetChart.clearChart();
            // Draw the chart with options and data.
            ageOfFleetChart.draw(data, options);
        }
    },
    setupOneLinkAverageAgeOfFleet: function() {
        const self = this;
        const VehicleType = self.getParameterByName("VehicleType");
        $(document).on("change", "[data-one-link-average-age-of-fleet-query-attributes] input, [data-one-link-average-age-of-fleet-query-attributes] select", ()=>self.updateResultsAverageAgeOfFleetLogic());
        $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").on("click", function(e) {
            // Stop the browser from following the link
            e.preventDefault();
            // Show the tab
            $(this).tab("show");
            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set("tab", $(this).attr("id"));
            window.history.replaceState({}, "", url);
        });
        self.getAverageAgeOfFleetChartData({
            data: {
                tab: "average-age-of-fleet-tab1"
            },
            VehicleType: VehicleType
        });
        History.Adapter.bind(window, "statechange", ()=>self.updateAverageAgeOfFleetState());
        window.updateResults = function() {
            self.updateResultsAverageAgeOfFleetLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get("tab");
        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) $("#" + tab).tab("show");
        else {
            tab = "average-age-of-fleet-tab1";
            $("#" + tab).tab("show");
        }
        $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").on("shown.bs.tab", function(e) {
            const tab = $(this).attr("id");
            // Only fetch the chart data after the tab has been shown
            if ($("#" + tab).hasClass("active")) {
                const state = {
                    data: {
                        tab: tab,
                        VehicleType: self.getParameterByName("VehicleType")
                    }
                }; // Fetch FuelType from the URL
                self.getAverageAgeOfFleetChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });
        $("#" + tab).tab("show");
        // Explicitly call getChartData and reloadTable for the initial tab
        const state = {
            data: {
                tab: tab,
                VehicleType: self.getParameterByName("VehicleType")
            }
        }; // Fetch FuelType from the URL
        self.getAverageAgeOfFleetChartData(state);
        self.reloadTable(state); // Update to pass full state
        google.charts.load("current", {
            "packages": [
                "corechart"
            ]
        });
    }
};
// average fleet vehicle downtime
const $67f53fcf4925a3cd$var$AverageFleetVehicleDowntime = {
    history: window.History,
    buildUpQueryString: function(alt_data) {
        const queryStringData = {};
        $.map(alt_data, function(value, key) {
            if (key === "isPageChange") return;
            if (value) queryStringData[key] = value;
        });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAverageFleetVehicleDowntimeData: function() {
        // Get the active tab
        var tabValue = $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").filter(".active").attr("id");
        // Return a data object with the active tab
        return {
            tab: tabValue
        };
    },
    updateResultsAverageFleetVehicleDowntimeLogic: function(isPageChange) {
        const self = this;
        const data = self.getAverageFleetVehicleDowntimeData();
        if (isPageChange) data.isPageChange = true;
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function(state) {
        const self = this;
        $.get("/one-link-average-fleet-vehicle-downtime/get-chart-data", state.data, function(response) {
            self.drawAverageFleetVehicleDowntimeChartForMonths(state.data.tab, response);
        });
    },
    reloadTable: function(state) {
        const self = this;
        $.get("/one-link-average-fleet-vehicle-downtime/table-results", state.data, function(response) {
            $("[data-one-link-average-fleet-vehicle-downtime-table-results]").replaceWith(response);
        });
    },
    updateAverageFleetVehicleDowntimeState: function() {
        const self = this;
        const state = self.history.getState();
        $.get("/one-link-average-fleet-vehicle-downtime/table-results", state.data, function(response) {
            $("[data-one-link-average-fleet-vehicle-downtime-table-results]").replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    drawAverageFleetVehicleDowntimeChartForMonths: function(tab, rawData) {
        if ($67f53fcf4925a3cd$var$googleChartsLoaded) {
            if ($("#" + tab).hasClass("active")) {
                const self = this;
                var chartId = "curve_chart-" + tab;
                self.drawAverageFleetVehicleDowntimeChart(chartId, rawData);
            }
        } else setTimeout(()=>this.drawAverageFleetVehicleDowntimeChartForMonths(tab, rawData), 1000);
    },
    getParameterByName: function(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    drawAverageFleetVehicleDowntimeChart: function(chartId, rawData) {
        var columnNames = [
            "Month",
            "Avg days vehicle taken off road (days)"
        ];
        var chartData = [
            columnNames
        ];
        for(var i = 0; i < rawData.length; i++){
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = {
                Jan: 0,
                Feb: 1,
                Mar: 2,
                Apr: 3,
                May: 4,
                Jun: 5,
                Jul: 6,
                Aug: 7,
                Sep: 8,
                Oct: 9,
                Nov: 10,
                Dec: 11
            };
            var month = monthMapping[dateParts[0]];
            var vor = rawData[i].averageVOR ? parseFloat(rawData[i].averageVOR.toFixed(2)) : null;
            chartData.push([
                new Date(year, month),
                vor
            ]); // Add 
        }
        var data = google.visualization.arrayToDataTable(chartData);
        var options = {
            curveType: "none",
            vAxis: {
                minValue: 1.50,
                maxValue: 2.00,
                format: "#.00' day(s)'" // Added '.00' to display two decimal places
            },
            hAxis: {
                format: "MMM yyyy",
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: "top",
                alignment: "start"
            },
            series: {
                0: {
                    lineWidth: 1,
                    pointSize: 5
                },
                1: {
                    lineWidth: 1,
                    pointSize: 5
                },
                2: {
                    lineWidth: 1,
                    pointSize: 5
                },
                3: {
                    lineWidth: 1,
                    pointSize: 5
                }
            },
            chartArea: {
                left: "10%",
                right: "5%",
                top: "10%",
                width: "100%",
                height: "82%"
            }
        };
        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            // Create a chart instance
            var chart = new google.visualization.LineChart(chartDiv);
            // Clear the chart
            chart.clearChart();
            // Draw the chart with options and data.
            chart.draw(data, options);
        }
    },
    setupOneLinkAverageFleetVehicleDowntime: function() {
        const self = this;
        $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").on("click", function(e) {
            // Stop the browser from following the link
            e.preventDefault();
            // Show the tab
            $(this).tab("show");
            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set("tab", $(this).attr("id"));
            window.history.replaceState({}, "", url);
        });
        self.getChartData({
            data: {
                tab: "average-fleet-vehicle-downtime-tab1"
            }
        });
        History.Adapter.bind(window, "statechange", self.updateAverageFleetVehicleDowntimeState());
        window.updateResults = function() {
            self.updateResultsAverageFleetVehicleDowntimeLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get("tab") || "average-fleet-vehicle-downtime-tab1";
        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) $("#" + tab).tab("show");
        else {
            tab = "average-fleet-vehicle-downtime-tab1";
            $("#" + tab).tab("show");
        }
        $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").on("shown.bs.tab", function(e) {
            const tab = $(this).attr("id");
            // Only fetch the chart data after the tab has been shown
            if ($("#" + tab).hasClass("active")) {
                const state = {
                    data: {
                        tab: tab
                    }
                };
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });
        $("#" + tab).tab("show"); // <-- Move here
        const state = {
            data: {
                tab: tab
            }
        };
        self.getChartData(state);
        setTimeout(function() {
            self.reloadTable(state);
        }, 200); // delay of 200ms
        google.charts.load("current", {
            "packages": [
                "corechart"
            ]
        });
    }
};
// Main entry point
$(function() {
    $67f53fcf4925a3cd$var$loadGoogleCharts().then(()=>{
        const pageType = $("#PageType").val(); // Get the value of hidden field
        if (pageType === "OneLinkNewVehicles") $67f53fcf4925a3cd$var$NewVehicles.setupOneLinkNewVehicles();
        else if (pageType === "OneLinkAverageVehicleWorkshopLeadTime") $67f53fcf4925a3cd$var$AverageLeadTimes.setupOneLinkAverageLeadTimes();
        else if (pageType === "OneLinkAverageAgeOfFleetEnteringWorkshop") $67f53fcf4925a3cd$var$AverageAgeOfFleet.setupOneLinkAverageAgeOfFleet();
        else if (pageType === "OneLinkAverageFleetVehicleDowntime") $67f53fcf4925a3cd$var$AverageFleetVehicleDowntime.setupOneLinkAverageFleetVehicleDowntime();
    });
});
$(window).resize(function() {
    const pageType = $("#PageType").val();
    if (pageType === "OneLinkNewVehicles") {
        const activeTab = $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").filter(".active").attr("id");
        $67f53fcf4925a3cd$var$NewVehicles.getChartData({
            data: {
                tab: activeTab
            }
        });
    } else if (pageType === "OneLinkAverageVehicleWorkshopLeadTime") {
        const activeTab = $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").filter(".active").attr("id");
        $67f53fcf4925a3cd$var$AverageLeadTimes.getChartData({
            data: {
                tab: activeTab
            }
        });
    } else if (pageType === "OneLinkAverageAgeOfFleetEnteringWorkshop") {
        const activeTab = $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").filter(".active").attr("id");
        $67f53fcf4925a3cd$var$AverageAgeOfFleet.getAverageAgeOfFleetChartData({
            data: {
                tab: activeTab
            }
        });
    } else if (pageType === "OneLinkAverageFleetVehicleDowntime") {
        const activeTab = $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").filter(".active").attr("id");
        $67f53fcf4925a3cd$var$AverageFleetVehicleDowntime.getChartData({
            data: {
                tab: activeTab
            }
        });
    }
});
function $67f53fcf4925a3cd$export$2fc82e8c97ef8c9() {
    $67f53fcf4925a3cd$var$NewVehicles.setupOneLinkNewVehicles();
}
function $67f53fcf4925a3cd$export$a2019de311dd36b1() {
    $67f53fcf4925a3cd$var$AverageLeadTimes.setupOneLinkAverageLeadTimes();
}
function $67f53fcf4925a3cd$export$fdfdd5222f7281c9() {
    $67f53fcf4925a3cd$var$AverageAgeOfFleet.setupOneLinkAverageAgeOfFleet();
}
function $67f53fcf4925a3cd$export$ef7c49e4953bcf45() {
    $67f53fcf4925a3cd$var$AverageFleetVehicleDowntime.setupOneLinkAverageFleetVehicleDowntime();
}


(0, $2892d4b3a4bd7b1c$export$5d0cc2edc113f064)();
function $cbbf978695a69611$var$needsGoogleCharts() {
    const pageType = $("#PageType").val();
    const chartPages = [
        "OneLinkNewVehicles",
        "OneLinkAverageVehicleWorkshopLeadTime",
        "OneLinkAverageAgeOfFleetEnteringWorkshop",
        "OneLinkAverageFleetVehicleDowntime"
    ];
    return chartPages.includes(pageType);
}
$(()=>{
    //Ignore datatable alert messages (errors)
    $.fn.dataTable.ext.errMode = "none";
    (0, $c80792d02f0f6a54$export$f80078829203ea32)();
    (0, $6ba8f3756a604e1e$export$a391e9e11dfa825a)();
    (0, $02ccdfd5868f53aa$export$b2bb814f390b8ca1)();
    (0, $41f3be02cf03cd10$export$d1979b506d91f67d)();
    (0, $c26879fdf7f36150$export$a6a4a29a790aae85)();
    (0, $0931948934220f52$export$30c8b39afd1a4d2b)();
    (0, $06aa7a5ca72b8734$export$4480b153ba60206d)();
    (0, $c0e2aeb39b8be769$export$d0990ca26e3a22f3)();
    (0, $593cd257706de00c$export$53c248b281253aba)();
    (0, $728b06aeb66604b2$export$a09f327970c84284)();
    (0, $aca60e5b2e026969$export$ce72890db155540c)();
    (0, $94302a5ffb81bfa2$export$a364db890d354a0c)();
    (0, $d700ac7e948a3f2e$export$d9879cc485083cbe)();
    (0, $fee793ddf9b673e0$export$c95db721723386e7)();
    (0, $a14a535463e27110$export$2d8fba0164856121)();
    (0, $7ef9cb8dc2b7724c$export$55fbd5f0890cdf7e)();
    (0, $165cb073955e137a$export$94d83d887297dd2)();
    (0, $82264929ebb8a49e$export$10b45b794006d1d0)();
    (0, $4c3677df652e2937$export$7b633cd5cf57daa2)();
    (0, $3e663d5dbb36a26e$export$124a9858458e53dc)();
    (0, $9e13b2ad467bb145$export$54941c72d7452803)();
    (0, $a83f24934579ebaa$export$85500d64d8b96a12)();
    (0, $0223437a5c85c95b$export$b62efe4e2fbde874)();
    (0, $87b693ffb012c6f5$export$a7425bd496405417)();
    // setupFuelCostCalculator();
    // setupFuelTypeButtons();
    (0, $935dae51dafb9406$export$f0c7f3aad087f331)();
    (0, $1681bada7f12e93a$export$8ffecd3ecbf5a7bf)();
    (0, $1062b41150fcb383$export$2b2ccfd71dd67323)();
    (0, $99ad575d7443e4d6$export$7689f9df4f599197)();
    (0, $fe07b9887899a8fb$export$7c7fd016d0e808fe)();
    (0, $1e7dc984495afd55$export$536c895956e6bdad)();
    (0, $c4df93a4feca97f3$export$332cf1f44c0656c1)();
    (0, $a51221e90ccfb5f2$export$1254953e51e11fff)();
    (0, $3bc885c99072932d$export$e09e8541d6e6379b)();
    (0, $ff2e9cac1156f2ea$export$376e40bec80c21a)();
    (0, $a8340321fe089932$export$ae69331b624aa7a)();
    (0, $86f87e45f0071f3a$export$6f277b52b642b4f9)();
    (0, $b9c76af634f3d75b$export$af46fff3f8bb6cb0)();
    (0, $cb041d180d1b1b5e$export$b16f720339b8b3cd)();
    (0, $29b334ac16b2381b$export$953e2b044b74bd66)();
    (0, $b0c1205ab438e8b5$export$abf0c736cc0404e4)();
    (0, $a45552c76e7ee752$export$b4ebbdbd9d8b89a1)();
    (0, $de5410f3f786fb03$export$ea92669c2bcde238)();
    (0, $631d9a7494b6c619$export$9ef30b34c240b3e6)();
    (0, $a44a9adb885e4949$export$5a34e6870ef2f82e)();
    (0, $57a44814a6005e07$export$29a95a623dfab103)();
    (0, $6d5c05cfba139cb5$export$561d62cccb15fe01)();
    (0, $f673f4e358290dfb$export$ed89fd68baaffc46)();
    (0, $94ae081d16a9769f$export$922c8c7f19660105)();
    if ($cbbf978695a69611$var$needsGoogleCharts()) {
        const pageType = $("#PageType").val(); // Get the value of hidden field
        if (pageType === "OneLinkNewVehicles") (0, $67f53fcf4925a3cd$export$2fc82e8c97ef8c9)();
        else if (pageType === "OneLinkAverageVehicleWorkshopLeadTime") setupOneLinkAverageLeadTimes();
        else if (pageType === "OneLinkAverageAgeOfFleetEnteringWorkshop") setupOneLinkAverageAgeOfFleet();
        else if (pageType === "OneLinkAverageFleetVehicleDowntime") setupOneLinkAverageFleetVehicleDowntime();
    }
    const qrCodeDataElement = document.getElementById("qrCodeData");
    if (qrCodeDataElement) {
        const uri = qrCodeDataElement.getAttribute("data-url");
        new QRCode(document.getElementById("qrCode"), {
            text: uri,
            width: 150,
            height: 150
        });
    }
});

})();
//# sourceMappingURL=fleet-news.js.map
